(function() {
    'use strict';
    var controllerId = 'pickpackListCtrl';

    angular.module('app').controller(controllerId, ['common', 'datacontext', 'NgTableParams','$scope','$modal', '$location', '$cookies',  pickpackListCtrl]);

    function pickpackListCtrl(common, datacontext, NgTableParams, $scope, $modal, $location, $cookies) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.last_list = $cookies.get('last_list');
        vm.cutoff_order_id = $cookies.get('cutoff_order_id');
        console.log(vm.last_list);
        vm.pending_item_cnt = 0;
        vm.list = [];
        vm.done = 0;
        vm.title = 'Pick Pack List View';

        vm.startSearch = 0;
        vm.store_products = [];
        vm.title = 'Product List View';

        vm.pickpack_user_status = $cookies.get('pickpack_user_status');
        if(vm.pickpack_user_status === '' || vm.pickpack_user_status === 'undefined' || vm.pickpack_user_status === undefined){
            vm.pickpack_user_status = 0;
        }

        console.log(vm.pickpack_user_status);

        vm.pickpack_user_sort_order = $cookies.get('pickpack_user_sort_order')
        if(vm.pickpack_user_sort_order === '' || vm.pickpack_user_sort_order === 'undefined' || vm.pickpack_user_sort_order === undefined){
            vm.pickpack_user_sort_order = 'pickpack_slip_id';
        }

        console.log(vm.pickpack_user_sort_order);

        vm.pickpack_user_sort_order_dir = $cookies.get('pickpack_user_sort_order_dir')
        if(vm.pickpack_user_sort_order_dir === '' || vm.pickpack_user_sort_order_dir === 'undefined' || vm.pickpack_user_sort_order_dir === undefined){
            vm.pickpack_user_sort_order_dir = 'desc';
        }

        // create empty structure for search items
        vm.query = {
            queryType:'array-count',
            search:'',
            pickpack_slip_id:'',
            pickpack_type_id:'106',
            pickpack_type_group_id:'',
            pickpack_status_id:vm.pickpack_user_status,
            order_by:vm.pickpack_user_sort_order,
            order_dir:vm.pickpack_user_sort_order_dir,
            page:1,
            limit:100
        };

        $scope.getNextPick = function () {
        	vm.query = {
                    queryType:'array-count',
                    search:'',
                    pickpack_slip_id:'',
                    pickpack_type_id:'106',
                    pickpack_type_group_id:'',
                    pickpack_status_id:1,
                    order_by:'pickpack_slip_id',
                    order_dir:'asc',
                    nextpick:1,
                    page:1,
                    limit:50
                };
        	get_pickpack_slips();
        }
        $scope.getNextPrint = function () {
        	vm.query = {
                    queryType:'array-count',
                    search:'',
                    pickpack_slip_id:'',
                    pickpack_type_id:'106',
                    pickpack_type_group_id:'',
                    pickpack_status_id:0,
                    order_by:'pickpack_slip_id',
                    order_dir:'asc',
                    nextprint:1,
                    page:1,
                    limit:50
                };
        	get_pickpack_slips();
        }

        $scope.getPickInPro = function () {
        	vm.query = {
                    queryType:'array-count',
                    search:'',
                    pickpack_slip_id:'',
                    pickpack_type_id:'',
                    pickpack_type_group_id:'',
                    pickpack_status_id:2,
                    order_by:'pickpack_slip_id',
                    order_dir:'asc',
                    nextpick:1,
                    page:1,
                    limit:50
                };
        	get_pickpack_slips();
        }
        $scope.getPackInPro = function () {
        	vm.query = {
                    queryType:'array-count',
                    search:'',
                    pickpack_slip_id:'',
                    pickpack_type_id:'',
                    pickpack_type_group_id:'',
                    pickpack_status_id:4,
                    order_by:'pickpack_slip_id',
                    order_dir:'asc',
                    nextpick:1,
                    page:1,
                    limit:50
                };
        	get_pickpack_slips();
        }

        $scope.primetoday = function () {
        	vm.query = {
                    queryType:'array-count',
                    search:'',
                    primetoday:'1',
                    pickpack_status_id:0,
                    pickpack_type_group_id:'',
                    order_by:'mp_ship_latest_by',
                    order_dir:'asc',
                    page:1,
                    today:'1',
                    limit:50
                };
        	get_pickpack_slips();
        }
        $scope.search = function (){
          console.log(vm.query);
          get_pickpack_slips();
        }
        $scope.onsitetoday = function () {
        	vm.query = {
                    queryType:'array-count',
                    search:'',
                    onsitetoday:'1',
                    pickpack_status_id:0,
                    pickpack_type_group_id:'',
                    order_by:'mp_ship_latest_by',
                    order_dir:'asc',
                    page:1,
                    today:'1',
                    limit:50
                };
        	get_pickpack_slips();
        }
        $scope.alltoday = function () {
        	vm.query = {
                    queryType:'array-count',
                    search:'',
                    pickpack_status_id:0,
                    pickpack_type_group_id:'',
                    order_by:'pickpack_slip_id',
                    order_dir:'desc',
                    today:'2',
                    page:1,
                    limit:50
                };
        	get_pickpack_slips();
        }
        $scope.podtoday = function () {
        	vm.query = {
                    queryType:'array-count',
                    search:'',
                    pickpack_status_id:0,
                    pickpack_type_group_id:'',
                    pod_today:1,
                    order_by:'pickpack_slip_id',
                    order_dir:'desc',
                    today:'3',
                    page:1,
                    limit:50
                };
        	get_pickpack_slips();
        }


        $scope.getNextPack = function () {
        	vm.query = {
                    queryType:'array-count',
                    search:'',
                    pickpack_slip_id:'',
                    pickpack_type_id:'106',
                    pickpack_status_id:3,
                    pickpack_type_group_id:'16',
                    order_by:'ifnull(pft.sort_priority,100)',
                    order_dir:'asc',
                    nextpick:1,
                    page:1,
                    limit:50
                };
        	get_pickpack_slips();
        }

        vm.urlQuery  = $location.search();
        vm.url_used = 0;

        // loop and set url var
        for (var i in vm.urlQuery) {
            // ignore query type in url
            if ( i !=='queryType') {
                vm.query[i] = vm.urlQuery[i];
            }
            //console.log("k", i);
            //console.log("v", vm.urlQuery[i]);
            vm.url_used = 1;
        }

        $scope.$watchCollection("vm.query",function (newValue, oldValue) {
            for ( var i in newValue ) {
                if ( i !== 'page' && newValue[i] !== oldValue[i]) {
                    console.log(i, newValue[i], oldValue[i]);

                    if(i === 'pickpack_status_id'){
                        $cookies.put('pickpack_user_status',newValue[i]);
                        vm.pickpack_user_status = $cookies.get('pickpack_user_status');
                        console.log(vm.pickpack_user_status);
                    }

                    vm.startSearch ++;
                    if( oldValue[i] >= 0 || oldValue[i] === ""){
                       get_pickpack_slips();
                    }else{
                        return "";
                    }
                }
            }
        });

        activate();

        function activate() {
            var promises = [
                get_pickpack_slips(),
                get_pickpack_pending_count(),
                get_pickpack_status(),
                get_pickpack_types(),
                get_pickpack_typesv2(),
                get_held_manual_cubbies()
            ];
            common.activateController(promises, controllerId)
                .then(function() {
                   // log('Activated Pick Pack List View');
                });
        }

        function get_pickpack_slips() {
            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;

                    vm.pickpack_user_status = $cookies.get('pickpack_user_status');
                    if(vm.pickpack_user_status === '' || vm.pickpack_user_status === 'undefined' || vm.pickpack_user_status === undefined){
                        vm.pickpack_user_status = 0;
                    }
                    console.log(vm.pickpack_user_status);

                    for(var key in params.sorting()) {

                        $cookies.put('pickpack_user_sort_order',key);
                        vm.pickpack_user_sort_order = $cookies.get('pickpack_user_sort_order')
                        if(vm.pickpack_user_sort_order === '' || vm.pickpack_user_sort_order === 'undefined' || vm.pickpack_user_sort_order === undefined){
                            vm.pickpack_user_sort_order = 'pickpack_slip_id';
                        }
                        console.log(vm.pickpack_user_sort_order);

                        $cookies.put('pickpack_user_sort_order_dir',params.sorting()[key]);
                        vm.pickpack_user_sort_order_dir = $cookies.get('pickpack_user_sort_order_dir');
                        if(vm.pickpack_user_sort_order_dir === '' || vm.pickpack_user_sort_order_dir === 'undefined' || vm.pickpack_user_sort_order_dir === undefined){
                            vm.pickpack_user_sort_order_dir = 'pickpack_slip_id';
                        }
                        console.log(vm.pickpack_user_sort_order_dir);

                        vm.query.order_by = vm.pickpack_user_sort_order;
                        vm.query.order_dir = vm.pickpack_user_sort_order_dir;
                    }

                    // ajax request to api
                     var query = angular.copy(vm.query);
                        if (query.search) {
                            query.pickpack_status_id = "";
                            query.pickpack_type_id = "";
                            query.pickpack_type_group_id = "";
                        }
                    return datacontext.get_pickpack_slips(query).then(function (httpResult) {

                    // return datacontext.get_pickpack_slips(vm.query).then(function (httpResult) {
                        //$scope.search_filter = $location.absUrl() + '?' + $.param($scope.tableParams.$params);

                        console.log(httpResult);

                        params.total(httpResult.data.total);
                        vm.results_total = httpResult.data.total;
                        // set new data
                        vm.results = httpResult.data.data;
                        vm.results.qty_ordered = httpResult.data.QTY_ORDERED_CNT;
                        vm.results.qty_picked = httpResult.data.QTY_PICKED_CNT;
                        vm.results.qty_packed = httpResult.data.QTY_PACKED_CNT;
                        vm.results.user_role_id = httpResult.data.USER_ROLE_ID;

                        if(httpResult.data.DATA1 !== ''){
                            vm.wholesale_sums = httpResult.data.DATA1;
                        }else{
                            vm.wholesale_sums = '';
                        }
                        return httpResult.data.data;
                    });
                }
            });
        }

        function get_pickpack_status() {
            return datacontext.get_pickpack_status().then(function(httpResult) {

                console.log(vm.pickpack_user_status);
                var pickpack_status = 'open';

                if(vm.pickpack_user_status === '1'){
                    pickpack_status = 'pending pick';
                }
                else if(vm.pickpack_user_status === '2'){
                    pickpack_status = 'pick in progress';
                }
                else if(vm.pickpack_user_status === '3'){
                    pickpack_status = 'pending pack';
                }
                else if(vm.pickpack_user_status === '4'){
                    pickpack_status = 'pack in progress';
                }
                else if(vm.pickpack_user_status === '5'){
                    pickpack_status = 'shipped';
                }else{
                    pickpack_status = 'open';
                }

                // create_open
                var open = {
                    "pickpack_status":pickpack_status,"pickpack_status_id":vm.pickpack_user_status
                };
                $scope.pickpack_status = httpResult.data.data;
                //$scope.pickpack_status.push(open);
            });
        }

        function get_pickpack_types() {
            return datacontext.get_pickpack_types().then(function(httpResult) {
                $scope.pickpack_types = httpResult.data.data;
            });
        }
        function get_pickpack_typesv2() {
            return datacontext.get_pickpack_typesv2().then(function(httpResult) {
                $scope.pickpack_typesv2 = httpResult.data.data;
            });
        }
        function get_pickpack_pending_count() {
            return datacontext.get_pickpack_pending_count().then(function(httpResult) {
                vm.pending_items_total = httpResult.data.data.count;
                vm.pending_today_total = httpResult.data.data.today_cnt;
            });
        }

        function get_held_manual_cubbies() {
            return datacontext.get_held_manual_cubbies().then(function(httpResult) {
                console.log(httpResult.data);
                vm.held_manual_cubbies = httpResult.data.DATA;
            });
        }

        $scope.delete_pickpack_slip = function(idx) {
            var pickpack_slip_id = $scope.vm.slips[idx].pickpack_slip_id;

            datacontext.delete_pickpack_slip(pickpack_slip_id).success(function(httpResult) {
                if (httpResult.success === true) {
                    log("Slip Deleted");
                    vm.slips.splice(idx, 1);
                } else {
                    //$scope.errors.push(result.error);
                    log('Error Deleting Slip');
                }
            });
        };

        $scope.createPickpackSlipModal = function () {

            $scope.pick_slip_create = {
                pick_pack_type_id: 1,
                due_today: true
            };

            // merge order item w/order items
            var modalInstance = $modal.open({
                templateUrl: '/app/pickpack/partials/pickpack_create_modal.html',
                controller:"pickslipCreateModalCtrl",
                windowClass:'small',
                resolve: {
                    pick_slip_create: function () {
                        return $scope.pick_slip_create;
                    }
                }
            }).result.then(function(pickpack_slip_id){
                    // create poi
                    get_pickpack_pending_count();
                    get_pickpack_slips();
                });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };

        $scope.open_cubby_modal = function(data) {
            
            console.log(data);
            $scope.data = data;

            var modalInstance = $modal.open({
                templateUrl: '/app/pickpack/partials/manual_cubby_update.html',
                controller: 'manualCubbyUpdateModalCtrl',
                resolve: {
                    manual_cubby: function () {
                        return $scope.data;
                    }
                }
            }).result.then(function(){
                    // refresh
                    get_pickpack_slips();
                });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        }

        $scope.change_pickpack_status = function (data) {

            console.log(data);

            $scope.data = data;


            var modalInstance = $modal.open({
                templateUrl: '/app/pickpack/partials/pickpack_status.html',
                controller: 'changePickPackStatusModalCtrl',
                resolve: {
                    pickslip: function () {
                        return $scope.data;
                    }
                }
            }).result.then(function(){
                    // refresh
                    get_pickpack_slips();
                });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };

    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .filter('utcToLocal', Filter);

    function Filter($filter) {
        return function (utcDateString, format) {
            // return if input date is null or undefined
            if (!utcDateString) {
                return;
            }

            // append 'Z' to the date string to indicate UTC time if the timezone isn't already specified
            if (utcDateString.indexOf('Z') === -1 && utcDateString.indexOf('+') === -1) {
                utcDateString += 'Z';
            }

            // convert and format date using the built in angularjs date filter
            return $filter('date')(utcDateString, format);
        };
    }
})();

(function() {
    'use strict';
    var controllerId = 'changePickPackStatusModalCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$modalInstance','pickslip', '$window', changePickPackStatusModalCtrl]);

    function changePickPackStatusModalCtrl(common, datacontext, $scope, $modalInstance, pickslip, $window) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        // Pushes input to scope
        $scope.pickslip = pickslip;

        // $scope.pickslip.note =  $window.sessionStorage.user_name ' - ' pickslip.note;

        // get pickpack_status
        datacontext.get_pickpack_status().then(function(response) {
            $scope.pickpack_status = response.data.data;
        });

        console.log('user_name', $window.sessionStorage.user_name);

        $scope.updatePickPackStatus = function (data) {

            //console.log(data);

             // set variables
             var payload = {
                 pickpack_slip_id: data.pickpack_slip_id,
                 pickpack_status_id: data.pickpack_status_id,
                 note: data.note + ' - ' + $window.sessionStorage.user_name
             };

             // update order status / set order note
             return datacontext.updatePickPackSlip(payload).then(function(httpResult) {
                $modalInstance.close(payload);
             });
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();

(function() {
    'use strict';
    var controllerId = 'PickPackItemsCtrl';

    angular.module('app').controller(controllerId, ['common', 'datacontext', '$window', '$scope','$routeParams','$modal', '$cookies', PickPackItemsCtrl]);

    function PickPackItemsCtrl(common, datacontext, $window, $scope, $routeParams, $modal, $cookies) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');

        var vm = this;
        vm.cubby_update = 0;
        vm.print_update = 0;
        vm.slip_id = $routeParams.pid;
        vm.title = 'Pick Pack List View';
        vm.user_name = $cookies.get('user_name');
        $cookies.put('last_list', vm.slip_id);
        activate();
        $scope.show_can = 0;
        $scope.no_track = 0;
        function activate() {
            var promises = [getPickpackItems(),get_pickpack_slips(), get_pickpack_status(),getPrintAllStatus(),getPickPackItems_summary()];
            common.activateController(promises, controllerId)
                .then(function() {
                    //  log('Activated Pick Pack Detail View');
                });
        }

        function get_pickpack_slips() {
            return datacontext.get_pickpack_slips({pickpack_slip_id:vm.slip_id}).then(function(httpResult) {
              console.log(httpResult);
                vm.detail = httpResult.data.data[0];
              if(angular.isDefined(httpResult.data.data[0])){
                vm.mcubby_alert = 0;
                if((vm.detail.pickpack_type_id === 46 && vm.detail.manual_cubby.length === 0) || (httpResult.data.MANUAL_CUBBY_ALERT === 1)){
                  vm.detail.manual_cubby = httpResult.data.MANUAL_CUBBY;
                  vm.mcubby_alert = 1;
                }
                vm.manual_cubby = httpResult.data.MANUAL_CUBBY;
                vm.auto_cubby = httpResult.data.AUTO_CUBBY;
                vm.manual_cubby_alert = httpResult.data.MANUAL_CUBBY_ALERT;
                vm.ABS_CNT = httpResult.data.ABS_CNT;
                vm.unpacked_orders = httpResult.data.UNPACKED_ORDERS;
                if(vm.unpacked_orders.length > 0){
                  var modalInstance = $modal.open({
                          scope:$scope,
                          template: "<div><b style='color:#ff0000 !important;'>{{vm.unpacked_orders}}</b><br></div><div style='float:right;'><button ng-click='refresh_packing()'>Refresh!</button></div>",
                          controller: function(){
                              $scope.refresh_packing = function(){
                                console.log("test packing function");
                                datacontext.fix_unpacked_orders(vm.slip_id).success(function(httpResult) {
                                    location.reload();
                                });
                              };
                          }
                      });
                }
                /***if(vm.ABS_CNT > 0 && vm.detail.abs_override === 0){
                  var modalInstance = $modal.open({
                          scope:$scope,
                          template: "<div><b style='color:#ff0000 !important;'>PLEASE CHECK ABS OVERRIDE BOX</b><br></div><div style='float:right;'><button ng-click='cancel()'>I got it!</button></div>",
                          controller: function(){
                              $scope.cancel = function(){
                                modalInstance.dismiss('cancel');
                              };
                          }
                      });
                }***/

                if(angular.isDefined(httpResult.data.ERRORMULTI)){
                    vm.ERRORMULTI = httpResult.data.ERRORMULTI;
                }
                if(angular.isDefined(httpResult.data.USER_ID)){
                    vm.USER_ID = httpResult.data.USER_ID;
                    vm.user_role_id = httpResult.data.USER_ROLE_ID;
                }
              }else{
                vm.ERRORMULTI = "Invalid Pick List ID in URL";
              }


            });
        }

        //add url variables search


        	function getPickpackItems() {
            if(angular.isDefined($routeParams.orderbyn1)){
              vm.orderby = 'opi.sort_order_override_v1 ASC';
            }else if(angular.isDefined($routeParams.orderbyn)){
              vm.orderby = 'l.location_number,lt.rolled_pick_order_id';
            }else if(angular.isDefined($routeParams.orderby)){
              if($routeParams.orderby === 'shipdesc'){
                vm.orderby = 'IFNULL(o.mp_ship_latest_by, date_add(o.ordered_on,INTERVAL 3 DAY) ) ASC';
              }else{
                vm.orderby = 'order_id '+$routeParams.orderby;
              }

        		}else if(angular.isDefined($routeParams.orderbywfp)){
              vm.orderby = 'p.on_hand ASC, pod.pod_sort';
        		}else{
        			vm.orderby = '';
        		}
        		console.log('new:'+vm.orderby);
                return datacontext.getPickPackItems({pickpack_slip_id:vm.slip_id,orderby:vm.orderby}).then(function(httpResult) {
                    vm.slips = httpResult.data.data;
                    vm.spid = httpResult.data.SPID;

                    vm.atts = _.chain(httpResult.data.data).groupBy("product_id")
                                .pairs()
                                .map(function (currentItem) {
                                    return _.object(_.zip(["product_id", "product_title","on_hand_original"], currentItem));
                                })
                                .value();

                    vm.pickpack_items =[];

                    for (var i = 0; i < vm.atts.length; i++) {
                        //var product_id = vm.atts[i].product_id;
                        var arrlen = vm.atts[i].product_title.length;
                        for (var j = 0; j < vm.atts[i].product_title.length; j++) {
                            var product_id = vm.atts[i].product_title[j].product_id;
                            var product_title = vm.atts[i].product_title[j].product_title;
                            var on_hand_original = vm.atts[i].product_title[j].on_hand_original;
                        }
                        
                        vm.pickpack_items.push({'product_id':product_id,'product_title':product_title,'on_hand_original':on_hand_original,'len':arrlen});
                    }

                    console.log(vm.pickpack_items);
                });

            }


        function get_pickpack_status() {
            return datacontext.get_pickpack_status().then(function(httpResult) {
                vm.pickpack_status = httpResult.data.data;
            });
        }
        function getPrintAllStatus(){
          return datacontext.getPrintAllStatus({pickpack_slip_id:vm.slip_id}).then(function(httpResult) {
              vm.print_all = httpResult.data.data;
              console.log(httpResult.data.data);
              console.log(vm.print_all);
          });
        }

        function getPickPackItems_summary(){
            return datacontext.getPickPackItems_summary({pickpack_slip_id:vm.slip_id}).then(function(httpResult) {
                vm.pickpack_items_summary = httpResult.data.data;
            });
        }

      $scope.sort_by = function (slip_id,sort_by_val) {
        if(sort_by_val === 'qty_desc'){
          vm.orderby = 'on_hand desc';
        }else if(sort_by_val === 'qty_asc'){
          vm.orderby = 'on_hand asc';
        }else if(sort_by_val === 'pikedqty_desc'){
          vm.orderby = 'opi.picked_qty desc';
        }else if(sort_by_val === 'pikedqty_asc'){
          vm.orderby = 'opi.picked_qty asc';
        }

          return datacontext.getPickPackItems({pickpack_slip_id:slip_id,orderby:vm.orderby}).then(function(httpResult) {
              vm.slips = httpResult.data.data;
          });

      };
        $scope.updatePickSlip = function (data) {

            data = {
                pickpack_slip_id : vm.slip_id,
                pickpack_status_id: vm.detail.pickpack_status_id
            };

            return datacontext.updatePickPackSlip(data).then(function (httpResult) {
                // catch errro?
            });

        };
        $scope.abs_override_upd = function (abs_override,slip_id,user_id) {

            if(abs_override === true){
              datacontext.updateFullPackageABS({pickpack_slip_id:slip_id, abs_override: abs_override, user_id: user_id}).then(function(httpResult) {
                $scope.abs_override_msg = "ABS override updated to Yes";
              });
            }else{
              datacontext.updateFullPackageABS({pickpack_slip_id:slip_id, abs_override: abs_override, user_id: user_id}).then(function(httpResult) {
                $scope.abs_override_msg = "ABS override updated to No";
              });

            }

        };

        $scope.upd_pod_cnt = function (data) {

            data = {
                pickpack_slip_id : vm.slip_id
            };

            return datacontext.updatepremiumCnt(data).then(function (httpResult) {
                get_pickpack_slips();
            });

        };

        $scope.update_cubby = function (auto_cubby,manual_cubby){
          var data = {
              pickpack_slip_id : vm.slip_id,
              auto_cubby: auto_cubby,
              manual_cubby:manual_cubby,
              user_name: vm.user_name
          };
          return datacontext.update_cubby(data).then(function (httpResult) {
              console.log(httpResult.data);
              vm.cubby_error = httpResult.data.ERROR;
              if(vm.cubby_error.length > 4){
                vm.cubby_update = 1;
                var modalInstance = $modal.open({
                      scope:$scope,
                      template: "<div><b>{{vm.cubby_error}}</b><br></div><div style='float:right;'><button ng-click='cancel()'>I got it!</button></div>",
                      controller: function(){
                          $scope.cancel = function(){
                            modalInstance.dismiss('cancel');
                          };
                      }
                  });
              }else{
                $scope.cubby_update_msg = "Manual Cubby Updated!";
              }

          });
        };
        $scope.update_auto_cubby = function (slip_id){
          var data = {
              pickpack_slip_id : slip_id,
              user_name: vm.user_name
          };
          return datacontext.update_auto_cubby(data).then(function (httpResult) {
              console.log(httpResult.data);
              vm.cubby_error = httpResult.data.ERROR;
              vm.detail.auto_cubby = httpResult.data.AUTO_CUBBY;
              if(vm.cubby_error.length === 0){
                vm.cubby_auto_update = 1;
                $scope.cubby_update_msg = "Primary Cubby auto assignesd!";
              }

          });
        };

         $scope.update_list_notes = function (slip_id, list_notes) {
            vm.list_notes_update = 0;
            vm.list_notes_error = "";
            var data = {
                pickpack_slip_id: slip_id,
                list_notes: list_notes,
                user_name: vm.user_name
            };
            console.log(data);
            return datacontext.update_list_notes(data).then(function (httpResult) {
                console.log(httpResult.data);

                vm.list_notes_error = httpResult.data.ERROR || "";

                if (vm.list_notes_error.length === 0) {
                    vm.list_notes_update = 1;
                    vm.list_notes_update_msg = "List notes updated!";
                }
            });
        };



        $scope.change_ship_method = function (data) {
            // merge order item w/order items
            $scope.shippingupdate = data;
            console.log(data);
            var modalInstance = $modal.open({
                templateUrl: '/app/pickpack/partials/shippingupdate.html',
                controller: 'shippingupdatenewCtrl',
                resolve: {
                	shippingupdate: function () {
                        return $scope.shippingupdate;
                    }
                }
            }).result.then(function (result) {
            	console.log(result);
                //$scope.tracking_number = result;
                //get_orders();
                //$scope.$broadcast('refreshAuditLog', 'refresh');
            });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };

        $scope.print_image_not_found = function(slip_id,pid,mpid) {
            $scope.printimageupdate = slip_id;
            var itemdata = {
                pickpack_slip_id : slip_id,
                pid: pid,
                mpid:mpid
            };
            console.log(itemdata);

            var modalInstance = $modal.open({
                templateUrl: '/app/pickpack/partials/printimageupdate.html',
                controller: 'printimagenotfoundCtrl',
                resolve: {
                    itemdata: function () {
                        return itemdata;
                    }
                }
            }).result.then(function(result){
                console.log(result);
            });

            vm.cancel = function (){
                modalInstance.dismiss('cancel');
            };
        };

        $scope.no_track_number = function (data,track) {
            if ( track == 1 || track === true) {
                $scope.no_track = 1;
            } else{
                $scope.no_track = 0;
            }

            return datacontext.getPickPackItems({pickpack_slip_id:vm.slip_id,no_tracking_number:track}).then(function(httpResult) {
                vm.slips = httpResult.data.data;
            });
        };

        $scope.unpicked_items = function (data,unpick) {
            if ( unpick == 1 || unpick === true) {
                $scope.un_pick = 1;
            } else{
                $scope.un_pick = 0;
            }

            return datacontext.getPickPackItems({pickpack_slip_id:vm.slip_id,unpick:unpick}).then(function(httpResult) {
                vm.slips = httpResult.data.data;
            });
        }

        $scope.change_note = function (data) {
            // merge order item w/order items
            $scope.noteupdate = data;
            console.log(data);
            var modalInstance = $modal.open({
                templateUrl: '/app/pickpack/partials/noteupdate.html',
                controller: 'noteupdateCtrl',
                resolve: {
                	noteupdate: function () {
                        return $scope.noteupdate;
                    }
                }
            }).result.then(function (result) {
            	console.log(result);
                //$scope.tracking_number = result;
                //get_orders();
                //$scope.$broadcast('refreshAuditLog', 'refresh');
            });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };

        $scope.reprint_cover = function (slip_id,printer) {
          var itemData = {
                  pickpack_slip_id: slip_id,
                  printer: printer};
          console.log(itemData);
          datacontext.reprint_cover(itemData).success(function(httpResult) {
              if (httpResult.success === true) {
                log_success("Cover sheet reprinted.");
              } else {
                log_error("Failed to reprint.")
              }
          });
        };
        $scope.cover_label = function (slip_id, pickpack_type, mp_ship_latest_by_new, qty_ordered, manual_cubby) {
            // merge order item w/order items
            var itemData = {
                    pickpack_slip_id: slip_id,
                    pickpack_type: pickpack_type,
                    mp_ship_latest_by: mp_ship_latest_by_new,
                    qty_ordered: qty_ordered,
                    manual_cubby: manual_cubby
                    };
            //get items count
            datacontext.get_print_cnt({pickpack_slip_id:vm.slip_id}).then(function (httpResult) {
              console.log(httpResult.data.data);
              console.log(httpResult.data.CAN_DATA);
              console.log(httpResult.data.CAT_CNT_DATA);

              vm.cat_detail_cnt = httpResult.data.CAT_CNT_DATA;

              vm.atts = _.chain(httpResult.data.CAT_CNT_DATA.DATA).groupBy("category_id")
                            .pairs()
                            .map(function (currentItem) {
                                return _.object(_.zip(["category_id", "category_count", "category_name", "pod_dimension_id", "pod_dimension"], currentItem));
                            })
                            .value();

                vm.pickpack_cat_cnt =[];

                for(var i = 0; i < vm.atts.length; i++){
                    for (var j = 0; j < vm.atts[i].category_count.length; j++) {
                        var category_count = vm.atts[i].category_count[j][0];
                        var category_id = vm.atts[i].category_count[j][1];
                        var category_name = vm.atts[i].category_count[j][2];
                        var pod_dimension_id = vm.atts[i].category_count[j][3];
                        var pod_dimension = vm.atts[i].category_count[j][4];

                        vm.pickpack_cat_cnt.push({'category_count':category_count,'category_id':category_id,'category_name':category_name,'pod_dimension_id':pod_dimension_id, 'pod_dimension':pod_dimension});
                    };
                };
              // merge order item w/order items
              var itemData = {
                      pickpack_slip_id: slip_id,
                      pickpack_type: pickpack_type,
                      mp_ship_latest_by: mp_ship_latest_by_new,
                      qty_ordered: httpResult.data.data,
                      total_data:httpResult.data.TOTAL_DATA,
                      qty_ordered_can: httpResult.data.CAN_DATA,
                      can_ship_by: httpResult.data.CAN_SHIP_BY,
                      manual_cubby: manual_cubby,
                      pickpack_cat_cnt: vm.pickpack_cat_cnt
                      };
                      console.log(itemData);
                      var modalInstance = $modal.open({
                          templateUrl: '/app/pickpack/partials/coverlabel.html',
                          controller: 'coverlabelCtrl',
                          resolve: {
                          	itemData: function () {
                                  return itemData;
                              }
                          }
                      }).result.then(function (result) {
                      	console.log(result);
                          //$scope.tracking_number = result;
                          //get_orders();
                          //$scope.$broadcast('refreshAuditLog', 'refresh');
                      });

                      vm.cancel = function () {
                          modalInstance.dismiss('cancel');
                      };
            });

        };
        $scope.close_list = function (slip_id,user_id) {
          console.log(slip_id);
          console.log(user_id);
          $scope.pickData = {
                  pickpack_slip_id: slip_id,
                  user_id: user_id};
          var modalInstance = $modal.open({
                templateUrl: '/app/pickpack/partials/closelist.html',
                controller: 'closelistCtrl',
                resolve: {
                	pickData: function () {
                        return $scope.pickData;
                    }
                }
            }).result.then(function (result) {
            	console.log(result);
                //$scope.tracking_number = result;
                //get_orders();
                //$scope.$broadcast('refreshAuditLog', 'refresh');
            });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };

        $scope.change_pickpack_status = function (slip_id,user_id,pickpack_status,pickpack_status_id) {
            $scope.pickslip = {
                pickpack_slip_id: slip_id,
                pickpack_status_id: pickpack_status_id,
                pickpack_status: pickpack_status,
                user_id: user_id
            };

            var modalInstance = $modal.open({
                templateUrl: '/app/pickpack/partials/pickpack_status.html',
                controller: 'changepickpackstatusCtrl',
                resolve: {
                    pickslip: function () {
                        return $scope.pickslip;
                    }
                }
            }).result.then(function (result) {
                console.log(result);
            });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        }

        $scope.pick_all = function (slip_id,user_id) {
          console.log(slip_id);
          console.log(user_id);
          $scope.pickData = {
                  pickpack_slip_id: slip_id,
                  user_id: user_id};
          var modalInstance = $modal.open({
                templateUrl: '/app/pickpack/partials/pickall.html',
                controller: 'pickallCtrl',
                resolve: {
                	pickData: function () {
                        return $scope.pickData;
                    }
                }
            }).result.then(function (result) {
            	console.log(result);
                //$scope.tracking_number = result;
                //get_orders();
                //$scope.$broadcast('refreshAuditLog', 'refresh');
            });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };


        $scope.submit_pick = function(order_package_id,picked_qty,product_id,order_id) {
        	console.log(order_package_id);
        	console.log(picked_qty);
        	console.log(vm.slip_id);
        	var itemData = {
                pickpack_slip_id: vm.slip_id,
                qty_picked: picked_qty,
                is_picked: 1,
                product_id: product_id,
                order_id:order_id,
                order_package_id: order_package_id,
                frompick: 1,
                is_printed: 1
            };


            vm.submitted = true;

            	// Update Pick Item
                datacontext.update_pick_list_wfp(itemData).success(function(httpResult) {
                        // Returns list of Pick / Pack slips
                        if (httpResult.success === true) {
                        	console.log("true");
                          vm.print_update = order_package_id;
                          datacontext.getPickPackItems({pickpack_slip_id:vm.slip_id,orderby:vm.orderby}).then(function(httpResult) {
                             vm.slips = httpResult.data.data;
                          });
                          vm.print_update = order_package_id;
                        	//getPickPackItems();
                        } else {
                            console.log("false");
                        }
                    });
        };

        $scope.submit_pick_summary = function(order_package_id,picked_qty,product_id,order_id) {
            console.log(order_package_id);
            console.log(picked_qty);
            console.log(product_id);
            console.log(order_id);
            console.log(vm.slip_id);

            var itemData = {
                pickpack_slip_id: vm.slip_id,
                qty_picked: picked_qty,
                is_picked: 1,
                product_id: product_id,
                order_id:order_id,
                order_package_id: order_package_id,
                frompick: 1,
                is_printed: 1
            };

            vm.submitted = true;

            //update pick item
            datacontext.update_pick_list_summary(itemData).success(function(httpResult){
                if(httpResult.success === true){
                    console.log('true');
                    vm.print_update = order_package_id;
                    datacontext.getPickPackItems({pickpack_slip_id:vm.slip_id,orderby:vm.orderby}).then(function(httpResult) {
                        vm.slips = httpResult.data.data;
                    });
                    vm.print_update = order_package_id;
                    location.reload();
                }else{
                    console.log('false');
                }
            });
        };

        $scope.updatePrinter = function(printer,slip_id){
          var slipPrintData = {printer: printer,
                              slip_id: slip_id};
          datacontext.update_printer(slipPrintData).success(function(httpResult) {
              // Returns list of Pick / Pack slips
              if (httpResult.success === true) {
                console.log("true");
              } else {
                console.log("false");
              }
          });
        };


        $scope.xerox_ftp = function (pickpack_slip_id, pickpack_type_id) {
            var slipXeroxData = {pickpack_slip_id: pickpack_slip_id,
                                pickpack_type_id: pickpack_type_id};
            datacontext.create_xerox_csv_ftp(slipXeroxData).success(function(httpResult) {
                if (httpResult.success === true) {
                    console.log("true");
                } else {
                    console.log("false");
                }
            });
        };

        $scope.xerox_ricoh_ftp = function (pickpack_slip_id, pickpack_type_id, ricoh) {
            var slipXeroxData = {pickpack_slip_id: pickpack_slip_id,
                                pickpack_type_id: pickpack_type_id};
            datacontext.create_ricoh_xerox_csv_ftp(slipXeroxData).success(function(httpResult) {
                if (httpResult.success === true) {
                    console.log("true");
                } else {
                    console.log("false");
                }
            });
        };

        $scope.xerox_calendars_km_ftp = function (pickpack_slip_id, pickpack_type_id, cal) {
            var slipXeroxData = {pickpack_slip_id: pickpack_slip_id,
                                pickpack_type_id: pickpack_type_id};
            datacontext.create_cal_km_xerox_csv_ftp(slipXeroxData).success(function(httpResult) {
                if (httpResult.success === true) {
                    console.log("true"); 
                    window.location.reload();
                } else {
                    console.log("false");
                    window.location.reload();
                }
            });
        };
        $scope.printAll = function(printer,slip_id,pickpack_type_id){
          var slipPrintData = {printer: printer,
                              pickpack_slip_id: slip_id,
                                pickpack_type_id:pickpack_type_id};
          datacontext.print_all(slipPrintData).success(function(httpResult) {
            console.log(httpResult);
            if(httpResult.ERROR.length > 0){
              //log_error(httpResult.ERROR);
              $scope.errormessage = httpResult.ERROR;
            }
              // Returns list of Pick / Pack slips
              if (httpResult.success === true) {
                console.log("true");
              } else {
                console.log("false");
              }
          });
        };
        $scope.printAllCan = function(printer,slip_id){
          var slipPrintData = {printer: printer,
                              pickpack_slip_id: slip_id};
          datacontext.print_all_can(slipPrintData).success(function(httpResult) {
            console.log(httpResult);
            if(httpResult.ERROR.length > 0){
              //log_error(httpResult.ERROR);
              $scope.errormessage = httpResult.ERROR;
            }
              // Returns list of Pick / Pack slips
              if (httpResult.success === true) {
                console.log("true");
              } else {
                console.log("false");
              }
          });
        };

        $scope.printAllHP = function(printer,slip_id,pickpack_type_id){
            var slipPrintData = {
                printer: printer,
                pickpack_slip_id: slip_id,
                pickpack_type_id:pickpack_type_id
            };

            datacontext.print_all_hp(slipPrintData).success(function(httpResult) {
                console.log(httpResult);
                if(httpResult.ERROR.length > 0){
                    //log_error(httpResult.ERROR);
                    $scope.errormessage = httpResult.ERROR;
                }

                //Returns list of Pick / Pack slips
                if(httpResult.success === true) {
                    console.log("true");
                }else{
                    console.log("false");
                }
            });
        };

        $scope.printAllEPSON777_1 = function(printer,slip_id,pickpack_type_id){
            var slipPrintData = {
                printer: printer,
                pickpack_slip_id: slip_id,
                pickpack_type_id:pickpack_type_id
            };

            datacontext.print_all_EPSON777_1(slipPrintData).success(function(httpResult) {
                console.log(httpResult);
                if(httpResult.ERROR.length > 0){
                    //log_error(httpResult.ERROR);
                    $scope.errormessage = httpResult.ERROR;
                }

                //Returns list of Pick / Pack slips
                if(httpResult.success === true) {
                    console.log("true");
                }else{
                    console.log("false");
                }
            });
        };

        $scope.printAllEPSON777_2 = function(printer,slip_id,pickpack_type_id){
            var slipPrintData = {
                printer: printer,
                pickpack_slip_id: slip_id,
                pickpack_type_id:pickpack_type_id
            };

            datacontext.print_all_EPSON777_2(slipPrintData).success(function(httpResult) {
                console.log(httpResult);
                if(httpResult.ERROR.length > 0){
                    //log_error(httpResult.ERROR);
                    $scope.errormessage = httpResult.ERROR;
                }

                //Returns list of Pick / Pack slips
                if(httpResult.success === true) {
                    console.log("true");
                }else{
                    console.log("false");
                }
            });
        };

        $scope.printAllEPSON777_3 = function(printer,slip_id,pickpack_type_id){
            var slipPrintData = {
                printer: printer,
                pickpack_slip_id: slip_id,
                pickpack_type_id:pickpack_type_id
            };

            datacontext.print_all_EPSON777_3(slipPrintData).success(function(httpResult) {
                console.log(httpResult);
                if(httpResult.ERROR.length > 0){
                    //log_error(httpResult.ERROR);
                    $scope.errormessage = httpResult.ERROR;
                }

                //Returns list of Pick / Pack slips
                if(httpResult.success === true) {
                    console.log("true");
                }else{
                    console.log("false");
                }
            });
        };

        $scope.printAllEPSON777_4 = function(printer,slip_id,pickpack_type_id){
            var slipPrintData = {
                printer: printer,
                pickpack_slip_id: slip_id,
                pickpack_type_id:pickpack_type_id
            };

            datacontext.print_all_EPSON777_4(slipPrintData).success(function(httpResult) {
                console.log(httpResult);
                if(httpResult.ERROR.length > 0){
                    //log_error(httpResult.ERROR);
                    $scope.errormessage = httpResult.ERROR;
                }

                //Returns list of Pick / Pack slips
                if(httpResult.success === true) {
                    console.log("true");
                }else{
                    console.log("false");
                }
            });
        };

        $scope.DoneprintAll = function(slip_id){
          // if(assign_cubby){
          //   console.log("assign_cubby"+assign_cubby);
          // }else{
          //   console.log("noassign_cubby"+assign_cubby);
          // }
          var slipPrintData = {pickpack_slip_id: slip_id};
          console.log(slipPrintData);
          datacontext.done_print_all(slipPrintData).success(function(httpResult) {
              // Returns list of Pick / Pack slips
              if (httpResult.success === true) {
                console.log("true");
                log_success("Pick Status Updated");
                vm.done_print = 1;
              } else {
                console.log("false");
              }
          });
        };

        $scope.print_wfp_ftp = function (layout,order_package_id,to_ship_qty,product_id,category_id,pod_dimension_id,master_product_id,order_id,pickpack_slip_id,width,height,user_orientation_id,printer,wfp_image_s3_status,hi_res_image_id) {

          console.log(user_orientation_id);
          console.log(pod_dimension_id);
          console.log(height);
          console.log(width);

            var itemDataNew = {
                product_id: product_id,
                master_product_id: master_product_id,
                order_id: order_id 
            };
          if(wfp_image_s3_status == 0){
            datacontext.check_wfp_image(itemDataNew).success(function(httpResult) {
              var error_message = httpResult;
              $scope.print_values = {layout:layout,order_package_id:order_package_id,to_ship_qty:to_ship_qty,product_id:product_id,category_id:category_id,master_product_id:master_product_id,
                                    order_id:order_id,pickpack_slip_id:pickpack_slip_id,error_message:error_message,width:width,height:height,user_orientation_id:user_orientation_id,printer:'20',pod_dimension_id:pod_dimension_id,wfp_image_s3_status:wfp_image_s3_status,hi_res_image_id:hi_res_image_id};

              var modalInstance = $modal.open({
                  templateUrl: '/app/pickpack/partials/print_wfp_ftp_modal.html',
                  controller: 'onPrintWfpFtpModalCtrl',
                  resolve: {
                      print_values: function () {
                          return $scope.print_values;
                      }
                  }
              }).result.then(function(result){
                      //$scope.tracking_number = result;
                  });

              vm.cancel = function () {
                  modalInstance.dismiss('cancel');
              };
            });
          }else{
            var error_message = "";
            $scope.print_values = {layout:layout,order_package_id:order_package_id,to_ship_qty:to_ship_qty,product_id:product_id,category_id:category_id,master_product_id:master_product_id,
                                  order_id:order_id,pickpack_slip_id:pickpack_slip_id,error_message:error_message,width:width,height:height, user_orientation_id:user_orientation_id,printer:'20',pod_dimension_id:pod_dimension_id,wfp_image_s3_status:wfp_image_s3_status,hi_res_image_id:hi_res_image_id};

            var modalInstance = $modal.open({
                templateUrl: '/app/pickpack/partials/print_wfp_ftp_modal.html',
                controller: 'onPrintWfpFtpModalCtrl',
                resolve: {
                    print_values: function () {
                        return $scope.print_values;
                    }
                }
            }).result.then(function(result){
                    //$scope.tracking_number = result;
                });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
          }



        };

        $scope.print_wfp_ftp_can = function (layout,order_package_id,to_ship_qty,product_id,category_id,master_product_id,order_id,pickpack_slip_id,width,height,user_orientation_id,printer,wfp_image_s3_status,hi_res_image_id) {

          console.log(user_orientation_id);

            var itemDataNew = {
                  product_id: product_id,
                  master_product_id: master_product_id,
                  order_id: order_id
            };
          if(wfp_image_s3_status == 0){
            datacontext.check_wfp_image(itemDataNew).success(function(httpResult) {
              var error_message = httpResult;
              $scope.print_values = {layout:layout,order_package_id:order_package_id,to_ship_qty:to_ship_qty,product_id:product_id,category_id:category_id,master_product_id:master_product_id,
                                    order_id:order_id,pickpack_slip_id:pickpack_slip_id,error_message:error_message,width:width,height:height, user_orientation_id:user_orientation_id,printer:'1640',wfp_image_s3_status:wfp_image_s3_status,hi_res_image_id:hi_res_image_id};

              var modalInstance = $modal.open({
                  templateUrl: '/app/pickpack/partials/print_wfp_ftp_can_modal.html',
                  controller: 'onPrintWfpFtpModalCtrl',
                  resolve: {
                      print_values: function () {
                          return $scope.print_values;
                      }
                  }
              }).result.then(function(result){
                      //$scope.tracking_number = result;
                  });

              vm.cancel = function () {
                  modalInstance.dismiss('cancel');
              };
            });
          }else{
            var error_message = "";
            $scope.print_values = {layout:layout,order_package_id:order_package_id,to_ship_qty:to_ship_qty,product_id:product_id,category_id:category_id,master_product_id:master_product_id,
                                  order_id:order_id,pickpack_slip_id:pickpack_slip_id,error_message:error_message,width:width,height:height, user_orientation_id:user_orientation_id,printer:'1640',wfp_image_s3_status:wfp_image_s3_status,hi_res_image_id:hi_res_image_id};

            var modalInstance = $modal.open({
                templateUrl: '/app/pickpack/partials/print_wfp_ftp_can_modal.html',
                controller: 'onPrintWfpFtpModalCtrl',
                resolve: {
                    print_values: function () {
                        return $scope.print_values;
                    }
                }
            }).result.then(function(result){
                    //$scope.tracking_number = result;
                });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
          }



        };

        $scope.print_wfp_ftp_hp = function(layout,order_package_id,to_ship_qty,product_id,category_id,pod_dimension_id,master_product_id,order_id,pickpack_slip_id,width,height,user_orientation_id,printer,wfp_image_s3_status,hi_res_image_id) {
            console.log(user_orientation_id);
            console.log(pod_dimension_id);

            var layout = layout;
            var user_orientation_id = user_orientation_id;

            var itemDataNew = {
                  product_id: product_id,
                  master_product_id: master_product_id,
                  order_id: order_id
            };

            if(wfp_image_s3_status == 0){
                datacontext.check_wfp_image(itemDataNew).success(function(httpResult) {
                    var error_message = httpResult;

                    if(pod_dimension_id === 8 || pod_dimension_id === 4){
                        if(user_orientation_id == 3){
                            layout = 0;
                        }else if(user_orientation_id == 4){
                            layout = 1;
                        };
                    };

                    $scope.print_values = {layout:layout,order_package_id:order_package_id,to_ship_qty:to_ship_qty,product_id:product_id,category_id:category_id,master_product_id:master_product_id,
                                    order_id:order_id,pickpack_slip_id:pickpack_slip_id,error_message:error_message,width:width,height:height, user_orientation_id:user_orientation_id,printer:'82',pod_dimension_id:pod_dimension_id,wfp_image_s3_status:wfp_image_s3_status,hi_res_image_id:hi_res_image_id};

                    var modalInstance = $modal.open({
                        templateUrl: '/app/pickpack/partials/print_wfp_ftp_hp_modal.html',
                        controller: 'onPrintWfpFtpModalCtrl',
                        resolve: {
                            print_values: function () {
                                return $scope.print_values;
                            }
                        }
                    }).result.then(function(result){
                        //$scope.tracking_number = result;
                    });

                    vm.cancel = function () {
                        modalInstance.dismiss('cancel');
                    };
                });
            }else{
                var error_message = "";

                if(pod_dimension_id === 8 || pod_dimension_id === 4){
                    if(user_orientation_id == 3){
                        layout = 0;
                    }else if(user_orientation_id == 4){
                        layout = 1;
                    };
                };

                $scope.print_values = {layout:layout,order_package_id:order_package_id,to_ship_qty:to_ship_qty,product_id:product_id,category_id:category_id,master_product_id:master_product_id,
                                order_id:order_id,pickpack_slip_id:pickpack_slip_id,error_message:error_message,width:width,height:height, user_orientation_id:user_orientation_id,printer:'82',pod_dimension_id:pod_dimension_id,wfp_image_s3_status:wfp_image_s3_status,hi_res_image_id:hi_res_image_id};

                var modalInstance = $modal.open({
                    templateUrl: '/app/pickpack/partials/print_wfp_ftp_hp_modal.html',
                    controller: 'onPrintWfpFtpModalCtrl',
                    resolve: {
                        print_values: function () {
                            return $scope.print_values;
                        }
                    }
                }).result.then(function(result){
                    //$scope.tracking_number = result;
                });

                vm.cancel = function () {
                    modalInstance.dismiss('cancel');
                };
            }
        };

        $scope.print_wfp_ftp_777_1 = function(layout,order_package_id,to_ship_qty,product_id,category_id,pod_dimension_id,master_product_id,order_id,pickpack_slip_id,width,height,user_orientation_id,printer,wfp_image_s3_status,hi_res_image_id) {
            console.log(user_orientation_id);
            console.log(pod_dimension_id);

            var layout = layout;
            var user_orientation_id = user_orientation_id;

            var itemDataNew = {
                  product_id: product_id,
                  master_product_id: master_product_id,
                  order_id: order_id
            };

            if(wfp_image_s3_status == 0){
                datacontext.check_wfp_image(itemDataNew).success(function(httpResult) {
                    var error_message = httpResult;

                    if(pod_dimension_id === 8 || pod_dimension_id === 4){
                        if(user_orientation_id == 3){
                            layout = 0;
                        }else if(user_orientation_id == 4){
                            layout = 1;
                        };
                    };

                    $scope.print_values = {layout:layout,order_package_id:order_package_id,to_ship_qty:to_ship_qty,product_id:product_id,category_id:category_id,master_product_id:master_product_id,
                                    order_id:order_id,pickpack_slip_id:pickpack_slip_id,error_message:error_message,width:width,height:height, user_orientation_id:user_orientation_id,printer:'70',pod_dimension_id:pod_dimension_id,wfp_image_s3_status:wfp_image_s3_status,hi_res_image_id:hi_res_image_id};

                    var modalInstance = $modal.open({
                        templateUrl: '/app/pickpack/partials/print_wfp_ftp_777_1.html',
                        controller: 'onPrintWfpFtpModalCtrl',
                        resolve: {
                            print_values: function () {
                                return $scope.print_values;
                            }
                        }
                    }).result.then(function(result){
                        //$scope.tracking_number = result;
                    });

                    vm.cancel = function () {
                        modalInstance.dismiss('cancel');
                    };
                });
            }else{
                var error_message = "";

                if(pod_dimension_id === 8 || pod_dimension_id === 4){
                    if(user_orientation_id == 3){
                        layout = 0;
                    }else if(user_orientation_id == 4){
                        layout = 1;
                    };
                };

                $scope.print_values = {layout:layout,order_package_id:order_package_id,to_ship_qty:to_ship_qty,product_id:product_id,category_id:category_id,master_product_id:master_product_id,
                                order_id:order_id,pickpack_slip_id:pickpack_slip_id,error_message:error_message,width:width,height:height, user_orientation_id:user_orientation_id,printer:'70',pod_dimension_id:pod_dimension_id,wfp_image_s3_status:wfp_image_s3_status,hi_res_image_id:hi_res_image_id};

                var modalInstance = $modal.open({
                    templateUrl: '/app/pickpack/partials/print_wfp_ftp_777_1.html',
                    controller: 'onPrintWfpFtpModalCtrl',
                    resolve: {
                        print_values: function () {
                            return $scope.print_values;
                        }
                    }
                }).result.then(function(result){
                    //$scope.tracking_number = result;
                });

                vm.cancel = function () {
                    modalInstance.dismiss('cancel');
                };
            }
        };

        $scope.print_wfp_ftp_777_2 = function(layout,order_package_id,to_ship_qty,product_id,category_id,pod_dimension_id,master_product_id,order_id,pickpack_slip_id,width,height,user_orientation_id,printer,wfp_image_s3_status,hi_res_image_id) {
            console.log(user_orientation_id);
            console.log(pod_dimension_id);

            var layout = layout;
            var user_orientation_id = user_orientation_id;

            var itemDataNew = {
                  product_id: product_id,
                  master_product_id: master_product_id,
                  order_id: order_id
            };

            if(wfp_image_s3_status == 0){
                datacontext.check_wfp_image(itemDataNew).success(function(httpResult) {
                    var error_message = httpResult;

                    if(pod_dimension_id === 8 || pod_dimension_id === 4){
                        if(user_orientation_id == 3){
                            layout = 0;
                        }else if(user_orientation_id == 4){
                            layout = 1;
                        };
                    };

                    $scope.print_values = {layout:layout,order_package_id:order_package_id,to_ship_qty:to_ship_qty,product_id:product_id,category_id:category_id,master_product_id:master_product_id,
                                    order_id:order_id,pickpack_slip_id:pickpack_slip_id,error_message:error_message,width:width,height:height, user_orientation_id:user_orientation_id,printer:'71',pod_dimension_id:pod_dimension_id,wfp_image_s3_status:wfp_image_s3_status,hi_res_image_id:hi_res_image_id};

                    var modalInstance = $modal.open({
                        templateUrl: '/app/pickpack/partials/print_wfp_ftp_777_2.html',
                        controller: 'onPrintWfpFtpModalCtrl',
                        resolve: {
                            print_values: function () {
                                return $scope.print_values;
                            }
                        }
                    }).result.then(function(result){
                        //$scope.tracking_number = result;
                    });

                    vm.cancel = function () {
                        modalInstance.dismiss('cancel');
                    };
                });
            }else{
                var error_message = "";

                if(pod_dimension_id === 8 || pod_dimension_id === 4){
                    if(user_orientation_id == 3){
                        layout = 0;
                    }else if(user_orientation_id == 4){
                        layout = 1;
                    };
                };

                $scope.print_values = {layout:layout,order_package_id:order_package_id,to_ship_qty:to_ship_qty,product_id:product_id,category_id:category_id,master_product_id:master_product_id,
                                order_id:order_id,pickpack_slip_id:pickpack_slip_id,error_message:error_message,width:width,height:height, user_orientation_id:user_orientation_id,printer:'71',pod_dimension_id:pod_dimension_id,wfp_image_s3_status:wfp_image_s3_status,hi_res_image_id:hi_res_image_id};

                var modalInstance = $modal.open({
                    templateUrl: '/app/pickpack/partials/print_wfp_ftp_777_2.html',
                    controller: 'onPrintWfpFtpModalCtrl',
                    resolve: {
                        print_values: function () {
                            return $scope.print_values;
                        }
                    }
                }).result.then(function(result){
                    //$scope.tracking_number = result;
                });

                vm.cancel = function () {
                    modalInstance.dismiss('cancel');
                };
            }
        };

        $scope.print_wfp_ftp_777_3 = function(layout,order_package_id,to_ship_qty,product_id,category_id,pod_dimension_id,master_product_id,order_id,pickpack_slip_id,width,height,user_orientation_id,printer,wfp_image_s3_status,hi_res_image_id) {
            console.log(user_orientation_id);
            console.log(pod_dimension_id);

            var layout = layout;
            var user_orientation_id = user_orientation_id;

            var itemDataNew = {
                  product_id: product_id,
                  master_product_id: master_product_id,
                  order_id: order_id
            };

            if(wfp_image_s3_status == 0){
                datacontext.check_wfp_image(itemDataNew).success(function(httpResult) {
                    var error_message = httpResult;

                    if(pod_dimension_id === 8 || pod_dimension_id === 4){
                        if(user_orientation_id == 3){
                            layout = 0;
                        }else if(user_orientation_id == 4){
                            layout = 1;
                        };
                    };

                    $scope.print_values = {layout:layout,order_package_id:order_package_id,to_ship_qty:to_ship_qty,product_id:product_id,category_id:category_id,master_product_id:master_product_id,
                                    order_id:order_id,pickpack_slip_id:pickpack_slip_id,error_message:error_message,width:width,height:height, user_orientation_id:user_orientation_id,printer:'72',pod_dimension_id:pod_dimension_id,wfp_image_s3_status:wfp_image_s3_status,hi_res_image_id:hi_res_image_id};

                    var modalInstance = $modal.open({
                        templateUrl: '/app/pickpack/partials/print_wfp_ftp_777_3.html',
                        controller: 'onPrintWfpFtpModalCtrl',
                        resolve: {
                            print_values: function () {
                                return $scope.print_values;
                            }
                        }
                    }).result.then(function(result){
                        //$scope.tracking_number = result;
                    });

                    vm.cancel = function () {
                        modalInstance.dismiss('cancel');
                    };
                });
            }else{
                var error_message = "";

                if(pod_dimension_id === 8 || pod_dimension_id === 4){
                    if(user_orientation_id == 3){
                        layout = 0;
                    }else if(user_orientation_id == 4){
                        layout = 1;
                    };
                };

                $scope.print_values = {layout:layout,order_package_id:order_package_id,to_ship_qty:to_ship_qty,product_id:product_id,category_id:category_id,master_product_id:master_product_id,
                                order_id:order_id,pickpack_slip_id:pickpack_slip_id,error_message:error_message,width:width,height:height, user_orientation_id:user_orientation_id,printer:'72',pod_dimension_id:pod_dimension_id,wfp_image_s3_status:wfp_image_s3_status,hi_res_image_id:hi_res_image_id};

                var modalInstance = $modal.open({
                    templateUrl: '/app/pickpack/partials/print_wfp_ftp_777_3.html',
                    controller: 'onPrintWfpFtpModalCtrl',
                    resolve: {
                        print_values: function () {
                            return $scope.print_values;
                        }
                    }
                }).result.then(function(result){
                    //$scope.tracking_number = result;
                });

                vm.cancel = function () {
                    modalInstance.dismiss('cancel');
                };
            }
        };

        $scope.print_wfp_ftp_777_4 = function(layout,order_package_id,to_ship_qty,product_id,category_id,pod_dimension_id,master_product_id,order_id,pickpack_slip_id,width,height,user_orientation_id,printer,wfp_image_s3_status,hi_res_image_id) {
            console.log(user_orientation_id);
            console.log(pod_dimension_id);

            var layout = layout;
            var user_orientation_id = user_orientation_id;

            var itemDataNew = {
                  product_id: product_id,
                  master_product_id: master_product_id,
                  order_id: order_id
            };

            if(wfp_image_s3_status == 0){
                datacontext.check_wfp_image(itemDataNew).success(function(httpResult) {
                    var error_message = httpResult;

                    if(pod_dimension_id === 8 || pod_dimension_id === 4){
                        if(user_orientation_id == 3){
                            layout = 0;
                        }else if(user_orientation_id == 4){
                            layout = 1;
                        };
                    };

                    $scope.print_values = {layout:layout,order_package_id:order_package_id,to_ship_qty:to_ship_qty,product_id:product_id,category_id:category_id,master_product_id:master_product_id,
                                    order_id:order_id,pickpack_slip_id:pickpack_slip_id,error_message:error_message,width:width,height:height, user_orientation_id:user_orientation_id,printer:'73',pod_dimension_id:pod_dimension_id,wfp_image_s3_status:wfp_image_s3_status,hi_res_image_id:hi_res_image_id};

                    var modalInstance = $modal.open({
                        templateUrl: '/app/pickpack/partials/print_wfp_ftp_777_4.html',
                        controller: 'onPrintWfpFtpModalCtrl',
                        resolve: {
                            print_values: function () {
                                return $scope.print_values;
                            }
                        }
                    }).result.then(function(result){
                        //$scope.tracking_number = result;
                    });

                    vm.cancel = function () {
                        modalInstance.dismiss('cancel');
                    };
                });
            }else{
                var error_message = "";

                if(pod_dimension_id === 8 || pod_dimension_id === 4){
                    if(user_orientation_id == 3){
                        layout = 0;
                    }else if(user_orientation_id == 4){
                        layout = 1;
                    };
                };

                $scope.print_values = {layout:layout,order_package_id:order_package_id,to_ship_qty:to_ship_qty,product_id:product_id,category_id:category_id,master_product_id:master_product_id,
                                order_id:order_id,pickpack_slip_id:pickpack_slip_id,error_message:error_message,width:width,height:height, user_orientation_id:user_orientation_id,printer:'73',pod_dimension_id:pod_dimension_id,wfp_image_s3_status:wfp_image_s3_status,hi_res_image_id:hi_res_image_id};

                var modalInstance = $modal.open({
                    templateUrl: '/app/pickpack/partials/print_wfp_ftp_777_4.html',
                    controller: 'onPrintWfpFtpModalCtrl',
                    resolve: {
                        print_values: function () {
                            return $scope.print_values;
                        }
                    }
                }).result.then(function(result){
                    //$scope.tracking_number = result;
                });

                vm.cancel = function () {
                    modalInstance.dismiss('cancel');
                };
            }
        };
        $scope.print_wfp_ftp_777_5 = function(layout,order_package_id,to_ship_qty,product_id,category_id,pod_dimension_id,master_product_id,order_id,pickpack_slip_id,width,height,user_orientation_id,printer,wfp_image_s3_status,hi_res_image_id) {
            console.log(user_orientation_id);
            console.log(pod_dimension_id);

            var layout = layout;
            var user_orientation_id = user_orientation_id;

            var itemDataNew = {
                  product_id: product_id,
                  master_product_id: master_product_id,
                  order_id: order_id
            };

            if(wfp_image_s3_status == 0){
                datacontext.check_wfp_image(itemDataNew).success(function(httpResult) {
                    var error_message = httpResult;

                    if(pod_dimension_id === 8 || pod_dimension_id === 4){
                        if(user_orientation_id == 3){
                            layout = 0;
                        }else if(user_orientation_id == 4){
                            layout = 1;
                        };
                    };

                    $scope.print_values = {layout:layout,order_package_id:order_package_id,to_ship_qty:to_ship_qty,product_id:product_id,category_id:category_id,master_product_id:master_product_id,
                                    order_id:order_id,pickpack_slip_id:pickpack_slip_id,error_message:error_message,width:width,height:height, user_orientation_id:user_orientation_id,printer:'74',pod_dimension_id:pod_dimension_id,wfp_image_s3_status:wfp_image_s3_status,hi_res_image_id:hi_res_image_id};

                    var modalInstance = $modal.open({
                        templateUrl: '/app/pickpack/partials/print_wfp_ftp_777_5.html',
                        controller: 'onPrintWfpFtpModalCtrl',
                        resolve: {
                            print_values: function () {
                                return $scope.print_values;
                            }
                        }
                    }).result.then(function(result){
                        //$scope.tracking_number = result;
                    });

                    vm.cancel = function () {
                        modalInstance.dismiss('cancel');
                    };
                });
            }else{
                var error_message = "";

                if(pod_dimension_id === 8 || pod_dimension_id === 4){
                    if(user_orientation_id == 3){
                        layout = 0;
                    }else if(user_orientation_id == 4){
                        layout = 1;
                    };
                };

                $scope.print_values = {layout:layout,order_package_id:order_package_id,to_ship_qty:to_ship_qty,product_id:product_id,category_id:category_id,master_product_id:master_product_id,
                                order_id:order_id,pickpack_slip_id:pickpack_slip_id,error_message:error_message,width:width,height:height, user_orientation_id:user_orientation_id,printer:'74',pod_dimension_id:pod_dimension_id,wfp_image_s3_status:wfp_image_s3_status,hi_res_image_id:hi_res_image_id};

                var modalInstance = $modal.open({
                    templateUrl: '/app/pickpack/partials/print_wfp_ftp_777_5.html',
                    controller: 'onPrintWfpFtpModalCtrl',
                    resolve: {
                        print_values: function () {
                            return $scope.print_values;
                        }
                    }
                }).result.then(function(result){
                    //$scope.tracking_number = result;
                });

                vm.cancel = function () {
                    modalInstance.dismiss('cancel');
                };
            }
        };



        $scope.print_wfp_ftp_777_6 = function(layout,order_package_id,to_ship_qty,product_id,category_id,pod_dimension_id,master_product_id,order_id,pickpack_slip_id,width,height,user_orientation_id,printer,wfp_image_s3_status,hi_res_image_id) {
            console.log(user_orientation_id);
            console.log(pod_dimension_id);

            var layout = layout;
            var user_orientation_id = user_orientation_id;

            var itemDataNew = {
                  product_id: product_id,
                  master_product_id: master_product_id,
                  order_id: order_id
            };

            if(wfp_image_s3_status == 0){
                datacontext.check_wfp_image(itemDataNew).success(function(httpResult) {
                    var error_message = httpResult;

                    if(pod_dimension_id === 8 || pod_dimension_id === 4){
                        if(user_orientation_id == 3){
                            layout = 0;
                        }else if(user_orientation_id == 4){
                            layout = 1;
                        };
                    };

                    $scope.print_values = {layout:layout,order_package_id:order_package_id,to_ship_qty:to_ship_qty,product_id:product_id,category_id:category_id,master_product_id:master_product_id,
                                    order_id:order_id,pickpack_slip_id:pickpack_slip_id,error_message:error_message,width:width,height:height, user_orientation_id:user_orientation_id,printer:'75',pod_dimension_id:pod_dimension_id,wfp_image_s3_status:wfp_image_s3_status,hi_res_image_id:hi_res_image_id};

                    var modalInstance = $modal.open({
                        templateUrl: '/app/pickpack/partials/print_wfp_ftp_777_6.html',
                        controller: 'onPrintWfpFtpModalCtrl',
                        resolve: {
                            print_values: function () {
                                return $scope.print_values;
                            }
                        }
                    }).result.then(function(result){
                        //$scope.tracking_number = result;
                    });

                    vm.cancel = function () {
                        modalInstance.dismiss('cancel');
                    };
                });
            }else{
                var error_message = "";

                if(pod_dimension_id === 8 || pod_dimension_id === 4){
                    if(user_orientation_id == 3){
                        layout = 0;
                    }else if(user_orientation_id == 4){
                        layout = 1;
                    };
                };

                $scope.print_values = {layout:layout,order_package_id:order_package_id,to_ship_qty:to_ship_qty,product_id:product_id,category_id:category_id,master_product_id:master_product_id,
                                order_id:order_id,pickpack_slip_id:pickpack_slip_id,error_message:error_message,width:width,height:height, user_orientation_id:user_orientation_id,printer:'75',pod_dimension_id:pod_dimension_id,wfp_image_s3_status:wfp_image_s3_status,hi_res_image_id:hi_res_image_id};

                var modalInstance = $modal.open({
                    templateUrl: '/app/pickpack/partials/print_wfp_ftp_777_6.html',
                    controller: 'onPrintWfpFtpModalCtrl',
                    resolve: {
                        print_values: function () {
                            return $scope.print_values;
                        }
                    }
                }).result.then(function(result){
                    //$scope.tracking_number = result;
                });

                vm.cancel = function () {
                    modalInstance.dismiss('cancel');
                };
            }
        };

        $scope.print_wfp_ftp_canvas = function(layout,order_package_id,to_ship_qty,product_id,master_product_id,order_id,pickpack_slip_id,width,height,user_orientation_id,printer,wfp_image_s3_status,hi_res_image_id) {
            console.log(user_orientation_id);

            var itemDataNew = {
                product_id: product_id,
                master_product_id: master_product_id,
                order_id: order_id
            };

           if(wfp_image_s3_status == 0){
                datacontext.check_wfp_image(itemDataNew).success(function(httpResult) {
                    var error_message = httpResult;

                    $scope.print_values = {layout:layout,order_package_id:order_package_id,to_ship_qty:to_ship_qty,product_id:product_id,master_product_id:master_product_id,
                                    order_id:order_id,pickpack_slip_id:pickpack_slip_id,error_message:error_message,width:width,height:height,user_orientation_id:user_orientation_id,printer:60,wfp_image_s3_status:wfp_image_s3_status,hi_res_image_id:hi_res_image_id};

                    var modalInstance = $modal.open({
                        templateUrl: '/app/pickpack/partials/print_wfp_ftp_canvas.html',
                        controller: 'onPrintWfpFtpModalCtrl',
                        resolve: {
                            print_values: function () {
                                return $scope.print_values;
                            }
                        }
                    }).result.then(function(result){
                        //$scope.tracking_number = result;
                    });

                    vm.cancel = function () {
                        modalInstance.dismiss('cancel');
                    };
                });
            }else{
                var error_message = "";
                $scope.print_values = {
                    layout:layout,order_package_id:order_package_id,to_ship_qty:to_ship_qty,product_id:product_id,master_product_id:master_product_id,
                    order_id:order_id,pickpack_slip_id:pickpack_slip_id,error_message:error_message,width:width,height:height,user_orientation_id:user_orientation_id,printer:60,wfp_image_s3_status:wfp_image_s3_status,hi_res_image_id:hi_res_image_id
                };

                var modalInstance = $modal.open({
                    templateUrl: '/app/pickpack/partials/print_wfp_ftp_canvas.html',
                    controller: 'onPrintWfpFtpModalCtrl',
                    resolve: {
                        print_values: function () {
                            return $scope.print_values;
                        }
                    }
                }).result.then(function(result){
                    //$scope.tracking_number = result;
                });

                vm.cancel = function () {
                    modalInstance.dismiss('cancel');
                };
            }

            
        }

    }
})();

(function() {
    'use strict';
    var controllerId = 'onPrintWfpFtpModalCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$modalInstance','print_values', onPrintWfpFtpModalCtrl]);

    function onPrintWfpFtpModalCtrl(common, datacontext, $scope, $modalInstance, print_values) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');
        var vm = this;

        $scope.layout = print_values.layout;
        $scope.order_package_id = print_values.order_package_id;
        $scope.to_ship_qty = print_values.to_ship_qty;
        $scope.product_id = print_values.product_id;
        $scope.category_id = print_values.category_id;
        $scope.master_product_id = print_values.master_product_id;
        $scope.order_id = print_values.order_id;
        $scope.pickpack_slip_id = print_values.pickpack_slip_id;
        $scope.error_message = print_values.error_message;
        $scope.width = print_values.width;
        $scope.height = print_values.height;
        $scope.user_orientation_id = print_values.user_orientation_id;
        $scope.wfp_image_s3_status = print_values.wfp_image_s3_status;
        $scope.printer = print_values.printer;
        $scope.pod_dimension_id = print_values.pod_dimension_id;
        $scope.hi_res_image_id = print_values.hi_res_image_id;
        //$scope.printer = 4;

        $scope.printer_name = '';

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
        $scope.swapDimensions = function(product_id, width, height){
          console.log(product_id+':'+width+':'+height);

          var itemDataSwap = {
                product_id: product_id,
                width: width,
                height: height};
          datacontext.swap_dimensions(itemDataSwap).success(function(response) {
              log_success("Image width and height swapped!");
              //submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id);
              // close it
              //$modalInstance.close();
          });
        };
        $scope.submit_print_wfp = function(layout, order_package_id, to_ship_qty, product_id, master_product_id, order_id,pickpack_slip_id,printer,category_id,pod_dimension_id,user_orientation_id,width,height,hi_res_image_id) {
          console.log(layout);
          console.log(product_id);
          console.log(master_product_id);
          console.log('printer'+printer);
          console.log('pod_dimension_id '+pod_dimension_id);

          if(printer == 20){
            $scope.printer_name = 'EPSON P20';
          }else if(printer == 60){
            $scope.printer_name = 'EPSON S60';
          }else if(printer == 82){
            $scope.printer_name = 'HP 8200';
          }else if(printer == 1640){
            $scope.printer_name = 'Canon Colorado';
          }


          if(master_product_id != 0){
            master_product_id = master_product_id;
          }
          if(!angular.isDefined(layout) || printer == 0 ){
            log_error("Please select Printer");
            $scope.error_message = "Please select Printer";
          }else if(!angular.isDefined(layout) ){
            log_error("Please select Layout");

          }else{
            if(layout == 1 || layout == true){
              if(master_product_id != 0){
                datacontext.print_wfp_regular(master_product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response) {
                    log_success("Image pushed to regular Printer " +$scope.printer_name);
                    submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                    // close it
                    $modalInstance.close();
                });
              }else{
                datacontext.print_wfp_regular(product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response) {
                    log_success("Image pushed to regular Printer " +$scope.printer_name);
                    submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                    // close it
                    $modalInstance.close();
                });
              }
            } else {
              if(master_product_id != 0){
                datacontext.print_wfp_rotate(master_product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response) {
                    log_success("Image pushed to rotate Printer " +$scope.printer_name);
                    submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                    // close it
                    $modalInstance.close();
                });
              }else{
                datacontext.print_wfp_rotate(product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response) {
                    log_success("Image pushed to rotate Printer " +$scope.printer_name);
                    submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                    // close it
                    $modalInstance.close();
                });
              }
            }
          }

        };
        $scope.submit_print_wfp_can = function(layout, order_package_id, to_ship_qty, product_id, category_id, master_product_id, order_id,pickpack_slip_id,printer,user_orientation_id,width,height,hi_res_image_id) {
          console.log(layout);
          console.log(product_id);
          console.log(master_product_id);

          if(printer == 20){
            $scope.printer_name = 'EPSON P20';
          }else if(printer == 60){
            $scope.printer_name = 'EPSON S60';
          }else if(printer == 82){
            $scope.printer_name = 'HP 8200';
          }else if(printer == 1640){
            $scope.printer_name = 'Canon Colorado';
          }

          if(master_product_id != 0){
            master_product_id = master_product_id;
          }
          if(!angular.isDefined(layout) ){
            log_error("Please select Layout");

          }else{
            if(layout == 1 || layout == true){
              if(master_product_id != 0){
                datacontext.print_wfp_regular_can(master_product_id,printer,user_orientation_id,width,height,product_id,category_id,hi_res_image_id).success(function(response) {
                    log_success("Image pushed to regular Printer " +$scope.printer_name);
                    submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                    // close it
                    $modalInstance.close();
                });
              }else{
                datacontext.print_wfp_regular_can(product_id,printer,user_orientation_id,width,height,product_id,category_id,hi_res_image_id).success(function(response) {
                    log_success("Image pushed to regular Printer " +$scope.printer_name);
                    submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                    // close it
                    $modalInstance.close();
                });
              }
            } else {
              if(master_product_id != 0){
                datacontext.print_wfp_rotate_can(master_product_id,printer,user_orientation_id,width,height,product_id,category_id,hi_res_image_id).success(function(response) {
                    log_success("Image pushed to rotate Printer " +$scope.printer_name);
                    submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                    // close it
                    $modalInstance.close();
                });
              }else{
                datacontext.print_wfp_rotate_can(product_id,printer,user_orientation_id,width,height,product_id,category_id,hi_res_image_id).success(function(response) {
                    log_success("Image pushed to rotate Printer " +$scope.printer_name);
                    submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                    // close it
                    $modalInstance.close();
                });
              }
            }
          }

        };

        $scope.submit_print_wfp_hp = function(layout, order_package_id, to_ship_qty, product_id, master_product_id, order_id, pickpack_slip_id, printer, category_id, pod_dimension_id, user_orientation_id, width, height, hi_res_image_id) {
            console.log(layout);
            console.log(product_id);
            console.log(master_product_id);
            console.log('printer '+printer);
            //console.log('pod_dimension_id '+pod_dimension_id);

            if(printer == 20){
                $scope.printer_name = 'EPSON P20';
            }else if(printer == 60){
                $scope.printer_name = 'EPSON S60';
            }else if(printer == 82){
                $scope.printer_name = 'HP 8200';
            }else if(printer == 1640){
                $scope.printer_name = 'Canon Colorado';
            }

            if(master_product_id != 0){
                master_product_id = master_product_id;
            }

            if(!angular.isDefined(layout) || printer == 0){
                log_error("Please select HP Printer");
                $scope.error_message = "Please select Printer";
            }else if(!angular.isDefined(layout)){
                log_error("Please selecct Layout");
            }else{
                if(layout == 1 || layout == true){
                    if(master_product_id != 0){
                        datacontext.print_wfp_hp_regular(master_product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response){
                            log_success("Image pushed to regular Printer " +$scope.printer_name);
                            submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                            //close it
                            $modalInstance.close();
                        });
                    }else{
                        datacontext.print_wfp_hp_regular(product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response){
                            log_success("Image pushed to regular Printer " +$scope.printer_name);
                            submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                            // close it
                            $modalInstance.close();
                        });
                    }
                }else{
                    if(master_product_id != 0){
                        datacontext.print_wfp_hp_rotate(master_product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response){
                            console.log(response);
                            log_success("Image pushed to rotate Printer " +$scope.printer_name);
                            submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                            // close it
                            $modalInstance.close();
                        });
                    }else{
                        datacontext.print_wfp_hp_rotate(product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response){
                            console.log(response);
                            log_success("Image pushed to rotate Printer " +$scope.printer_name);
                            submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                            // close it
                            $modalInstance.close();
                        });
                    }
                }
            }
        };

        $scope.submit_print_wfp_777_1 = function(layout, order_package_id, to_ship_qty, product_id, master_product_id, order_id, pickpack_slip_id, printer, category_id, pod_dimension_id, user_orientation_id, width, height, hi_res_image_id) {
            console.log(layout);
            console.log(product_id);
            console.log(master_product_id);
            console.log('printer '+printer);
            //console.log('pod_dimension_id '+pod_dimension_id);

            if(printer == 20){
                $scope.printer_name = 'EPSON P20';
            }else if(printer == 60){
                $scope.printer_name = 'EPSON S60';
            }else if(printer == 70){
                $scope.printer_name = 'EPSON 777-1';
            }else if(printer == 71){
                $scope.printer_name = 'EPSON 777-2';
            }else if(printer == 72){
                $scope.printer_name = 'EPSON 777-3';
            }else if(printer == 82){
                $scope.printer_name = 'HP 8200';
            }else if(printer == 1640){
                $scope.printer_name = 'Canon Colorado';
            }

            if(master_product_id != 0){
                master_product_id = master_product_id;
            }

            if(!angular.isDefined(layout) || printer == 0){
                log_error("Please select HP Printer");
                $scope.error_message = "Please select Printer";
            }else if(!angular.isDefined(layout)){
                log_error("Please selecct Layout");
            }else{
                if(layout == 1 || layout == true){
                    if(master_product_id != 0){
                        datacontext.print_wfp_epson_777_1_regular(master_product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response){
                            log_success("Image pushed to regular Printer " +$scope.printer_name);
                            submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                            //close it
                            $modalInstance.close();
                        });
                    }else{
                        datacontext.print_wfp_epson_777_1_regular(product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response){
                            log_success("Image pushed to regular Printer " +$scope.printer_name);
                            submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                            // close it
                            $modalInstance.close();
                        });
                    }
                }else{
                    if(master_product_id != 0){
                        datacontext.print_wfp_epson_777_1_rotate(master_product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response){
                            log_success("Image pushed to rotate Printer " +$scope.printer_name);
                            submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                            // close it
                            $modalInstance.close();
                        });
                    }else{
                        datacontext.print_wfp_epson_777_1_rotate(product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response){
                            log_success("Image pushed to rotate Printer " +$scope.printer_name);
                            submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                            // close it
                            $modalInstance.close();
                        });
                    }
                }
            }
        };

        $scope.submit_print_wfp_777_2 = function(layout, order_package_id, to_ship_qty, product_id, master_product_id, order_id, pickpack_slip_id, printer, category_id, pod_dimension_id, user_orientation_id, width, height, hi_res_image_id) {
            console.log(layout);
            console.log(product_id);
            console.log(master_product_id);
            console.log('printer '+printer);
            //console.log('pod_dimension_id '+pod_dimension_id);

            if(printer == 20){
                $scope.printer_name = 'EPSON P20';
            }else if(printer == 60){
                $scope.printer_name = 'EPSON S60';
            }else if(printer == 70){
                $scope.printer_name = 'EPSON 777-1';
            }else if(printer == 71){
                $scope.printer_name = 'EPSON 777-2';
            }else if(printer == 72){
                $scope.printer_name = 'EPSON 777-3';
            }else if(printer == 82){
                $scope.printer_name = 'HP 8200';
            }else if(printer == 1640){
                $scope.printer_name = 'Canon Colorado';
            }

            if(master_product_id != 0){
                master_product_id = master_product_id;
            }

            if(!angular.isDefined(layout) || printer == 0){
                log_error("Please select HP Printer");
                $scope.error_message = "Please select Printer";
            }else if(!angular.isDefined(layout)){
                log_error("Please selecct Layout");
            }else{
                if(layout == 1 || layout == true){
                    if(master_product_id != 0){
                        datacontext.print_wfp_epson_777_2_regular(master_product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response){
                            log_success("Image pushed to regular Printer " +$scope.printer_name);
                            submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                            //close it
                            $modalInstance.close();
                        });
                    }else{
                        datacontext.print_wfp_epson_777_2_regular(product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response){
                            log_success("Image pushed to regular Printer " +$scope.printer_name);
                            submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                            // close it
                            $modalInstance.close();
                        });
                    }
                }else{
                    if(master_product_id != 0){
                        datacontext.print_wfp_epson_777_2_rotate(master_product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response){
                            log_success("Image pushed to rotate Printer " +$scope.printer_name);
                            submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                            // close it
                            $modalInstance.close();
                        });
                    }else{
                        datacontext.print_wfp_epson_777_2_rotate(product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response){
                            log_success("Image pushed to rotate Printer " +$scope.printer_name);
                            submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                            // close it
                            $modalInstance.close();
                        });
                    }
                }
            }
        };

        $scope.submit_print_wfp_777_3 = function(layout, order_package_id, to_ship_qty, product_id, master_product_id, order_id, pickpack_slip_id, printer, category_id, pod_dimension_id, user_orientation_id, width, height, hi_res_image_id) {
            console.log(layout);
            console.log(product_id);
            console.log(master_product_id);
            console.log('printer '+printer);
            //console.log('pod_dimension_id '+pod_dimension_id);

            if(printer == 20){
                $scope.printer_name = 'EPSON P20';
            }else if(printer == 60){
                $scope.printer_name = 'EPSON S60';
            }else if(printer == 70){
                $scope.printer_name = 'EPSON 777-1';
            }else if(printer == 71){
                $scope.printer_name = 'EPSON 777-2';
            }else if(printer == 72){
                $scope.printer_name = 'EPSON 777-3';
            }else if(printer == 82){
                $scope.printer_name = 'HP 8200';
            }else if(printer == 1640){
                $scope.printer_name = 'Canon Colorado';
            }

            if(master_product_id != 0){
                master_product_id = master_product_id;
            }

            if(!angular.isDefined(layout) || printer == 0){
                log_error("Please select HP Printer");
                $scope.error_message = "Please select Printer";
            }else if(!angular.isDefined(layout)){
                log_error("Please selecct Layout");
            }else{
                if(layout == 1 || layout == true){
                    if(master_product_id != 0){
                        datacontext.print_wfp_epson_777_3_regular(master_product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response){
                            log_success("Image pushed to regular Printer " +$scope.printer_name);
                            submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                            //close it
                            $modalInstance.close();
                        });
                    }else{
                        datacontext.print_wfp_epson_777_3_regular(product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response){
                            log_success("Image pushed to regular Printer " +$scope.printer_name);
                            submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                            // close it
                            $modalInstance.close();
                        });
                    }
                }else{
                    if(master_product_id != 0){
                        datacontext.print_wfp_epson_777_3_rotate(master_product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response){
                            log_success("Image pushed to rotate Printer " +$scope.printer_name);
                            submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                            // close it
                            $modalInstance.close();
                        });
                    }else{
                        datacontext.print_wfp_epson_777_3_rotate(product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response){
                            log_success("Image pushed to rotate Printer " +$scope.printer_name);
                            submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                            // close it
                            $modalInstance.close();
                        });
                    }
                }
            }
        };

        $scope.submit_print_wfp_777_4 = function(layout, order_package_id, to_ship_qty, product_id, master_product_id, order_id, pickpack_slip_id, printer, category_id, pod_dimension_id, user_orientation_id, width, height, hi_res_image_id) {
            console.log(layout);
            console.log(product_id);
            console.log(master_product_id);
            console.log('printer '+printer);
            //console.log('pod_dimension_id '+pod_dimension_id);

            if(printer == 20){
                $scope.printer_name = 'EPSON P20';
            }else if(printer == 60){
                $scope.printer_name = 'EPSON S60';
            }else if(printer == 70){
                $scope.printer_name = 'EPSON 777-1';
            }else if(printer == 71){
                $scope.printer_name = 'EPSON 777-2';
            }else if(printer == 72){
                $scope.printer_name = 'EPSON 777-3';
            }else if(printer == 73){
                $scope.printer_name = 'EPSON 777-4';
            }else if(printer == 82){
                $scope.printer_name = 'HP 8200';
            }else if(printer == 1640){
                $scope.printer_name = 'Canon Colorado';
            }

            if(master_product_id != 0){
                master_product_id = master_product_id;
            }

            if(!angular.isDefined(layout) || printer == 0){
                log_error("Please select HP Printer");
                $scope.error_message = "Please select Printer";
            }else if(!angular.isDefined(layout)){
                log_error("Please selecct Layout");
            }else{
                if(layout == 1 || layout == true){
                    if(master_product_id != 0){
                        datacontext.print_wfp_epson_777_4_regular(master_product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response){
                            log_success("Image pushed to regular Printer " +$scope.printer_name);
                            submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                            //close it
                            $modalInstance.close();
                        });
                    }else{
                        datacontext.print_wfp_epson_777_4_regular(product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response){
                            log_success("Image pushed to regular Printer " +$scope.printer_name);
                            submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                            // close it
                            $modalInstance.close();
                        });
                    }
                }else{
                    if(master_product_id != 0){
                        datacontext.print_wfp_epson_777_4_rotate(master_product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response){
                            log_success("Image pushed to rotate Printer " +$scope.printer_name);
                            submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                            // close it
                            $modalInstance.close();
                        });
                    }else{
                        datacontext.print_wfp_epson_777_4_rotate(product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response){
                            log_success("Image pushed to rotate Printer " +$scope.printer_name);
                            submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                            // close it
                            $modalInstance.close();
                        });
                    }
                }
            }
        };

        $scope.submit_print_wfp_777_5 = function(layout, order_package_id, to_ship_qty, product_id, master_product_id, order_id, pickpack_slip_id, printer, category_id, pod_dimension_id, user_orientation_id, width, height, hi_res_image_id) {
            console.log(layout);
            console.log(product_id);
            console.log(master_product_id);
            console.log('printer '+printer);
            //console.log('pod_dimension_id '+pod_dimension_id);

            if(printer == 20){
                $scope.printer_name = 'EPSON P20';
            }else if(printer == 60){
                $scope.printer_name = 'EPSON S60';
            }else if(printer == 70){
                $scope.printer_name = 'EPSON 777-1';
            }else if(printer == 71){
                $scope.printer_name = 'EPSON 777-2';
            }else if(printer == 72){
                $scope.printer_name = 'EPSON 777-3';
            }else if(printer == 73){
                $scope.printer_name = 'EPSON 777-4';
            }else if(printer == 74){
                $scope.printer_name = 'EPSON 777-5';
            }else if(printer == 75){
                $scope.printer_name = 'EPSON 777-6';

            }else if(printer == 82){
                $scope.printer_name = 'HP 8200';
            }else if(printer == 1640){
                $scope.printer_name = 'Canon Colorado';
            }

            if(master_product_id != 0){
                master_product_id = master_product_id;
            }

            if(!angular.isDefined(layout) || printer == 0){
                log_error("Please select HP Printer");
                $scope.error_message = "Please select Printer";
            }else if(!angular.isDefined(layout)){
                log_error("Please selecct Layout");
            }else{
                if(layout == 1 || layout == true){
                    if(master_product_id != 0){
                        datacontext.print_wfp_epson_777_5_regular(master_product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response){
                            log_success("Image pushed to regular Printer " +$scope.printer_name);
                            submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                            //close it
                            $modalInstance.close();
                        });
                    }else{
                        datacontext.print_wfp_epson_777_5_regular(product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response){
                            log_success("Image pushed to regular Printer " +$scope.printer_name);
                            submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                            // close it
                            $modalInstance.close();
                        });
                    }
                }else{
                    if(master_product_id != 0){
                        datacontext.print_wfp_epson_777_5_rotate(master_product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response){
                            log_success("Image pushed to rotate Printer " +$scope.printer_name);
                            submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                            // close it
                            $modalInstance.close();
                        });
                    }else{
                        datacontext.print_wfp_epson_777_5_rotate(product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response){
                            log_success("Image pushed to rotate Printer " +$scope.printer_name);
                            submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                            // close it
                            $modalInstance.close();
                        });
                    }
                }
            }
        };

        $scope.submit_print_wfp_777_6 = function(layout, order_package_id, to_ship_qty, product_id, master_product_id, order_id, pickpack_slip_id, printer, category_id, pod_dimension_id, user_orientation_id, width, height, hi_res_image_id) {
            console.log(layout);
            console.log(product_id);
            console.log(master_product_id);
            console.log('printer '+printer);
            //console.log('pod_dimension_id '+pod_dimension_id);

            if(printer == 20){
                $scope.printer_name = 'EPSON P20';
            }else if(printer == 60){
                $scope.printer_name = 'EPSON S60';
            }else if(printer == 70){
                $scope.printer_name = 'EPSON 777-1';
            }else if(printer == 71){
                $scope.printer_name = 'EPSON 777-2';
            }else if(printer == 72){
                $scope.printer_name = 'EPSON 777-3';
            }else if(printer == 73){
                $scope.printer_name = 'EPSON 777-4';
            }else if(printer == 74){
                $scope.printer_name = 'EPSON 777-5';
            }else if(printer == 75){
                $scope.printer_name = 'EPSON 777-6';

            }else if(printer == 82){
                $scope.printer_name = 'HP 8200';
            }else if(printer == 1640){
                $scope.printer_name = 'Canon Colorado';
            }

            if(master_product_id != 0){
                master_product_id = master_product_id;
            }

            if(!angular.isDefined(layout) || printer == 0){
                log_error("Please select HP Printer");
                $scope.error_message = "Please select Printer";
            }else if(!angular.isDefined(layout)){
                log_error("Please selecct Layout");
            }else{
                if(layout == 1 || layout == true){
                    if(master_product_id != 0){
                        datacontext.print_wfp_epson_777_6_regular(master_product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response){
                            log_success("Image pushed to regular Printer " +$scope.printer_name);
                            submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                            //close it
                            $modalInstance.close();
                        });
                    }else{
                        datacontext.print_wfp_epson_777_6_regular(product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response){
                            log_success("Image pushed to regular Printer " +$scope.printer_name);
                            submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                            // close it
                            $modalInstance.close();
                        });
                    }
                }else{
                    if(master_product_id != 0){
                        datacontext.print_wfp_epson_777_6_rotate(master_product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response){
                            log_success("Image pushed to rotate Printer " +$scope.printer_name);
                            submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                            // close it
                            $modalInstance.close();
                        });
                    }else{
                        datacontext.print_wfp_epson_777_6_rotate(product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response){
                            log_success("Image pushed to rotate Printer " +$scope.printer_name);
                            submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                            // close it
                            $modalInstance.close();
                        });
                    }
                }
            }
        };

        $scope.submit_print_wfp_canvas = function(layout, order_package_id, to_ship_qty, product_id, master_product_id, order_id,pickpack_slip_id,printer,user_orientation_id,width,height,hi_res_image_id) {
            console.log(layout);
            console.log(product_id);
            console.log(master_product_id);
            console.log('printer'+printer);

            if(printer == 20){
                $scope.printer_name = 'EPSON P20';
            }else if(printer == 60){
                $scope.printer_name = 'EPSON S60';
            }else if(printer == 82){
                $scope.printer_name = 'HP 8200';
            }else if(printer == 1640){
                $scope.printer_name = 'Canon Colorado';
            }
            
            if(master_product_id != 0){
                master_product_id = master_product_id;
            }
            if(!angular.isDefined(layout) || printer == 0 ){
                log_error("Please select Printer");
                $scope.error_message = "Please select Printer";
            }else if(!angular.isDefined(layout) ){
                log_error("Please select Layout");

            }else{
                if(layout == 1 || layout == true){
                    if(master_product_id != 0){
                        datacontext.print_wfp_canvas_regular(master_product_id,printer,user_orientation_id,width,height,product_id,hi_res_image_id).success(function(response) {
                            log_success("Image pushed to regular Printer " +$scope.printer_name);
                            submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                            // close it
                            $modalInstance.close();
                        });
                    }else{
                        datacontext.print_wfp_canvas_regular(product_id,printer,user_orientation_id,width,height,product_id,hi_res_image_id).success(function(response) {
                            log_success("Image pushed to regular Printer " +$scope.printer_name);
                            submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                            // close it
                            $modalInstance.close();
                        });
                    }
                } else {
                    if(master_product_id != 0){
                        datacontext.print_wfp_canvas_rotate(master_product_id,printer,user_orientation_id,width,height,product_id,hi_res_image_id).success(function(response) {
                            log_success("Image pushed to rotate Printer " +$scope.printer_name);
                            submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                            // close it
                            $modalInstance.close();
                        });
                    }else{
                        datacontext.print_wfp_canvas_rotate(product_id,printer,user_orientation_id,width,height,product_id,hi_res_image_id).success(function(response) {
                            log_success("Image pushed to rotate Printer " +$scope.printer_name);
                            submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id,1);
                            // close it
                            $modalInstance.close();
                        });
                    }
                }
            }

        };


        function submit_pick(order_package_id,picked_qty,product_id,order_id,pickpack_slip_id,is_printed) {
        	console.log(order_package_id);
        	console.log(picked_qty);

        	var itemData = {
                pickpack_slip_id: pickpack_slip_id,
                qty_picked: picked_qty,
                is_picked: 1,
                product_id: product_id,
                order_id:order_id,
                order_package_id: order_package_id,
                frompick: 1,
                is_printed: is_printed
            };


            //vm.submitted = true;

            	// Update Pick Item
                datacontext.update_pick_list_wfp(itemData).success(function(httpResult) {

                        // Returns list of Pick / Pack slips
                        if (httpResult.success === true) {
                        	//console.log("true");
                          // var data = {
                          //     pickpack_slip_id : pickpack_slip_id
                          // };
                          // datacontext.updatepremiumCnt(data).then(function (httpResult) {
                          // });
                        	location.reload();
                        } else {
                          //console.log("false");
                        }
                    });

        }

    }
})();

(function() {
    'use strict';
    var controllerId = 'pickListCntl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$window', '$modal', '$routeParams', '$cookies', pickListCntl]);

    function pickListCntl(common, datacontext, $scope, $window, $modal, $routeParams, $cookies) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.user_name = $cookies.get('user_name');
        $cookies.put('last_list', vm.slip_id);
        vm.picklist = [];
        vm.title = 'Pick List';
        vm.slip_id = $routeParams.pid;
        vm.alerts = [];
        vm.pick_items_left = 0;
        vm.submitted = false;
        vm.btn_step = 'pick';
        vm.pickpack_order = 1;
        vm.loading = false;
        activate();

        function activate() {
            var promises = [
                get_pick_list(),
                assignList()
            ];
            common.activateController(promises, controllerId)
                .then(function() {
                     // log('Activated Pick List Views');
                });
        }

        function assignList() {
            datacontext.get_pickpack_slips({pickpack_slip_id:vm.slip_id}).success(function(httpResult) {
              vm.pod_cnt = 0;
              console.log(httpResult.data[0]);
              vm.pod_cnt = httpResult.data[0].pod_cnt;
              if(vm.pod_cnt > 0){
                    var modalInstance = $modal.open({
                          scope:$scope,
                          template: "<div><b>ALERT! {{vm.pod_cnt}} UNPRINTED ITEMS FOUND</b><br></div><div style='float:right;'><button ng-click='cancel()'>I got it!</button></div>",
                          controller: function(){
                              $scope.cancel = function(){
                                modalInstance.dismiss('cancel');
                              };
                          }
                      });
                  }

                if ( httpResult.data[0].pickpack_status_id === 1) {
                  if(vm.pod_cnt > 0){
                    var payload = {
                        pickpack_slip_id: vm.slip_id,
                        start_pick: 1,
                        pod_cnt_alert: vm.pod_cnt
                    };
                  }else{
                    var payload = {
                        pickpack_slip_id: vm.slip_id,
                        start_pick: 1
                    };
                  }

                    datacontext.updatePickPackSlip(payload).success(function() {});
                }
                console.log(httpResult);
                if(angular.isDefined(httpResult.ERRORMULTI)){
                    vm.ERRORMULTI = httpResult.ERRORMULTI;
                }

            });
        }

        function get_pick_list() {
            return datacontext.get_pick_list(vm.slip_id).then(function(httpResult) {
                vm.picklist = httpResult.data.data;
                console.log(httpResult.data.AUTO_CUBBY);
                vm.picklist.auto_cubby = httpResult.data.AUTO_CUBBY;
                vm.picklist.manual_cubby = httpResult.data.MANUAL_CUBBY;

                if(angular.isDefined(vm.picklist[0]) && vm.picklist[0].ship_method_id === 20){
                    get_waybill_num();
                }

                // set default
                vm.location_switched = 0;
                vm.location_is_backshelf = 0;
                vm.location_oos = 0;
                // get count
                vm.pick_items_left = httpResult.data.count;

                if ( vm.pick_items_left > 0) {
                    // check if location empty with indicates change

                        // don't need to notify on just change
                        if ( vm.picklist[0].locations.length > 0) {
                            // don't need to notify on just change
                            // vm.location_switched = 1;
                            // has secondary location

                            // reverse array so last in as lowest priority_id
                            for (var i in vm.picklist[0].locations.reverse()) {
                                vm.location_is_backshelf = 0;
                                var is_backshelf = 1;

                                if(vm.picklist[0].locations[i].location_type_id === 30 && vm.picklist[0].pickpack_type_id === 11){
                                	vm.picklist[0].picked_loc_prod_id_new = vm.picklist[0].locations[i].loc_prod_id;

                                }
                                if(vm.picklist[0].locations[i].location_type_id === 27 && vm.picklist[0].locations[i].location_on_hand === 0){
                                	vm.location_m_oos = 1;
                                  vm.oos_m_pid = vm.picklist[0].locations[i].product_id;
                                }
                                else if ( vm.picklist[0].locations[i].priority_id <= 5 && ( angular.isDefined(vm.picklist[0].picked_loc_prod_id_new) === false  || vm.picklist[0].pickpack_type_id !== 11) ) {
                                    is_backshelf = 0;
                                    vm.picklist[0].picked_loc_prod_id_new = vm.picklist[0].locations[i].loc_prod_id;

                                } else {
                                    var backshelf_location = vm.picklist[0].locations[i].loc_prod_id;
                                }

                                if ( is_backshelf ) {
                                    vm.location_is_backshelf = is_backshelf;
                                    vm.picklist[0].picked_loc_prod_id = backshelf_location;
                                }
                            }
                            if(angular.isDefined(vm.picklist[0].picked_loc_prod_id_new) === true){
                            	vm.picklist[0].picked_loc_prod_id = vm.picklist[0].picked_loc_prod_id_new;
                            }
                            if(vm.location_m_oos === 1){
                              $scope.pickpack_item = {
                                  pickpack_slip_id: vm.slip_id,
                                  pid: vm.oos_m_pid};
                              var modalInstance = $modal.open({
                                  templateUrl: '/app/pickpack/partials/backstock_m.html',
                                  controller:"backstockMCtrl",
                                  backdrop  : 'static',
                                  keyboard  : false,
                                  windowClass:'small',
                                  resolve: {
                                    pickpackItem: function () {
                                      return $scope.pickpack_item;
                                    }
                                  }
                              }).result.then(function(){

                              });

                              vm.cancel = function () {
                                  modalInstance.dismiss('cancel');
                              };
                            }

                        } else {
                            // out of stock ???
                            vm.location_oos = 1;
                            vm.picklist[0].picked_loc_prod_id = 0;
                        }
                        console.log(vm);
                }

            });
        }

        function get_waybill_num() {
            // get todays fedEx waybill num
            return datacontext.get_waybill_num({}).then(function(httpResult) {
                console.log("waybill",httpResult);
                console.log(httpResult.data.data.length);
                if(httpResult.data.data === 0){
                    // merge order item w/order items
                    var modalInstance = $modal.open({
                        templateUrl: '/app/pickpack/partials/fedex_waybill.html',
                        controller:"fedexWaybillCtrl",
                        backdrop  : 'static',
                        keyboard  : false,
                        windowClass:'small'
                    }).result.then(function(){

                    });

                    vm.cancel = function () {
                        modalInstance.dismiss('cancel');
                    };
                }

            });
        }

        function create_ship_label(itemData){

        	return datacontext.createShipLabel(itemData).success(function(httpResult) {
            	if (httpResult.success === true) {
                   console.log("true");

                } else {
                	console.log("false");
                    if(angular.isDefined(httpResult.data)){
                      log_error(httpResult.data);
                    }
                }
            });
        }
        $scope.is_just_picked = function(idx){
          console.log(vm.picklist[idx]);
          if ($window.confirm("Are you sure you want to ALERT as Just Picked?")){
            var data = vm.picklist[idx];
            var itemData = {
                  pickpack_slip_id: vm.slip_id,
                  product_title: data.product_title,
                  product_id: data.product_id,
                  picked_loc_prod_id: data.picked_loc_prod_id,
                  user_name: vm.user_name
              };
            if(vm.picklist[idx].just_picked){
              datacontext.is_just_picked(itemData).success(function(httpResult) {
              });
            }else{
              console.log(vm.picklist[idx].just_picked);
            }
          }
        };

        $scope.is_item_missing = function(idx){
            var data = vm.picklist[idx];
            if ($window.confirm("Are you sure you want to ALERT as ITEM MISSING?")){
                var itemData = {
                    pickpack_slip_id: vm.slip_id,
                    product_title: data.product_title,
                    product_id: data.product_id,
                    picked_loc_prod_id: data.picked_loc_prod_id,
                    user_name: vm.user_name
                };

                console.log(vm.picklist[idx]);
                if(vm.picklist[idx].item_missing){
                    datacontext.is_item_missing(itemData).success(function(httpResult) {});
                }
            }
        };

        $scope.submit_pick_update = function(data) {
            console.log("data heer");
            console.log(data);

            if(angular.isDefined(data.master_inv_pid)){
                var master_inv_pid = data.master_inv_pid;
            }else{
                var master_inv_pid = 0;
            }

            var itemData = {
                pickpack_slip_id: vm.slip_id,
                product_title: data.product_title,
                product_id: data.product_id,
                master_inv_pid: master_inv_pid,
                qty_ordered: data.qty_ordered,
                qty_picked: data.qty_picked,
                picked_loc_prod_id: data.picked_loc_prod_id,
                is_picked: 0,
                pickpack_order: data.pickpack_order,
                ship_method_id: data.ship_method_id,
                order_id: data.order_id,
                order_package_id: data.order_package_id,
                ship_to_address_id: data.ship_address_id,
                ship_address_country_id: data.ship_address_country_id,
                fulfillment_warehouse_id: data.fulfillment_warehouse_id,
                use_multi_cart: data.use_multi_cart,
                frompick: 1
            };

            vm.submitted = true;

            // todo check (remove ???) why we declared this in scope ??
            $scope.product_id = data.product_id;

            // check if form valid submitted blank qty packed
            if ($scope.pickForm.$invalid === false) {
                // Get current object
                var item_picked = itemData.product_title;
                // Pack Form ok we can go ahead now and update
                // Check if picker is short packing

                if (vm.btn_step === 'pick' && itemData.qty_ordered !== Number(itemData.qty_picked)) {
                    vm.btn_step = 'CONFIRM';
                vm.submitted = false;
                } else {
                    // Check if updating last one
                    if (vm.picklist.length === 1) {
                        itemData.is_picked = 1;
                    }

                    // reset submit flag
                    vm.submitted = false;
                    vm.btn_step = 'picked';
                    
                    // Update Pick Item
                    datacontext.update_pick_list(itemData).success(function(httpResult) {
                        // Returns list of Pick / Pack slips
                        if (httpResult.success === true) {
                            //if(itemData.qty_ordered !== Number(itemData.qty_picked) && vm.btn_step === 'CONFIRM'){
                            datacontext.add_location_audit(itemData).success(function() {
                    			if (httpResult.success === false) {
                    				log('No product location found!');
                    			}
                            });
                            //}

                            // Reset: clear submission for next item
                            vm.btn_step = 'pick';
                            vm.submitted = 'false';

                            // Alert User Item Packed
                            vm.alerts = [{
                                type: "success_panel",
                                msg: itemData.qty_picked + ' x ' + itemData.product_title + ' Picked'
                            }];

                            // refresh page
                            get_pick_list();
                            //changing shipping method to fedex Int for international for multi only //completely commenting this //opening for laminations Int
                            if(itemData.ship_address_country_id !== 1 && itemData.ship_method_id !== 15 && itemData.ship_method_id !== 22){
                                itemData.ship_method_id = 26;
                                var submitform = {
                                    order_package_id: itemData.order_package_id,
                                    ship_method_id: itemData.ship_method_id,
                                    order_id: itemData.order_id
                                };

                                datacontext.updateOrderPackage(submitform).then(function() {});
                            }

                            // || itemData.ship_method_id === 20
                            if(itemData.ship_method_id === 1 || itemData.ship_method_id === 15 || itemData.ship_method_id === 4 || itemData.ship_method_id === 18){
                            	create_ship_label(itemData);
                            }
                        } else {
                            //$scope.errors.push(result.error);
                            $scope.alerts = [{
                                type: 'error_panel',
                                msg: 'error' + item_picked
                            }];

                            // refresh page anyway
                            get_pick_list();

                            //changing shipping method to DHL for international
                            if(itemData.ship_address_country_id !== 1 && itemData.ship_method_id !== 15 && itemData.ship_method_id !== 22){
                                itemData.ship_method_id = 26;
                                var submitform = {
                                    order_package_id: itemData.order_package_id,
                                    ship_method_id: itemData.ship_method_id,
                                    order_id: itemData.order_id
                                };

                                datacontext.updateOrderPackage(submitform).then(function() {});
                            }

                            // || itemData.ship_method_id === 20
                            if(itemData.ship_method_id === 1 || itemData.ship_method_id === 15 || itemData.ship_method_id === 4 || itemData.ship_method_id === 18){
                                create_ship_label(itemData);
                            }
                        }
                    });
                    // rerun to make sure it stuck
                }
            } else {
                log('invalid form submitted');
            }
        };
    }
})();

(function() {
    'use strict';
    var controllerId = 'packItemCntl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$timeout', '$window', '$routeParams', '$position', '$modal', '$cookies', '$sce', packItemCntl]);

    function packItemCntl(common, datacontext, $scope, $timeout, $window, $routeParams, $position, $modal, $cookies, $sce) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');
        var vm = this;
        vm.user_name = $cookies.get('user_name');
        vm.user_id = $cookies.get('user_id');
        vm.label_load_time = 0;
        $scope.isDisabled = true;

        vm.packlist = [];
        vm.title = 'Pack List';
        vm.slip_id = $routeParams.pid;
        $cookies.put('last_list', vm.slip_id);
        vm.alerts = [];
        vm.orders_left = 0;
        vm.submitted = false;
        vm.has_shipping_code = true;
        vm.btn_step = 'pack';
        vm.label_host = '//s3.amazonaws.com/gco_bucket/shiplabels/';
        vm.rebel_label_host = 'https://ace.gothamcityonline.com/reports/temp7.cfm?tracking';
        vm.last_list = $cookies.get('last_list');
        activate();
        console.log(vm.slip_id);
        console.log(vm.last_list);
        $scope.pick_missed_count = 0;
        $scope.pick_extra_count = 0;
        function activate() {
            var promises = [
                getPackList(),
                assignList(),
                getPickPackItems()
            ];
            common.activateController(promises, controllerId)
                .then(function() {
                    // log('Activated Pack List View');
                });
        }

        $scope.checkShipRate = function(packshipssel){
            var packshipssel = packshipssel;
            var shipprice = packshipssel.split('|')[1];

            if( shipprice <= 25){
                $scope.isDisabled = false;
            }else{
                $scope.isDisabled = true;
            }
        };

        $scope.getTrackingUrl = function(o) {
            console.log(o);
            var url = 'https://ace.gothamcityonline.com/tasks/amz_rebelution/tracking_code_files/' +
                o +
                '.pdf#toolbar=0&navpanes=0';
            return $sce.trustAsResourceUrl(url);
        };

        function assignList() {
            // check current status before assigning to user
            datacontext.get_pickpack_slips({pickpack_slip_id:vm.slip_id}).success(function(httpResult) {
              vm.user_name = httpResult.USER_NAME;
              console.log(vm.user_name);
              console.log(httpResult.data[0]);
              vm.packed_by = httpResult.data[0].packed_by;
              vm.picked_by = httpResult.data[0].picked_by;
              vm.pod_printed_count = httpResult.data[0].pod_printed_count;
              vm.qty_picked = httpResult.data[0].qty_picked;
              vm.pick_missed_count = httpResult.data[0].pick_missed_count;
              vm.pick_extra_count = httpResult.data[0].pick_extra_count;
                if ( httpResult.data[0].pickpack_status_id === 3) {
                    var payload = {
                        pickpack_slip_id: vm.slip_id,
                        start_pack: 1
                    };
                    datacontext.updatePickPackSlip(payload).success(function() {});
                }
                if(angular.isDefined(httpResult.ERRORMULTI)){
                    vm.ERRORMULTI = httpResult.ERRORMULTI;
                }
            });
        }
        function getPackList() {
            return datacontext.getPackList({pickpack_slip_id:vm.slip_id}).then(function(httpResult) {
                vm.packlist = httpResult.data.data;
                vm.last_order_id = $cookies.get('last_order_id');
                vm.last_orderpackage_id = $cookies.get('last_orderpackage_id');
                vm.last_p_id = $cookies.get('last_p_id');
                vm.last_customer_name = $cookies.get('last_customer_name');
                vm.last_ordered_items = $cookies.get('last_ordered_items');
                vm.last_tracking_num = $cookies.get('last_tracking_num');
                console.log("last-items");
                console.log("vm.last_order_id"+vm.last_order_id);
                console.log("vm.last_orderpackage_id"+vm.last_orderpackage_id);
                console.log("vm.last_p_id"+vm.last_p_id);
                console.log("vm.last_customer_name"+vm.last_customer_name);
                console.log("vm.last_ordered_items"+vm.last_ordered_items);
                console.log("vm.last_tracking_num"+vm.last_tracking_num);

                if (angular.isDefined(vm.packlist[1])){
                    vm.next_cust_name = vm.packlist[1].ship_address.first_name + ' ' + vm.packlist[1].ship_address.last_name;
                }

                if (angular.isDefined(vm.packlist[2])){
                    vm.last_cust_name = vm.packlist[2].ship_address.first_name + ' ' + vm.packlist[2].ship_address.last_name;
                }

                vm.Error_Code = '';
                vm.Error_Message = '';
                if(angular.isDefined(httpResult.data.ERROR_CODE)){
                  vm.Error_Code = httpResult.data.ERROR_CODE;
                }
                if(angular.isDefined(httpResult.data.ERROR_MESSAGE)){
                  vm.Error_Message = httpResult.data.ERROR_MESSAGE;
                }

                vm.packshipssel = httpResult.data.LOWESTSERVICEID+'|'+httpResult.data.LOWESTSHIPCOST;
                vm.is_packed_cnt = httpResult.data.IS_PACKED_CNT;
                vm.is_packed_cnt_v1 = httpResult.data.IS_PACKED_CNT_V1;
                vm.default_sort = httpResult.data.DEFAULT_SORT;
                vm.is_picked_cnt = httpResult.data.IS_PICKED_CNT;
                vm.to_ship_qty_cnt = httpResult.data.TO_SHIP_QTY_CNT;
                vm.act_pkg_qty_items = httpResult.data.ACT_PKG_QTY_ITEMS;
                vm.pkg_qty_items = httpResult.data.PKG_QTY_ITEMS;
                vm.order_status_id = httpResult.data.ORDER_STATUS_ID;

                if(angular.isDefined(httpResult.data.ORDER_STATUS_MSG) ){
                  vm.order_status_msg = httpResult.data.ORDER_STATUS_MSG;
                }

                if(angular.isDefined(httpResult.data.LOWESTSERVICEID) && httpResult.data.LOWESTSERVICEID !== 'undefined'){
                    $scope.checkShipRate(vm.packshipssel);
                }

                vm.packshippackage = '';
                vm.packships = httpResult.data.SHIPS;
                $scope.date = new Date();
                if(angular.isDefined(vm.packlist[0]) && vm.packlist[0].ship_method_id === 20){
                    get_waybill_num();
                }
                // if(angular.isDefined(vm.packlist[0])){
                //   var items_for_tube = vm.packlist[0].order_items;

                //   console.log(items_for_tube);

                //   var arrayLength = items_for_tube.length;
                //   var max_tube_length = 0;
                //   for (var i = 0; i < arrayLength; i++) {

                //     if(max_tube_length < items_for_tube[i].tube){
                //         max_tube_length = items_for_tube[i].tube;
                //     }

                //   }
                //   // if(max_tube_length > 0 ){
                //   //   vm.packshippackage = '12|15.5|0.5|3';
                //   //   $scope.selectPackageType(vm.packshippackage,vm.packlist[0].order_id,1,1,0,0);
                //   // }

                //   console.log(max_tube_length);

                //   if(vm.packlist[0].abs_override === 1){
                //         if(max_tube_length === 37){
                //             vm.packshippackage = '37|1.5|1.5|15';
                //             $scope.selectPackageType(vm.packshippackage,vm.packlist[0].order_id,1,1,0,0);
                //         }
                //         else if(max_tube_length === 40){
                //             vm.packshippackage = '40|3|3|15';
                //             $scope.selectPackageType(vm.packshippackage,vm.packlist[0].order_id,1,1,0,0);
                //         }else if(max_tube_length === 21.5){
                //             vm.packshippackage = '21.5|1.5|1.5|8';
                //             $scope.selectPackageType(vm.packshippackage,vm.packlist[0].order_id,1,1,0,0);
                //         }else if(vm.packlist[0].category_id === 21){
                //             vm.packshippackage = '15.5|9.5|0.5|6';
                //             $scope.selectPackageType(vm.packshippackage,vm.packlist[0].order_id,1,1,0,0);
                //         }else if (vm.packlist[0].order_items[0].pod_dimension_id === 4){
                //             vm.packshippackage = '25|1.5|1.5|6';
                //             $scope.selectPackageType(vm.packshippackage,vm.packlist[0].order_id,1,1,0,0);
                //         }else if (vm.packlist[0].category_id === 33){
                //             vm.packshippackage = '25|1.5|1.5|8';
                //             $scope.selectPackageType(vm.packshippackage,vm.packlist[0].order_id,1,1,0,0);
                //         }else{
                //             vm.packshippackage = '12|15.5|0.5|3';
                //             $scope.selectPackageType(vm.packshippackage,vm.packlist[0].order_id,1,1,0,0);
                //         }
                //   }
                //   else if(max_tube_length === 13){
                //     vm.packshippackage = '15.5|12|0.5|3';
                //     $scope.selectPackageType(vm.packshippackage,vm.packlist[0].order_id,1,1,0,0);
                //   }else if(max_tube_length === 25){
                //     vm.packshippackage = '25|1.5|1.5|8';
                //     $scope.selectPackageType(vm.packshippackage,vm.packlist[0].order_id,1,1,0,0);
                //   }else if(max_tube_length === 10){
                //     vm.packshippackage = '15.5|12|0.5|1';
                //     $scope.selectPackageType(vm.packshippackage,vm.packlist[0].order_id,1,1,0,0);
                //   }else if(max_tube_length === 99){
                //     vm.packshippackage = '15.5|12|0.5|3';
                //     $scope.selectPackageType(vm.packshippackage,vm.packlist[0].order_id,1,1,0,0);
                //   }
                // }

                if (angular.isDefined(vm.packlist[0])) {

                    datacontext.getPackageDimensions({
                        order_id: vm.packlist[0].order_id,
                        order_package_id: vm.packlist[0].order_package_id,
                        fulfillment_warehouse_id: vm.packlist[0].fulfillment_warehouse_id
                    }).then(function(httpResult) {

                        console.log('Package Dimensions:', httpResult);

                        if (httpResult.data.success === true) {

                            vm.packlist[0].packshippackage = httpResult.data.PACKSHIPPACKAGE;
                            vm.packlist[0].length = httpResult.data.LENGTH;
                            vm.packlist[0].width = httpResult.data.WIDTH;
                            vm.packlist[0].height = httpResult.data.HEIGHT;
                            vm.packlist[0].weight = httpResult.data.WEIGHT;

                            console.log('Package:', vm.packlist[0].packshippackage);
                            console.log('Length:', vm.packlist[0].length);
                            console.log('Width:', vm.packlist[0].width);
                            console.log('Height:', vm.packlist[0].height);
                            console.log('Weight:', vm.packlist[0].weight);

                            $scope.selectPackageType(
                                vm.packlist[0].packshippackage,
                                vm.packlist[0].order_id,
                                1,
                                vm.packlist[0].is_prime,
                                0,
                                1
                            );

                        } else {

                            log_error(httpResult.data.data);

                        }

                    });

                }


                
                if(vm.default_sort === 1){
                  var modalInstance = $modal.open({
                          scope:$scope,
                          template: "<div><b style='color:#ff0000 !important;'>This list was just resorted. Click here to refresh before packing!</b><br></div><div style='float:right;'><button ng-click='cancel()'>I got it!</button></div>",
                          controller: function(){
                              $scope.cancel = function(){
                                modalInstance.dismiss('cancel');
                                location.reload();
                              };
                          }
                      });
                }

                /*
                if(vm.packlist[0].store_id === 4 && vm.packlist[0].ship_address_country_id !== 1) {
                    var modalInstance = $modal.open({
                        scope:$scope,
                        template: "<div><b style='color:#ff0000 !important;'>International eBay Order. Create MANUAL ship label and give to manager.</b><br></div><div style='float:right;'><button ng-click='cancel()'>I got it!</button></div>",
                        controller: function(){
                          $scope.cancel = function(){
                            modalInstance.dismiss('cancel');
                            //location.reload();
                          };
                        },
                        backdrop: 'static'
                    });
                }

                // C410b -  UPDATE Fedex call for multi frames
                if((vm.packlist[0].category_id === 33 || vm.packlist[0].category_id === 46) && vm.packlist[0].order_items[0].pod_dimension_id === 2 && vm.packlist[0].ship_method_id === 16){
                    var modalInstance = $modal.open({
                        scope:$scope,
                        template: "<div><b>This order should ship with fedex smartpost and not UPS MI</b><br></div><div style='float:right;'><button ng-click='cancel()'>I got it!</button></div>",
                        controller: function(){
                            $scope.cancel = function(){
                                modalInstance.dismiss('cancel');
                            };
                        }
                    });
                }
                */

                if (angular.isDefined(vm.packlist[0])){
              		if(vm.packlist[0].packing_note.trim().length > 0 && vm.packlist[0].ship_service_level !== 'SecondDay'){
                    if(vm.packlist[0].packing_note.indexOf('DO NOT SHIP') > -1){
                      var modalInstance = $modal.open({
                              scope:$scope,
                              template: "<div><b style='color:#ff0000 !important;'>Packing Note: {{vm.packlist[0].packing_note}}</b><br></div><div style='float:right;'><button ng-click='cancel()'>I got it!</button></div>",
                              controller: function(){
                                  $scope.cancel = function(){
                                  	modalInstance.dismiss('cancel');
                                  };
                              }
                          });
                    }else if (vm.packlist[0].packing_note.indexOf('OK TO SHIP') > -1){
                      var modalInstance = $modal.open({
                              scope:$scope,
                              template: "<div><b style='color:green !important;'>Packing Note: {{vm.packlist[0].packing_note}}</b><br></div><div style='float:right;'><button ng-click='cancel()'>I got it!</button></div>",
                              controller: function(){
                                  $scope.cancel = function(){
                                  	modalInstance.dismiss('cancel');
                                  };
                              }
                          });
                    }else{
                      var modalInstance = $modal.open({
                              scope:$scope,
                              template: "<div><b>Packing Note: {{vm.packlist[0].packing_note}}</b><br></div><div style='float:right;'><button ng-click='cancel()'>I got it!</button></div>",
                              controller: function(){
                                  $scope.cancel = function(){
                                  	modalInstance.dismiss('cancel');
                                  };
                              }
                          });
                    }
                  	// var modalInstance = $modal.open({
                    //       scope:$scope,
                    //       template: "<div><b>{{vm.packlist[0].packing_note}}</b><br></div><div style='float:right;'><button ng-click='cancel()'>I got it!</button></div>",
                    //       controller: function(){
                    //           $scope.cancel = function(){
                    //           	modalInstance.dismiss('cancel');
                    //           };
                    //       }
                    //   });
                  }
                  if(vm.packlist[0].multi_order_issue === 1){
                  	var modalInstance = $modal.open({
                          scope:$scope,
                          template: "<div><b>This is Multi order, only 1 of Multi items appeared</b><br></div><div style='float:right;'><button ng-click='cancel()'>I got it!</button></div>",
                          controller: function(){
                              $scope.cancel = function(){
                              	modalInstance.dismiss('cancel');
                              };
                          }
                      });
                  }
                  if(vm.packlist[0].ship_address_country_id !== 1 && vm.packlist[0].category_id === 24){
                  	var modalInstance = $modal.open({
                          scope:$scope,
                          template: "<div><b>INTERNATIONAL ORDER WITH GIANT</b><br></div><div style='float:right;'><button ng-click='cancel()'>I got it!</button></div>",
                          controller: function(){
                              $scope.cancel = function(){
                              	modalInstance.dismiss('cancel');
                              };
                          }
                      });
                  }
                  if(vm.packlist[0].store_id === 15 && vm.packlist[0].ship_method_id === 21){
                  	var modalInstance = $modal.open({
                          scope:$scope,
                          template: "<div><b>WALMART ORDER - SHIP UPS Mail Innovations</b><br></div><div style='float:right;'><button ng-click='cancel()'>I got it!</button></div>",
                          controller: function(){
                              $scope.cancel = function(){
                              	modalInstance.dismiss('cancel');
                              };
                          }
                      });
                  }

                    if(vm.packlist[0].store_id === 4 && vm.packlist[0].ship_address_country_id !== 1) {
                        var modalInstance = $modal.open({
                            scope:$scope,
                            template: "<div><b style='color:#ff0000 !important;'>International eBay Order. Create MANUAL ship label and give to manager.</b><br></div><div style='float:right;'><button ng-click='cancel()'>I got it!</button></div>",
                            controller: function(){
                              $scope.cancel = function(){
                                modalInstance.dismiss('cancel');
                                //location.reload();
                              };
                            },
                            backdrop: 'static'
                        });
                    }

                    // C410b -  UPDATE Fedex call for multi frames
                    if((vm.packlist[0].category_id === 33 || vm.packlist[0].category_id === 46) && vm.packlist[0].order_items[0].pod_dimension_id === 2 && vm.packlist[0].ship_method_id === 16){
                        var modalInstance = $modal.open({
                            scope:$scope,
                            template: "<div><b>This order should ship with fedex smartpost and not UPS MI</b><br></div><div style='float:right;'><button ng-click='cancel()'>I got it!</button></div>",
                            controller: function(){
                                $scope.cancel = function(){
                                    modalInstance.dismiss('cancel');
                                };
                            }
                        });
                    }
              	}

                if (vm.packlist.length !== undefined) {
                    vm.orders_left = vm.packlist.length;
                } else {
                    vm.orders_left = 0;
                }
                $scope.pack_date = new Date();
            });
        }

        function getPickPackItems() {
            return datacontext.getPickPackItems({pickpack_slip_id:vm.slip_id,no_tracking_number:1}).then(function(httpResult) {

                //console.log(httpResult.data);
                vm.slips1 = httpResult.data.data;
            })
        }

        function get_waybill_num() {
            // get todays fedEx waybill num
            return datacontext.get_waybill_num({}).then(function(httpResult) {
                console.log("waybill",httpResult);
                console.log(httpResult.data);
                console.log(httpResult.data.data);
                if(httpResult.data.data === 0){
                    // merge order item w/order items
                    var modalInstance = $modal.open({
                        templateUrl: '/app/pickpack/partials/fedex_waybill.html',
                        controller:"fedexWaybillCtrl",
                        backdrop  : 'static',
                        keyboard  : false,
                        windowClass:'small'
                    }).result.then(function(){

                    });

                    vm.cancel = function () {
                        modalInstance.dismiss('cancel');
                    };
                }

            });
        }

        //package weight update //*** P089d - FRI - UPDATE weight override enter for null
        $scope.update_weight = function (weight,id){
           var formData = {
                package_weight:weight,
                order_package_id:id
           }
           return datacontext.updateOrderPackage(formData).then(function(response) {
                //update of package weight
                window.location.reload();
           })
        }

        $scope.is_abs_override = 0;
        //get eligible calls
        $scope.selectPackageType = function(packshippackage,order_id,multi,is_prime,idx,log) {
          console.log(packshippackage);
          console.log(order_id);
          console.log("idx:"+idx);
          console.log(vm.packlist[idx].abs_override);
          vm.api_online = vm.packlist[idx].api_online;

          if(vm.packlist[idx].abs_override === 1){
            $scope.is_abs_override = 1;
            $scope.isDisabled = true;
          }else{
            $scope.isDisabled = false;
          }

           if((is_prime === 1 || vm.packlist[idx].abs_override === 1 || vm.packlist[idx].ship_method_id === 32 || (vm.packlist[idx].ship_method_id == 4 && vm.packlist[idx].abs_override == 1)) 
               && vm.packlist[idx].api_online === 1 ){ //&& vm.packlist[idx].ship_method_id != 12

            return datacontext.getEligibleShips({order_id:order_id,packshippackage:packshippackage,multi:multi,idx:idx,log:log}).then(function(httpResult) {
                // vm.LOWESTSERVICEID = httpResult.data.LOWESTSERVICEID;
                // vm.LOWESTSHIPCOST = httpResult.data.LOWESTSHIPCOST;
                // vm.WEIGHT = httpResult.data.WEIGHT;
                // vm.packshipssel = httpResult.data.LOWESTSERVICEID+'|'+httpResult.data.LOWESTSHIPCOST;
                // vm.packships = httpResult.data.SHIPS;
                vm.loading = false;
                console.log(httpResult.data);

                if(angular.isDefined(httpResult.data.SHIP_METHOD_CHANGED) && httpResult.data.ERROR.length > 1){
                    vm.packlist[idx].TIMEOUT = 1;
                    vm.packlist[idx].ship_method_changed = httpResult.data.ERROR;
                    //log_error(httpResult.data.ERROR);
                }else if(angular.isDefined(httpResult.data.ERROR) && httpResult.data.ERROR.length > 1){
                    vm.packlist[idx].TIMEOUT = 1;
                    log_error(httpResult.data.ERROR);
                }else if(httpResult.data.TIMEOUT === 1){
                    vm.packlist[idx].TIMEOUT = 1;
                    log_error('ABS call timout or issue with Amazon, please create manual label for packing.!');
                }else{
                    vm.packlist[idx].LOWESTSERVICEID = httpResult.data.LOWESTSERVICEID;
                    if(httpResult.data.POSTAGE_LIMIT_EXCEED > 1){
                        vm.packlist[idx].POSTAGE_LIMIT_EXCEED = 1;
                        vm.packlist[idx].POSTAGE_LIMIT_EXCEED_ABS = 1;
                    }else{
                        vm.packlist[idx].POSTAGE_LIMIT_EXCEED = httpResult.data.POSTAGE_LIMIT_EXCEED;
                        vm.packlist[idx].POSTAGE_LIMIT_EXCEED_ABS = 0;
                    }

                    vm.packlist[idx].TIMEOUT = 0;
                    if(vm.packlist[idx].LOWESTSERVICEID === 'FEDEX_PTP_EXPRESS_SAVER_ONE_RATE'){
                        log_error('shipment is "FedEx OneRate"');
                    }else{
                        //log_error(vm.packlist[idx].LOWESTSERVICEID);
                    }
                    vm.packlist[idx].LOWESTSHIPCOST = httpResult.data.LOWESTSHIPCOST;
                    // vm.packlist[idx].weight = httpResult.data.WEIGHT;
                    // vm.packlist[idx].length = httpResult.data.LENGTH;
                    // vm.packlist[idx].packshipssel = httpResult.data.LOWESTSERVICEID+'|'+httpResult.data.LOWESTSHIPCOST;
                    vm.packlist[idx].packshippackage = packshippackage;
                    vm.packlist[idx].packships = httpResult.data.SHIPS;

                    var selectedShipping = vm.packlist[idx].packships.find(function(ship) {
                        return ship.SHIPPINGSERVICEID === 'std-us-swa-mfn';
                    });

                    if (selectedShipping) {
                        vm.packlist[idx].packshipssel =
                            selectedShipping.SHIPPINGSERVICEID + '|' + selectedShipping.SHIPRATE;
                    } else {
                        vm.packlist[idx].packshipssel =
                            httpResult.data.LOWESTSERVICEID + '|' +
                            httpResult.data.LOWESTSHIPCOST;
                    }

                    vm.packlist[idx].loading = false;
                    console.log(vm.packlist[idx]);

                    if(angular.isDefined(httpResult.data.LOWESTSERVICEID) && httpResult.data.LOWESTSERVICEID !== 'undefined'){
                        $scope.checkShipRate(vm.packlist[idx].packshipssel);  
                    }
                }
            });
        }

        };

        // todo: refactor this as its newbee code while learning angular
        // UPDATE PACKED ITEM QTY
        $scope.update_packed_items = function(idx) {

            // Set item packed for update
            vm.fulfillment_status_id = "";
            var order_id = vm.packlist[idx].order_id;
            var pickpack_slip_id = vm.packlist[idx].pickpack_slip_id;
            var items_packed = vm.packlist[idx].order_items;
            var arrayLength = items_packed.length;
            // check if last item and mark slip as done

            // Loop items and mark as packed
            var qty_ordered = 0;
            var qty_packed = 0;
            vm.update_success = true;

            // UPDATE QTY PICKED AND TRACKING NUMBER
            for (var i = 0; i < arrayLength; i++) {
                // add pickpack/order id to item array
                items_packed[i].pickpack_slip_id = pickpack_slip_id;
                items_packed[i].order_id = items_packed[i].order_id;
                items_packed[i].order_package_id = $scope.order_package_id;
                items_packed[i].package_item_id = items_packed[i].package_item_id;
                // sum up ordered
                qty_ordered = items_packed[i].qty_ordered + qty_ordered;
                // sum up packed
                qty_packed = items_packed[i].qty_packed + Number(qty_packed);
                items_packed[i].order_package_id = $scope.order_package_id;
                items_packed[i].only_packing = 1;
                items_packed[i].label_ready = items_packed[i].label_ready;

                console.log(items_packed[i]);

                // Update QTY Packed
                datacontext.update_pack_list(items_packed[i]).success(function(rSPQ) {
                    // Returns list of Pick / Pack slips
                    if (rSPQ.SUCCESS === true) {
                        //assign to cookie
                        $cookies.put('past_order_id', vm.packlist[idx].order_id);
                        if(items_packed[i].qty_packed === 0){
                            vm.quantity_packed = 0;
                        }
                    } else {
                        //$scope.errors.push(rSPQ.error);
                        vm.update_success = false;
                    }
                 });
            }
            // todo this doesn't work some odd reason so moved to hack in cfc
            //1   Calculate fulfillment_status
            //2   Fulfilled
            //3   Null
            //4   Partial
            if (qty_ordered === qty_packed) {
                // Full Shipped
                vm.packlist[idx].fulfillment_status_id = 2;
            } else if (qty_packed === 0) {
                // Null Shipped
                vm.packlist[idx].fulfillment_status_id = 5;
            } else {
                vm.packlist[idx].fulfillment_status_id = 4;
            }
        };

        console.log('Testing abs :' + $scope.is_abs_override);
        // VALIDATE PACK QTY FORM
        $scope.isDisabled = false;
        $scope.submit_packed_items = function(idx) {
            
            console.log(vm);
            $scope.isDisabled = true;
            // console.log(vm.packshippackage);
            // console.log(vm.packshippackage.trim().length);
            // console.log(vm.packlist[idx].order_items[0].qty_picked);

            console.log(vm.packlist[idx]);
            console.log(vm.packlist[idx].packshipssel);
            //assign last values
            //$cookies.put('last_order_id', vm.packlist[idx].order_id);
            $cookies.put('last_orderpackage_id', vm.packlist[idx].order_package_id);
            $cookies.put('last_p_id', vm.packlist[idx].product_id);
            $cookies.put('last_customer_name', vm.packlist[idx].ship_address.customer_name);
            $cookies.put('last_ordered_items', vm.packlist[idx].pkg_qty_items);
            //$cookies.put('last_tracking_num', '');
            vm.last_ordered_items = $cookies.get('last_ordered_items');
            vm.last_tracking_num = $cookies.get('last_tracking_num');

            if((vm.packlist[idx].is_prime === 1 || vm.packlist[idx].abs_override === 1 || vm.packlist[idx].ship_method_id === 32 || (vm.packlist[idx].ship_method_id === 4 && vm.packlist[idx].abs_override === 1)) && vm.packlist[idx].api_online === 1) {

                console.log(vm.packlist[idx].ship_method_id);

                if(vm.packlist[idx].packshippackage.trim().length === 0){
                    log_error("Please select Package Type.");
                }else if(vm.packlist[idx].packshippackage.trim().length > 0 && vm.packlist[idx].packshipssel.trim().length < 2){
                    log_error("Please reselect Package Type and choose Ship Service.");
                }else if(vm.packlist[idx].pickpack_type_id === 58 && (vm.packlist[idx].weight > 8 && vm.packlist[idx].length === 25) && vm.packlist[idx].order_items[0].qty_picked === 1 && (vm.packlist[idx].category_id === 13 || vm.packlist[idx].category_id === 12)){
                    log_error("package weight appears incorrect, please refresh page to pack");
                }else if(vm.packlist[idx].pickpack_type_id === 58 && (vm.packlist[idx].weight > 4 && vm.packlist[idx].length === 13) && vm.packlist[idx].order_items[0].qty_picked === 1 && (vm.packlist[idx].category_id === 13 || vm.packlist[idx].category_id === 12)){
                    log_error("package weight appears incorrect, please refresh page to pack");
                }else{

                    // vm.packlist[idx].LOWESTSERVICEID = vm.LOWESTSERVICEID;
                    // vm.packlist[idx].LOWESTSHIPCOST = vm.LOWESTSHIPCOST;
                    // vm.packlist[idx].packshipssel = vm.packshipssel;
                    // vm.packlist[idx].packshippackage = vm.packshippackage;
                    // vm.packlist[idx].weight = vm.WEIGHT;
                    console.log(vm.packlist[idx].is_prime);
                    // used to flag error after user clicks submit
                    vm.submitted = true;
                    vm.loading = true;
                    var generate_ship_label = false;

                    if(vm.packlist[idx].ship_method_id === 21 && vm.packlist[idx].is_prime !== 1){
                        // create barcode
                        datacontext.createBarCode({label: vm.packlist[idx].FNSKUs}).then(function() {
                            vm.packlist[idx].random = Math.floor((Math.random()*6)+1);
                        });

                        // create barcode with amazon order ID
                        datacontext.createBarCode({label: vm.packlist[idx].marketplace_order_id}).then(function() {
                            vm.packlist[idx].random = Math.floor((Math.random()*6)+1);
                        });
                    }else{
                        // create barcode
                        datacontext.createBarCode({label: vm.packlist[idx].order_id}).then(function() {
                            vm.packlist[idx].random = Math.floor((Math.random()*6)+1);
                        });
                    }

                    // check if form valid submitted blank qty packed
                    if ($scope.packForm.$invalid === false) {
                        // Verify Pick # matches Pack #
                        vm.pick_pack_match = true;

                        // object items packed for loop check
                        var items_packed = vm.packlist[idx].order_items;
                        var arrayLength = items_packed.length;

                        for (var i = 0; i < arrayLength; i++) {
                            // add pickpack id to array
                            if (items_packed[i].qty_picked !== Number(items_packed[i].qty_packed)) {
                                // Pick item  > Pack Items
                                vm.pick_pack_match = false;
                            }
                            if (Number(items_packed[i].order_package_id) == 0) {
                                vm.has_shipping_code = false;
                            }

                            if (Number(items_packed[i].qty_packed) !== 0) {
                                generate_ship_label = true;
                            }
                        };

                        if (vm.btn_step === 'confirm' || vm.pick_pack_match === true) {
                            //  update items pack qty
                            $scope.update_packed_items(idx);

                            // VERIFY UPDATE WORKED
                            if (vm.update_success === true) {
                                // Clear previous submission
                                vm.submitted = false;
                                console.log(vm.packlist[idx]);
                                if(vm.packlist[idx].api_online === 0 && vm.packlist[idx].is_prime === 1){
                                    generate_ship_label = false;
                                }

                                if (generate_ship_label) {
                                    $scope.createShipLabel(idx);
                                }else{
                                    vm.btn_step = 'next';
                                }

                                // Send alert
                                vm.alerts = [{
                                    type: 'success radius',
                                    msg: 'Items packed'
                                }];
                            }
                        } else {
                            // Pick / Pack mismatch
                            // Show confirm button
                            vm.btn_step = 'confirm';
                            vm.loading = false;
                            // Request Packer confirm this
                            vm.alerts = [{
                                type: 'warning radius',
                                msg: 'confirm  pack <> picked'
                            }];
                        }
                    } else {
                        // Turn off spinner
                        vm.loading = false;
                    }
                }
            } else if(vm.packlist[idx].ship_method_id === 7) {
                vm.packlist[idx].LOWESTSERVICEID = vm.LOWESTSERVICEID;
                vm.packlist[idx].LOWESTSHIPCOST = vm.LOWESTSHIPCOST;
                vm.packlist[idx].packshipssel = vm.packshipssel;
                vm.packlist[idx].packshippackage = vm.packshippackage;
                console.log(vm.packlist[idx].LOWESTSERVICEID);
                console.log(vm.packlist[idx].is_prime);
                // used to flag error after user clicks submit
                vm.submitted = true;
                vm.loading = true;
                var generate_ship_label = false;

                // create barcode
                datacontext.createBarCode({label: vm.packlist[idx].order_id}).then(function() {
                    vm.packlist[idx].random = Math.floor((Math.random()*6)+1);
                });

                // check if form valid submitted blank qty packed
                if ($scope.packForm.$invalid === false) {
                    // Verify Pick # matches Pack #
                    vm.pick_pack_match = true;

                    // object items packed for loop check
                    var items_packed = vm.packlist[idx].order_items;
                    var arrayLength = items_packed.length;

                    console.log(items_packed);
                    console.log('Test: ' +vm.slip_id);
                    console.log(vm.last_order_id);

                    for (var i = 0; i < arrayLength; i++) {

                        console.log(Number(items_packed[i].qty_packed));

                        // add pickpack id to array
                        if (items_packed[i].qty_picked !== Number(items_packed[i].qty_packed)) {
                            // Pick item  > Pack Items
                            vm.pick_pack_match = false;
                            //vm.quantity_packed = Number(items_packed[i].qty_packed);
                        }

                        vm.quantity_packed = Number(items_packed[i].qty_packed);

                        if (Number(items_packed[i].order_package_id) == 0) {
                            vm.has_shipping_code = false;
                        }

                        if (Number(items_packed[i].qty_packed) !== 0) {
                            generate_ship_label = true;
                        }
                    };

                    console.log(idx);

                    if (vm.btn_step === 'confirm' || vm.pick_pack_match === true) {

                        console.log(idx);

                        //  update items pack qty
                        $scope.update_packed_items(idx);
                        console.log(vm.quantity_packed);

                        // VERIFY UPDATE WORKED
                        if (vm.update_success === true) {
                            // Clear previous submission
                            vm.submitted = false;
                            if(vm.packlist[idx].api_online === 0 && vm.packlist[idx].is_prime === 1){
                                generate_ship_label = false;
                            }

                            console.log("Testing-Yamuna");
                            console.log(idx);

                            if (generate_ship_label) {
                                $scope.createShipLabel(idx);
                            }else{
                                vm.btn_step = 'next';
                            }

                            // Send alert
                            vm.alerts = [{
                                type: 'success radius',
                                msg: 'Items packed'
                            }];
                        }
                    } else {
                        // Pick / Pack mismatch
                        // Show confirm button

                        console.log('pick pack not matched');

                        //if(vm.quantity_packed !== 0){
                        vm.btn_step = 'confirm';
                        /*}else{
                        vm.btn_step = 'next';  
                        }*/

                        vm.loading = false;
                        // Request Packer confirm this
                        vm.alerts = [{
                            type: 'warning radius',
                            msg: 'confirm  pack <> picked'
                        }];
                    }
                } else {
                    // Turn off spinner
                    vm.loading = false;
                }
            } else{
                vm.packlist[idx].LOWESTSERVICEID = vm.LOWESTSERVICEID;
                vm.packlist[idx].LOWESTSHIPCOST = vm.LOWESTSHIPCOST;
                vm.packlist[idx].packshipssel = vm.packshipssel;
                vm.packlist[idx].packshippackage = vm.packshippackage;
                console.log(vm.packlist[idx].LOWESTSERVICEID);
                console.log(vm.packlist[idx].is_prime);
                // used to flag error after user clicks submit
                vm.submitted = true;
                vm.loading = true;
                var generate_ship_label = false;

            	if(vm.packlist[idx].ship_method_id === 21 && vm.packlist[idx].is_prime !== 1){
                  	// create barcode
                    datacontext.createBarCode({label: vm.packlist[idx].FNSKUs}).then(function() {
                        vm.packlist[idx].random = Math.floor((Math.random()*6)+1);
                    });

                    // create barcode with amazon order ID
                    datacontext.createBarCode({label: vm.packlist[idx].marketplace_order_id}).then(function() {
                        vm.packlist[idx].random = Math.floor((Math.random()*6)+1);
                    });
                }else{
                    // create barcode
                    datacontext.createBarCode({label: vm.packlist[idx].order_id}).then(function() {
                        vm.packlist[idx].random = Math.floor((Math.random()*6)+1);
                    });
                }

                // check if form valid submitted blank qty packed
                if ($scope.packForm.$invalid === false) {
                    // Verify Pick # matches Pack #
                    vm.pick_pack_match = true;

                    // object items packed for loop check
                    var items_packed = vm.packlist[idx].order_items;
                    var arrayLength = items_packed.length;

                    console.log(items_packed);
                    console.log(vm.slip_id);
                    //console.log(vm.last_order_id);

                    for (var i = 0; i < arrayLength; i++) {

                        console.log(Number(items_packed[i].qty_packed));

                        // add pickpack id to array
                        if (items_packed[i].qty_picked !== Number(items_packed[i].qty_packed)) {
                            // Pick item  > Pack Items
                            vm.pick_pack_match = false;
                            //vm.quantity_packed = Number(items_packed[i].qty_packed);
                        }

                        vm.quantity_packed = Number(items_packed[i].qty_packed);

                        if (Number(items_packed[i].order_package_id) == 0) {
                            vm.has_shipping_code = false;
                        }

                        if (Number(items_packed[i].qty_packed) !== 0) {
                            generate_ship_label = true;
                        }
                    };

                    if (vm.btn_step === 'confirm' || vm.pick_pack_match === true) {

                        console.log(idx);

                        //  update items pack qty
                        $scope.update_packed_items(idx);
                        console.log(vm.quantity_packed);

                        // VERIFY UPDATE WORKED
                        if (vm.update_success === true) {
                            // Clear previous submission
                            vm.submitted = false;
                            if(vm.packlist[idx].api_online === 0 && vm.packlist[idx].is_prime === 1){
                                generate_ship_label = false;
                            }

                            if (generate_ship_label) {
                                $scope.createShipLabel(idx);
                            }else{
                                vm.btn_step = 'next';
                            }

                            // Send alert
                            vm.alerts = [{
                                type: 'success radius',
                                msg: 'Items packed'
                            }];
                        }
                    } else {
                        // Pick / Pack mismatch
                        // Show confirm button

                        console.log('pick pack not matched');

                        //if(vm.quantity_packed !== 0){
                        vm.btn_step = 'confirm';
                        /*}else{
                        vm.btn_step = 'next';  
                        }*/

                        vm.loading = false;
                        // Request Packer confirm this
                        vm.alerts = [{
                            type: 'warning radius',
                            msg: 'confirm  pack <> picked'
                        }];
                    }
                } else {
                    // Turn off spinner
                    vm.loading = false;
                }
            }
        };

        $scope.print_label = function(idx) {
            vm.btn_step = 'next';
        };

        $scope.damaged_reprint = function(order_id,order_package_id,package_item_id,product_id,store_product_id,order_item_id) {
            datacontext.damaged_reprint(order_id,order_package_id,package_item_id,product_id,store_product_id,order_item_id).success(function(httpResult) {
                location.reload();
            });
        };

        $scope.print_label_shipped = function(idx) {
            //shipped_on update now

            // if(vm.api_online === 0){
            //   var submitform = {
            //         order_package_id: idx,
            //         ship_method_id: 4,
            //         user_name:vm.user_name
            //     };
            //   datacontext.updateOrderPackage(submitform).then(function() {
            //   });
            // }

            console.log(idx);
            console.log(vm.slip_id);
            //console.log(vm.last_order_id);
            console.log(vm.quantity_packed);
            console.log('reprint ship label');

            vm.next = 1;
            console.log("print_label_shipped only");
            datacontext.update_shipped_on(idx).success(function(httpResult) {
                vm.btn_step = 'next';
            });
        };

        $scope.print_label_shipped_amz = function(order_package_id,marketplace_order_id) {
        	//shipped_on update now
            console.log(order_package_id);
            console.log(vm.api_online);
            vm.next = 1;
            if(vm.api_online === 0){
                var submitform = {
                    order_package_id: order_package_id,
                    ship_method_id: 4,
                    user_name:vm.user_name
                };
                datacontext.updateOrderPackage(submitform).then(function() {});
            }
          //var link = 'https://sellercentral.amazon.com/bulk-buy-shipping-v2?orderIds='+marketplace_order_id;
          var link = 'https://sellercentral.amazon.com/orders-v3/order/'+marketplace_order_id+'/buy-shipping';
          window.open(link,"sellercentral");
        	datacontext.update_shipped_on(order_package_id).success(function(httpResult) {
        		vm.btn_step = 'next';
        	});
        };

        $scope.print_label_shipped_manual = function(order_package_id,marketplace_order_id) {
        	//shipped_on update now
        	vm.next = 1;
        };

        $scope.buy_shipping = function(mp_order_id) {
        	//shipped_on update now
        	console.log(mp_order_id);
          //var link = 'https://sellercentral.amazon.com/bulk-buy-shipping-v2?orderIds='+mp_order_id;
          var link = 'https://sellercentral.amazon.com/orders-v3/order/'+mp_order_id+'/buy-shipping';
          window.open(link,"sellercentral");
        };

        $scope.repack_order = function(order_id,order_package_id) {
        	//shipped_on update now

            var submitform = {
                order_package_id: order_package_id,
                order_id: order_id,
                pickpack_slip_id:vm.slip_id,
                action: 'repack'
            };
            console.log(submitform);
            datacontext.repack_order(submitform).then(function() {
                location.reload();
            });
        };

        $scope.print_label_shipped_mini = function(order_id,order_package_id){
            console.log(vm.slip_id);
            console.log(order_id);
            console.log(order_package_id);
            console.log(vm.quantity_packed);

            var itemDataNew = {
                order_package_id: order_package_id,
                order_id: order_id
            };

            console.log(itemDataNew);
            vm.next = 1;
            vm.btn_step = 'next';

            datacontext.get_package_items(itemDataNew).success(function(httpResult) {
                $scope.repick_print = httpResult.data;
                $scope.user_name = httpResult.USER_NAME;

                console.log($scope.repick_print);

                var modalInstance = $modal.open({
                    templateUrl: '/app/pickpack/partials/repick_modal.html',
                    controller: 'onRePickPackModalCtrl',
                    resolve: {
                        repick_print: function () {
                            return $scope.repick_print;
                        },
                        user_name: function() { return $scope.user_name; }
                    }
                }).result.then(function(result){
                    //$scope.tracking_number = result;
                });

                vm.cancel = function () {
                    modalInstance.dismiss('cancel');
                };

                //location.reload();
            });

            vm.loading = false;
            // Request Packer confirm this
            vm.alerts = [{
              type: 'warning radius',
              msg: 'confirm  pack <> picked'
            }];

        }

        $scope.return_edit_mode = function() {
            vm.btn_step = 'pack';
        };

        vm.change_ship_method = function (idx,status) {
            // combine
        	var ship_method_id = vm.packlist[idx].ship_method_id;
            $scope.postage_limit_exceed_abs = status;
        	
            var modalInstance = $modal.open({
                templateUrl: 'change_ship_method.html',
                controller: 'changeShipMethodCtrl',
                windowClass: 'small',
                resolve: {
                    order_package: function () {
                        return vm.packlist[idx];
                    },
                    status: function() { return $scope.postage_limit_exceed_abs; }
                }
            });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };

            modalInstance.result.then(function () {
                // refreshing full packlist causes it to skip so I am hacking
                vm.packlist[idx].ship_courier_id = 5;
                vm.packlist[idx].ship_courier ='Manual';
                vm.packlist[idx].ship_method_id = 4;
                vm.packlist[idx].ship_method =' Print Label';
                vm.packlist[idx].fulfillment_warehouse_id = vm.packlist[idx].fulfillment_warehouse_id;
                vm.packlist[idx].random = Math.floor((Math.random()*6)+1);
            }, function () {
                // Dismiss log
            });
        };

        // CREATE SHIPPING LABEL
        $scope.createShipLabel = function(idx) {

            // to do add addition var's when needed ie weight ship from
            console.log(vm.packlist[idx]);
            // Get Infomation to create label
            //check if SFP call
            if(angular.isDefined(vm.packlist[idx].packshipssel) &&  (vm.packlist[idx].abs_override === 1 || vm.packlist[idx].ship_method_id === 32)){
                var shipLabelRequest = {
                    order_id:vm.packlist[idx].order_id,
                    order_ids:vm.packlist[idx].order_ids,
                    order_package_id:vm.packlist[idx].order_package_id,
                    ship_to_address_id:vm.packlist[idx].ship_address_id,
                    ship_method_id:vm.packlist[idx].ship_method_id,
                    fulfillment_warehouse_id:vm.packlist[idx].fulfillment_warehouse_id,
                    customer_id:vm.packlist[idx].customer_id ,
                    order_total: vm.packlist[idx].order_total,
                    rrd_picked_qty: vm.packlist[idx].rrd_picked_qty,
                    packshipssel: vm.packlist[idx].packshipssel,
                    packshippackage: vm.packlist[idx].packshippackage,
                    lowest_service_id: vm.packlist[idx].LOWESTSERVICEID,
                    lowest_ship_cost: vm.packlist[idx].LOWESTSHIPCOST,
                    weight: vm.packlist[idx].weight,
                    package_weight: vm.packlist[idx].package_weight
              };
              if (vm.packlist[idx].ship_method_id === 32) {
                    var selectedShipping = vm.packlist[idx].packshipssel.split('|');

                    shipLabelRequest.lowest_service_id = selectedShipping[0];
                    shipLabelRequest.lowest_ship_cost = selectedShipping[1];
                }

            } else if(angular.isDefined(vm.packlist[idx].packshipssel) && angular.isDefined(vm.packlist[idx].LOWESTSERVICEID) && (vm.packlist[idx].is_prime === 1 || (vm.packlist[idx].ship_method_id === 4 && vm.packlist[idx].abs_override === 1)) && vm.packlist[idx].is_multi_item !== 1){
              var shipLabelRequest = {
                  order_id:vm.packlist[idx].order_id,
                  order_ids:vm.packlist[idx].order_ids,
                  order_package_id:vm.packlist[idx].order_package_id,
                  ship_to_address_id:vm.packlist[idx].ship_address_id,
                  ship_method_id:vm.packlist[idx].ship_method_id,
                  fulfillment_warehouse_id:vm.packlist[idx].fulfillment_warehouse_id,
                  customer_id:vm.packlist[idx].customer_id ,
                  order_total: vm.packlist[idx].order_total,
                  rrd_picked_qty: vm.packlist[idx].rrd_picked_qty,
                  packshipssel: vm.packlist[idx].packshipssel,
                  packshippackage: vm.packlist[idx].packshippackage,
                  lowest_service_id: vm.packlist[idx].LOWESTSERVICEID,
                  lowest_ship_cost: vm.packlist[idx].LOWESTSHIPCOST,
                  weight: vm.packlist[idx].weight,
                  package_weight: vm.packlist[idx].package_weight
              };
            } else if(angular.isDefined(vm.packlist[idx].packshipssel) && angular.isDefined(vm.packlist[idx].LOWESTSERVICEID) && (vm.packlist[idx].is_prime === 1 || (vm.packlist[idx].ship_method_id === 4 && vm.packlist[idx].abs_override === 1)) && vm.packlist[idx].is_multi_item === 1){
              var shipLabelRequest = {
                  order_id:vm.packlist[idx].order_id,
                  order_ids:vm.packlist[idx].order_ids,
                  order_package_id:vm.packlist[idx].order_package_id,
                  ship_to_address_id:vm.packlist[idx].ship_address_id,
                  ship_method_id:vm.packlist[idx].ship_method_id,
                  fulfillment_warehouse_id:vm.packlist[idx].fulfillment_warehouse_id,
                  customer_id:vm.packlist[idx].customer_id ,
                  order_total: vm.packlist[idx].order_total,
                  rrd_picked_qty: vm.packlist[idx].rrd_picked_qty,
                  packshipssel: vm.packlist[idx].packshipssel,
                  packshippackage: vm.packlist[idx].packshippackage,
                  lowest_service_id: vm.packlist[idx].LOWESTSERVICEID,
                  lowest_ship_cost: vm.packlist[idx].LOWESTSHIPCOST,
                  package_weight: vm.packlist[idx].package_weight
              };
            } else if(vm.packlist[idx].ship_method_id === 7) {
                var shipLabelRequest = {
                    order_id:vm.packlist[idx].order_id,
                    order_ids:vm.packlist[idx].order_ids,
                    order_package_id:vm.packlist[idx].order_package_id,
                    ship_to_address_id:vm.packlist[idx].ship_address_id,
                    ship_method_id:vm.packlist[idx].ship_method_id,
                    fulfillment_warehouse_id:vm.packlist[idx].fulfillment_warehouse_id,
                    customer_id:vm.packlist[idx].customer_id ,
                    order_total: vm.packlist[idx].order_total,
                    rrd_picked_qty: vm.packlist[idx].rrd_picked_qty,
                    label_ready: vm.packlist[idx].label_ready,
                    width: vm.packlist[idx].pkg_width,
                    height: vm.packlist[idx].pkg_height,
                    length: vm.packlist[idx].pkg_length,
                    weight: vm.packlist[idx].pkg_weight,
                    package_weight: vm.packlist[idx].package_weight
                };
            } else{
              var shipLabelRequest = {
                  order_id:vm.packlist[idx].order_id,
                  order_ids:vm.packlist[idx].order_ids,
                  order_package_id:vm.packlist[idx].order_package_id,
                  ship_to_address_id:vm.packlist[idx].ship_address_id,
                  ship_method_id:vm.packlist[idx].ship_method_id,
                  fulfillment_warehouse_id:vm.packlist[idx].fulfillment_warehouse_id,
                  customer_id:vm.packlist[idx].customer_id ,
                  order_total: vm.packlist[idx].order_total,
                  rrd_picked_qty: vm.packlist[idx].rrd_picked_qty,
                  label_ready: vm.packlist[idx].label_ready,
                  package_weight: vm.packlist[idx].package_weight
              };
            }

            vm.btn_label_loading = true;
            if(angular.isDefined(vm.packlist[idx].packshipssel) &&  (vm.packlist[idx].abs_override === 1 || vm.packlist[idx].ship_method_id === 32)){
                datacontext.createShipLabelSFPMultiAtPack(shipLabelRequest).success(function(httpResult) {
                    console.log(httpResult);
                    if (httpResult.SUCCESS === true) {
                        // Push to page
                        vm.packlist[idx].tracking_code = httpResult.DATA;
                        $cookies.put('last_tracking_num', vm.packlist[idx].tracking_code);
                        vm.packlist[idx].tracking_code_dhl = httpResult.DATA;
                        vm.btn_step = 'print';
                        vm.loading = false;
                        console.log('print');
                        console.log(httpResult.DATA);
                    } else {
                        log(httpResult.data);
                        vm.loading = false;
                        vm.shiplabeltimeout = true;
                        vm.btn_step = 'pack';
                        console.log('pack');

                        if(vm.packlist[idx].abs_override === 1 && (vm.packlist[idx].store_id === 1 || vm.packlist[idx].store_id === 9)){

                            console.log(vm.packlist[idx]);
                            var data = vm.packlist[idx];
                            var itemData = {
                                order_package_id:data.order_package_id,
                                ship_method_id: 4,
                                abs_override_no: 1,
                                from_pack_audit: 1,
                                order_id: data.order_id,
                                user_name:vm.user_name
                            };
                            
                            datacontext.updateOrderPackage(itemData).success(function(httpResult) {
                                location.reload();
                            });
                        }
                    }
                });
            }else if(angular.isDefined(vm.packlist[idx].packshipssel)  && angular.isDefined(vm.packlist[idx].LOWESTSERVICEID) && (vm.packlist[idx].is_prime === 1 || (vm.packlist[idx].ship_method_id === 4 && vm.packlist[idx].abs_override === 1)) && vm.packlist[idx].is_multi_item !== 1){
              datacontext.createShipLabelSFP(shipLabelRequest).success(function(httpResult) {
                 console.log(httpResult);
                     if (httpResult.SUCCESS === true) {
                         // Push to page
                       vm.packlist[idx].tracking_code = httpResult.DATA;
                       $cookies.put('last_tracking_num', vm.packlist[idx].tracking_code);
                       vm.packlist[idx].tracking_code_dhl = httpResult.DATA;
                       vm.btn_step = 'print';
                       vm.loading = false;
                       console.log('print');
                       console.log(httpResult.DATA);
                     } else {
                       console.log(httpResult);
                       log_error(httpResult.DATA);
                       vm.loading = false;
                       vm.shiplabeltimeout = true;
                       vm.btn_step = 'pack';
                       console.log('pack');
                     }
                 });
            }else if(angular.isDefined(vm.packlist[idx].packshipssel)  && angular.isDefined(vm.packlist[idx].LOWESTSERVICEID) && (vm.packlist[idx].is_prime === 1 ||  vm.packlist[idx].ship_method_id === 32 || (vm.packlist[idx].ship_method_id === 4 && vm.packlist[idx].abs_override === 1)) && vm.packlist[idx].is_multi_item === 1){

               datacontext.createShipLabelSFPMulti(shipLabelRequest).success(function(httpResult) {
                 console.log(httpResult);
                     if (httpResult.SUCCESS === true) {
                         // Push to page
                       vm.packlist[idx].tracking_code = httpResult.DATA;
                       $cookies.put('last_tracking_num', vm.packlist[idx].tracking_code);
                       vm.packlist[idx].tracking_code_dhl = httpResult.DATA;
                       vm.btn_step = 'print';
                       vm.loading = false;
                       console.log('print');
                       console.log(httpResult.DATA);
                     } else {
                       log(httpResult.data);
                       vm.loading = false;
                       vm.shiplabeltimeout = true;
                       vm.btn_step = 'pack';
                       console.log('pack');
                     }
                 });
            } else if (vm.packlist[idx].ship_method_id !== 32 && ( vm.packlist[idx].tracking_code_dhl.trim().length === 0 || vm.packlist[idx].ship_method_id !== 1)) {
            	 datacontext.createShipLabel(shipLabelRequest).success(function(httpResult) {
                    if (httpResult.success === true) {
                        // Push to page
                        vm.packlist[idx].tracking_code = httpResult.data;
                        $cookies.put('last_tracking_num', vm.packlist[idx].tracking_code);
                        $cookies.put('last_order_id', vm.packlist[idx].order_id);
                        vm.packlist[idx].tracking_code_dhl = httpResult.data;
                        vm.packlist[idx].label_ready = 1;
                        vm.packlist.label_ready = 1;
                        vm.btn_step = 'print';
                        vm.loading = false;
                        vm.label_load_time = httpResult.LABEL_LOAD_TIME;
                    } else {
                        log(httpResult.data);
                        console.log(httpResult);
                        vm.error_msg = httpResult.data;
                        vm.loading = false;
                        vm.shiplabeltimeout = true;
                        vm.btn_step = 'pack';
                        vm.label_fail_message = httpResult.data;

                        /*if(vm.packlist[idx].ship_method_id === 16){
                            if($window.confirm("Label failed. Would you like to try printing label from Endicia?")){
                                console.log(vm.packlist[idx]);
                                var data = vm.packlist[idx];
                                var itemData = {
                                order_package_id:data.order_package_id,
                                endicia_override: 1,
                                order_id:data.order_id,
                                from_pack_audit:1,
                                user_id: vm.user_id
                            };

                            datacontext.updatePackageEndicia(itemData).success(function(httpResult){
                                location.reload();
                            });
                        }
                        }*/

                        //if((angular.isDefined(httpResult.data) && httpResult.data === 'This order was not found in liberty. Please create a new order address import.') && (angular.isDefined(httpResult.ORDERNOTFOUND) && httpResult.ORDERNOTFOUND === '1')){
                        if(angular.isDefined(httpResult.data) && httpResult.data === 'This order was not found in liberty. Please create a new order address import.'){
                            console.log(httpResult.data);
                            //log_error(httpResult.data);
                        } else{
                            if(vm.packlist[idx].ship_method_id === 16 && (vm.packlist[idx].store_id === 1 || vm.packlist[idx].store_id === 9)){
                                //if ($window.confirm("Label failed. Would you like to change to manual shipping?")){
                                console.log(vm.packlist[idx]);
                                var data = vm.packlist[idx];
                                /*var itemData = {
                                    order_package_id:data.order_package_id,
                                    ship_method_id: 4,
                                    abs_override_no: 1,
                                    from_pack_audit: 1,
                                    order_id: data.order_id,
                                    user_name:vm.user_name
                                };
                                datacontext.updateOrderPackage(itemData).success(function(httpResult) {
                                location.reload();
                                });*/

                                location.reload();
                                //}
                            }
                        }
                    }
                });
            }
            else{
            	var shipLabelRequest = {
            			tracking_id:vm.packlist[idx].tracking_code_dhl
                    };
            	datacontext.getShiplabel(shipLabelRequest).success(function(httpResult) {

                    if (httpResult.success === true) {
                        // Push to page
                        vm.packlist[idx].tracking_code = httpResult.data;
                        $cookies.put('last_tracking_num', vm.packlist[idx].tracking_code);
                        vm.packlist[idx].tracking_code_dhl = httpResult.data;
                        vm.btn_step = 'print';
                        vm.loading = false;

                    } else {
                        log(httpResult.data);
                        vm.loading = false;
                        vm.shiplabeltimeout = true;
                        vm.btn_step = 'pack';
                    }
                });

            }
        };

        $scope.submit_pack_audit = function(pick_missed_count,pick_extra_count,packed_by,picked_by) {
          console.log("pick_missed_count"+pick_missed_count);
          console.log("pick_extra_count"+pick_extra_count);
          var pack_audit = {
              slip_id: vm.slip_id,
              pick_missed_count: pick_missed_count,
              pick_extra_count: pick_extra_count,
              packed_by: packed_by,
              picked_by: picked_by
          };
          datacontext.submit_pack_audit(pack_audit).success(function(httpResult) {
            datacontext.get_pickpack_slips({pickpack_slip_id:vm.slip_id}).success(function(httpResult) {
              vm.user_name = httpResult.USER_NAME;
              console.log(httpResult.data[0]);
              vm.packed_by = httpResult.data[0].packed_by;
              vm.picked_by = httpResult.data[0].picked_by;
              vm.pod_printed_count = httpResult.data[0].pod_printed_count;
              vm.qty_picked = httpResult.data[0].qty_picked;
              vm.pick_missed_count = httpResult.data[0].pick_missed_count;
              vm.pick_extra_count = httpResult.data[0].pick_extra_count;
                if(angular.isDefined(httpResult.ERRORMULTI)){
                    vm.ERRORMULTI = httpResult.ERRORMULTI;
                }
                $cookies.put('last_order_id', '');
                $cookies.put('last_orderpackage_id', '');
                $cookies.put('last_p_id', '');
                $cookies.put('last_customer_name', '');
                $cookies.put('last_ordered_items', '');
                $cookies.put('last_tracking_num', '');
              location.href = 'https://ace.gothamcityonline.com/#/pickpack/';
            });
          });
        };
        // FINAL STEP MARK Order Shipped
        $scope.get_next_item = function(idx) {
            $scope.isDisabled = false;
            // Flag order shipped
            vm.last_order_id = $cookies.get('last_order_id');
            vm.last_orderpackage_id = $cookies.get('last_orderpackage_id');
            vm.last_p_id = $cookies.get('last_p_id');
            vm.last_customer_name = $cookies.get('last_customer_name');
            vm.last_ordered_items = $cookies.get('last_ordered_items');
            vm.last_tracking_num = $cookies.get('last_tracking_num');

            console.log(vm.packlist[0].order_items[0].qty_packed);

            // vm.packlist[0].quantity_packed = vm.packlist[0].order_items[0].qty_packed;

            var shippedOrder = vm.packlist[idx];
            shippedOrder.quantity_packed = shippedOrder.order_items[0].qty_packed;

            datacontext.update_order_shipped(vm.packlist[idx]).success(function(httpResult) {
              console.log("vm.packlist[idx]here");
              console.log(vm.packlist[idx]);
              $cookies.put('last_order_id', vm.packlist[idx].order_id);
              $cookies.put('last_orderpackage_id', vm.packlist[idx].order_package_id);
              $cookies.put('last_p_id', vm.packlist[idx].product_id);
              $cookies.put('last_customer_name', vm.packlist[idx].ship_address.customer_name);
              $cookies.put('last_ordered_items', vm.packlist[idx].pkg_qty_items);
              //$cookies.put('last_tracking_num', '');
                if (httpResult.success === true) {
                    // Remove order from pending pack array
                    vm.packlist.splice(idx, 1);
                    // close open alerts
                    vm.alerts = [];
                    // Reset button
                    vm.btn_step = 'pack';
                    // Counting down left to pack this feels like a hack
                    vm.orders_left = vm.orders_left - 1;
                    //console.log(vm.packlist[idx].packing_note);
                    // if(angular.isDefined(vm.packlist[idx])){
                    //   if(vm.packlist[idx].packing_note != ''){
                    //   	open_pack_notes(vm.packlist[idx].packing_note);
                    //   }
                    //   console.log(vm.packlist[0].order_items[0].tube);
      		        //     console.log(vm.packlist[0].order_id);
                    //   if(vm.packlist[0].abs_override === 1){
                    //         if(vm.packlist[0].order_items[0].tube === 37){
                    //             vm.packshippackage = '37|1.5|1.5|5';
                    //             $scope.selectPackageType(vm.packshippackage,vm.packlist[0].order_id,1,1,0,0);
                    //         }else if(vm.packlist[0].order_items[0].tube === 40){
                    //             vm.packshippackage = '40|3|3|6';
                    //             $scope.selectPackageType(vm.packshippackage,vm.packlist[0].order_id,1,1,0,0);
                    //         }else if(vm.packlist[0].order_items[0].max_tube_length === 21.5){
                    //             // else if(max_tube_length === 21.5)
                    //             vm.packshippackage = '21.5|1.5|1.5|5';
                    //             $scope.selectPackageType(vm.packshippackage,vm.packlist[0].order_id,1,1,0,0);                                   
                    //         }else{
                    //             vm.packshippackage = '12|15.5|0.5|3';
                    //             $scope.selectPackageType(vm.packshippackage,vm.packlist[0].order_id,1,1,0,0);
                    //         }
                    //   }else if(vm.packlist[0].order_items[0].tube === 13){
                    //     vm.packshippackage = '12|15.5|0.5|1.6';
                    //     $scope.selectPackageType(vm.packshippackage,vm.packlist[0].order_id,1,1,0,0);
                    //   }else if(vm.packlist[0].order_items[0].tube === 25){
                    //     vm.packshippackage = '25|1.5|1.5|6';
                    //     $scope.selectPackageType(vm.packshippackage,vm.packlist[0].order_id,1,1,0,0);
                    //   }else if(vm.packlist[0].order_items[0].tube === 10){
                    //     vm.packshippackage = '12|15.5|0.5|1';
                    //     $scope.selectPackageType(vm.packshippackage,vm.packlist[0].order_id,1,1,0,0);
                    //   }else if(vm.packlist[0].order_items[0].tube === 99){
                    //     vm.packshippackage = '12|15.5|0.5|3';
                    //     $scope.selectPackageType(vm.packshippackage,vm.packlist[0].order_id,1,1,0,0);
                    //   }
                    //   $scope.take_audit = 0;
                    // }else{
                    //   log_success("Great work! List Is done.");
                    //   $scope.take_audit = 1;
                    //   $cookies.put('last_order_id', '');
                    //   $cookies.put('last_orderpackage_id', '');
                    //   $cookies.put('last_p_id', '');
                    //   $cookies.put('last_customer_name', '');
                    //   $cookies.put('last_ordered_items', '');
                    //   $cookies.put('last_tracking_num', '');
                    // }


                    if (angular.isDefined(vm.packlist[0])) {

                        var nextOrder = vm.packlist[0];

                        if (nextOrder.packing_note !== '') {
                            open_pack_notes(nextOrder.packing_note);
                        }

                        datacontext.getPackageDimensions({
                            order_id: nextOrder.order_id,
                            order_package_id: nextOrder.order_package_id,
                            fulfillment_warehouse_id: nextOrder.fulfillment_warehouse_id
                        }).then(function(httpResult) {

                            if (httpResult.data.success === true) {

                                nextOrder.packshippackage = httpResult.data.PACKSHIPPACKAGE;
                                nextOrder.length = httpResult.data.LENGTH;
                                nextOrder.width = httpResult.data.WIDTH;
                                nextOrder.height = httpResult.data.HEIGHT;
                                nextOrder.weight = httpResult.data.WEIGHT;

                                console.log('Next order:', nextOrder.order_id);
                                console.log('Dynamic package:', nextOrder.packshippackage);
                                console.log('Dimensions:', nextOrder.length,
                                    nextOrder.width, nextOrder.height);
                                console.log('Weight:', nextOrder.weight);

                                $scope.selectPackageType(
                                    nextOrder.packshippackage,
                                    nextOrder.order_id,
                                    1,
                                    nextOrder.is_prime,
                                    0,
                                    1
                                );

                            } else {
                                log_error(httpResult.data.data);
                            }
                        });

                        $scope.take_audit = 0;

                    } else {

                        log_success("Great work! List Is done.");
                        $scope.take_audit = 1;

                        $cookies.put('last_order_id', '');
                        $cookies.put('last_orderpackage_id', '');
                        $cookies.put('last_p_id', '');
                        $cookies.put('last_customer_name', '');
                        $cookies.put('last_ordered_items', '');
                        $cookies.put('last_tracking_num', '');
                    }





                } else {
                    log('ship label fail');
                    vm.loading = false;
                    vm.shiplabeltimeout = true;
                    vm.btn_step = 'pack';
            }
            });
            if( vm.packlist[idx].ship_method_id === 20){
                get_waybill_num();
            }

        };

        function open_pack_notes(packing_note) {
        		vm.packing_note1 = packing_note;

            if(vm.packing_note1.indexOf('DO NOT SHIP') > -1){
              var modalInstance = $modal.open({
                      scope:$scope,
                      template: "<div><b style='color:#ff0000 !important;'>Packing Note: {{vm.packing_note1}}</b><br></div><div style='float:right;'><button ng-click='cancel()'>I got it!</button></div>",
                      controller: function(){
                          $scope.cancel = function(){
                          	modalInstance.dismiss('cancel');
                          };
                      }
                  });
            }else if (vm.packing_note1.indexOf('OK TO SHIP') > -1){
              var modalInstance = $modal.open({
                      scope:$scope,
                      template: "<div><b style='color:green !important;'>Packing Note: {{vm.packing_note1}}</b><br></div><div style='float:right;'><button ng-click='cancel()'>I got it!</button></div>",
                      controller: function(){
                          $scope.cancel = function(){
                          	modalInstance.dismiss('cancel');
                          };
                      }
                  });
            }else{
              var modalInstance = $modal.open({
                      scope:$scope,
                      template: "<div><b>Packing Note: {{vm.packing_note1}}</b><br></div><div style='float:right;'><button ng-click='cancel()'>I got it!</button></div>",
                      controller: function(){
                          $scope.cancel = function(){
                          	modalInstance.dismiss('cancel');
                          };
                      }
                  });
            }


        }
    }
})();

(function() {
    'use strict';
    var controllerId = 'onRePickPackModalCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$modalInstance','repick_print', 'user_name', onRePickPackModalCtrl]);

    function onRePickPackModalCtrl(common, datacontext, $scope, $modalInstance, repick_print, user_name) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');
        var vm = this;

        $scope.repick_print = repick_print;
        $scope.user_name = user_name;
        $scope.pack_date = new Date();
        for(var i=0; i < repick_print.length; i++){
            console.log(repick_print[i].order_id);
            $scope.order_id = repick_print[i].order_id;
            $scope.pickpack_slip_id = repick_print[i].pickpack_slip_id;
            $scope.ship_by = repick_print[i].mp_ship_latest_by;
            $scope.store_name = repick_print[i].store_name;
            $scope.pickpack_type = repick_print[i].pickpack_type;
            $scope.qty_ordered = repick_print[i].qty_ordered;

        }
        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

    }
})();


(function() {
    'use strict';
    var controllerId = 'changeShipMethodCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modalInstance', '$cookies','order_package', 'status', changeShipMethodCtrl]);

    function changeShipMethodCtrl(common, datacontext, $scope, $modalInstance, $cookies, order_package, status) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');
        var shipmethodid = order_package.ship_method_id;
        var shipmethod_reason_id = "";
        var order_package_id = order_package.order_package_id;
        var order_id = order_package.order_id;
        var dhl_ship = "false";
        var fedex_ship = "false";
        var fedex_int_ship = "false";
        var amz_ship = "false";
        var manual_ship = "false";
        var ups_ship = "false";
        var ups_flats_ship = "false";
        var ups_ground_ship = "false";
        var dhl_ship = "false";
        var fedex_one_ship = "false";
        var usps_ship = "false";
        $scope.postage_limit_status = status;
        var vm = this;
        vm.user_name = $cookies.get('user_name');
        vm.user_role_id = 0;
        if( angular.isDefined($cookies.get('user_role_id')) ) {
          vm.user_role_id = $cookies.get('user_role_id');
        }
        //for ship method options
        if(order_package.ship_method_id === 22){
        	dhl_ship = "true";
        }else if(order_package.ship_method_id === 14){
        	fedex_ship = "true";
        }else if(order_package.ship_method_id === 4){
        	manual_ship = "true";
        }else if(order_package.ship_method_id === 16){
        	ups_ship = "true";
        }else if(order_package.ship_method_id === 22){
        	dhl_ship = "true";
        }else if(order_package.ship_method_id === 23){
            ups_flats_ship = "true";
        }else if(order_package.ship_method_id === 6){
            ups_ground_ship = "true";
        }else if(order_package.ship_method_id === 20){
        	fedex_int_ship = "true";
        }else if(order_package.ship_method_id === 21){
        	amz_ship = "true";
        }else if(order_package.ship_method_id === 12){
        	fedex_one_ship = "true";
        }else if(order_package.ship_method_id === 5){
            usps_ship = "true";
        }
        //for now hard coded as we are using only three methods
        /*removed DHL{
        	            id: 1,
        	            text: "DHL",
        	            isUserAnswer: dhl_ship
        	        }, */

        console.log(order_package);
        console.log($scope.postage_limit_status);

        //if($scope.postage_limit_status !== 'undefined' && $scope.postage_limit_status === 1){
            $scope.ship_methods = {
                questionText: "Change Ship Method.",
                choices: [{
                        id: 5,
                        text: "USPS Endicia",
                        isUserAnswer: "usps_ship"
                    }, {
                        id: 14,
                        text: "FedEx - SmartPost",
                        isUserAnswer: fedex_ship
                    }, {
                        id: 16,
                        text: "UPS - Mail Innovations",
                        isUserAnswer: ups_ship
                    }, {
                        id: 22,
                        text: "DHL International",
                        isUserAnswer: dhl_ship
                    }, {
                        id: 27,
                        text: "DHL Economy",
                        isUserAnswer: dhl_ship
                    }, {
                        id: 23,
                        text: "UPS - Flats",
                        isUserAnswer: ups_flats_ship
                    }, {
                        id: 6,
                        text: "UPS - Ground",
                        isUserAnswer: ups_ground_ship
                    }, {
                        id: 4,
                        text: "Manual",
                        isUserAnswer: manual_ship
                    }]
            };
        /*} else {
            $scope.ship_methods = {
                questionText: "Change Ship Method.",
                choices: [{
                        id: 5,
                        text: "USPS Endicia",
                        isUserAnswer: "usps_ship"
                    }, {
                        id: 14,
                        text: "FedEx",
                        isUserAnswer: fedex_ship
                    }, {
                        id: 16,
                        text: "UPS - Mail Innovations",
                        isUserAnswer: ups_ship
                    }, {
                        id: 4,
                        text: "Manual",
                        isUserAnswer: manual_ship
                    }, {
                    id: 20,
                    text: "FedEx Int",
                    isUserAnswer: fedex_int_ship
                    }, {
                    id: 21,
                    text: "Amazon Shipping",
                      isUserAnswer: amz_ship
                    }, {
                    id: 22,
                    text: "DHL Global Mail - International",
                    isUserAnswer: dhl_ship
                    },{
                    id: 12,
                    text: "FedEx One_Rate / 2Day",
                    isUserAnswer: fedex_one_ship
                }]
            };
        }*/

          $scope.ship_methods_reason = {
          	    questionText: "Select reason.",
          	    choices: [{
          	            id: 1,
          	            text: "no label printed",
          	            isUserAnswer: fedex_ship
          	        }, {
          	            id: 2,
          	            text: "address seems invalid",
          	            isUserAnswer: ups_ship
          	        }, {
                        id: 4,
                        text: "postage too high",
                        isUserAnswer: ''
                    }, {
          	            id: 3,
          	            text: "Other",
          	            isUserAnswer: manual_ship
          	        }]
          	};
        $scope.getVal = function (e) {
	        shipmethodid = e;
        };
        $scope.getVal_reason = function (e) {
	        shipmethod_reason_id = e;
        };

        $scope.ship_method_btn_ok = function () {
          if(shipmethodid === 21){
            var submitform = {
                  order_package_id: order_package_id,
                  ship_method_id: shipmethodid,
                  shipmethod_reason_id: shipmethod_reason_id,
                  abs_override_no: 1,
                  is_prime: 1,
                  order_id: order_id,
                  user_name:vm.user_name
              };
          }else{
            var submitform = {
                  order_package_id: order_package_id,
                  ship_method_id: shipmethodid,
                  shipmethod_reason_id: shipmethod_reason_id,
                  abs_override_no: 1,
                  order_id: order_id,
                  user_name:vm.user_name
              };
          }

          console.log(order_package.ship_method_id);
          console.log(shipmethodid);
          if( shipmethodid === 4 && shipmethod_reason_id === '' ){
            log_error("Please select reason to change ship method to manual.");
          }else if( order_package.ship_method_id === 12 && shipmethodid !== 4 && (vm.user_role_id > 0 && vm.user_role_id > 3) ){
            log_error("Premium orders must ship with expedited services.");
          }else{
            return datacontext.updateOrderPackage(submitform).then(function() {
              // update ship method scope
              $modalInstance.close('update');
              $scope.reload();
            });
          }

        };

        $scope.ship_method_btn_cancel = function () {
            $modalInstance.dismiss('cancel');
        };

        $scope.reload = function () {
           location.reload();
        }
    }
})();

(function() {
    'use strict';
    var controllerId = 'pickallCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modalInstance', 'pickData', pickallCtrl]);

    function pickallCtrl(common, datacontext, $scope, $modalInstance, pickData) {
      var getLogFn = common.logger.getLogFn;
      var log = getLogFn(controllerId);
      var log_success = getLogFn(controllerId,'success');
      var log_error = getLogFn(controllerId,'error');
      $scope.pickpack_slip_id = pickData.pickpack_slip_id;
      $scope.user_id = pickData.user_id;

        $scope.pick_list = function (password) {
          if(password === "pickit"){
            console.log("closed");
            console.log($scope);
            datacontext.update_list_picked({pickpack_slip_id: $scope.pickpack_slip_id, user_id: $scope.user_id}).then(function (httpResult) {
                log_success("List marked as Picked!")
                // close it
                $modalInstance.close();
            });
          }else{
            log_error("Password Mismatch!");
          }

        };

    }
})();

(function() {
    'use strict';
    var controllerId = 'closelistCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modalInstance', 'pickData', closelistCtrl]);

    function closelistCtrl(common, datacontext, $scope, $modalInstance, pickData) {
      var getLogFn = common.logger.getLogFn;
      var log = getLogFn(controllerId);
      var log_success = getLogFn(controllerId,'success');
      var log_error = getLogFn(controllerId,'error');
      $scope.pickpack_slip_id = pickData.pickpack_slip_id;
      $scope.user_id = pickData.user_id;

        $scope.close_list = function (password) {
          if(password === "closeit"){
            console.log("closed");
            console.log($scope);
            datacontext.close_list_update({pickpack_slip_id: $scope.pickpack_slip_id, user_id: $scope.user_id}).then(function (httpResult) {
                log_success("List Closed!")
                // close it
                $modalInstance.close();
            });
          }else{
            log_error("Password Mismatch!");
          }

        };

    }
})();

(function() {
    'use strict';
    var controllerId = 'changepickpackstatusCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$window', '$modalInstance', '$cookies', 'pickslip', changepickpackstatusCtrl]);

    function changepickpackstatusCtrl(common, datacontext, $scope, $window, $modalInstance, $cookies, pickslip) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId, 'success');
        var log_error = getLogFn(controllerId, 'error');
        var vm = this;

        $scope.pickpack_slip_id = pickslip.pickpack_slip_id;
        $scope.user_id = pickslip.user_id;
        $scope.pickpack_status_id = pickslip.pickpack_status_id;
        $scope.pickpack_status = pickslip.pickpack_status;

        $scope.pickslip = pickslip;

        vm.user_name = $cookies.get('user_name');

        datacontext.get_pickpack_status().then(function(response) {
            $scope.pickpack_status = response.data.data;
        });

        $scope.updatePickPackStatus = function(data) {
            var payload = {
                pickpack_slip_id: data.pickpack_slip_id,
                pickpack_status_id: data.pickpack_status_id,
                note: data.note + ' - ' + vm.user_name
            };

            return datacontext.updatePickPackSlip(payload).then(function(httpResult) {
                $modalInstance.close(payload);
                location.reload();
            });
        }

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();

(function() {
    'use strict';
    var controllerId = 'fedexWaybillCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$modalInstance', fedexWaybillCtrl]);

    function fedexWaybillCtrl(common, datacontext, $scope, $modalInstance) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');

        // Pushes input to scope
        $scope.waybill_num = "";

        $scope.ok = function (waybill_num) {

            if(!parseInt(waybill_num) || waybill_num.length !== 12){
                log_error("Please enter 12 digit Numeric FedEx Waybill No");
                return false;
            }else{
                // Insert waybill no
                datacontext.ins_waybill_num({waybill_num: parseInt(waybill_num)}).then(function (httpResult) {
                    log_success("Waybill Num Logged !!!")
                    // close it
                    $modalInstance.close();
                });
            }
        }

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();
(function() {
    'use strict';
    var controllerId = 'backstockMCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$modalInstance', 'pickpackItem', backstockMCtrl]);

    function backstockMCtrl(common, datacontext, $scope, $modalInstance, pickpackItem) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');
        console.log("backstockMCtrl");
        console.log($scope);
        console.log(pickpackItem);
        var vm = this;
        $scope.product_id = pickpackItem.pid;
        datacontext.get_location_products({product_id:pickpackItem.pid,search_location_type:27}).then(function (httpResult) {
          $scope.location_products = httpResult.data.data;
          console.log(vm.location_products);
        });
        $scope.update_location_product = function(loc,idx) {
          console.log(loc);
          console.log("idx"+idx);
          datacontext.update_location_product(loc).then(function (httpResult) {
            log('Location Updated');
        });
        };
        $scope.delete_location_product = function(loc,idx) {
          console.log("loc"+loc);
          console.log("idx"+idx);
          loc.backstock_m = 1;
          console.log(loc);
          datacontext.delete_location(loc).then(function (httpResult) {
              log('Location Deleted');
              vm.temp_loc_prod_id.length = 0;
              vm.temp_location_id.length = 0;
              //change product on hand
              $scope.product_on_hand = httpResult.data;
            var myEl = angular.element( document.querySelector( '#product_on_hand' ) );
              myEl.text($scope.product_on_hand);

              $scope.$broadcast('refreshLocationProductsLog', 'refresh');
              get_location_products();
          });
        };



        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();

(function() {
    'use strict';
    var controllerId = 'pickpackShippingModalCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$modalInstance', 'pickpackItem', pickpackShippingModalCtrl]);

    function pickpackShippingModalCtrl(common, datacontext, $scope, $modalInstance, pickpackItem) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');

        // Pushes input to scope
        $scope.pickpack_item = pickpackItem;
        $scope.pickpack_item.default_shipping_method_id = $scope.pickpack_item.default_shipping_method_id.toString();

        datacontext.get_pp_shipping_methods().then(function (response) {
            $scope.ship_methods = response.data.data;
        });

        $scope.ok = function (ship_method_type) {

            $scope.pickpack_item.default_shipping_method_id = parseInt($scope.pickpack_item.default_shipping_method_id);
            // Insert waybill no
            datacontext.update_pp_shipping_method($scope.pickpack_item).then(function (httpResult) {
                log_success("Updated Shipping Method !!!");
                // close it
                $modalInstance.close();
            });

        }

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();

(function(){
    'use strict';
    var controllerId = 'manualCubbyUpdateModalCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$modalInstance', '$window', 'manual_cubby', manualCubbyUpdateModalCtrl]);

    function manualCubbyUpdateModalCtrl(common, datacontext, $scope, $modalInstance, $window, manual_cubby) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');

        console.log(manual_cubby);
        $scope.manual_cubby = manual_cubby;
        $scope.manual_cubby_original = manual_cubby.toString().replace("HELD","");
        console.log($scope.manual_cubby_original);

        $scope.update_manual_cubby = function(data){

            console.log(data);
            $scope.manual_cubby_new = data;

            if($scope.manual_cubby_original === $scope.manual_cubby_new){

                datacontext.update_held_manual_cubby({manual_cubby: manual_cubby,manual_cubby_new: $scope.manual_cubby_new}).then(function (httpResult) {
                    log_success("Released held manual cubby " +$scope.manual_cubby);
                    // close it
                    $modalInstance.close();
                });

            }else{
                log_error('Please remove only the string HELD from the manul cubby value');
            }

        }

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();

(function() {
    'use strict';
    var controllerId = 'pickslipCreateModalCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$modalInstance', '$window', 'pick_slip_create', pickslipCreateModalCtrl]);

    function pickslipCreateModalCtrl(common, datacontext, $scope, $modalInstance, $window, pick_slip_create) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        // Pushes input to scope
        $scope.submitted = 0;
        // Set Defaults
        $scope.today = new Date();
        $scope.today_ref = new Date();
        $scope.tomorrow =  new Date( $scope.today_ref.setDate($scope.today_ref.getDate() + 1) ); // $scope.today.add(1, 'days');
        $scope.day_after_tomorrow = new Date( $scope.today_ref.setDate($scope.today_ref.getDate() + 1) );
        $scope.day_after_tomorrow_3 = new Date( $scope.today_ref.setDate($scope.today_ref.getDate() + 1) );
        $scope.day_after_tomorrow_7 = new Date( $scope.today_ref.setDate($scope.today_ref.getDate() + 4) );

        console.log(pick_slip_create.order_id);

        if(angular.isDefined(pick_slip_create.from_order) && pick_slip_create.pick_pack_type_id > 0 && pick_slip_create.order_id > 0){
            $scope.pickpack_slip = {
                pickpack_type_id: pick_slip_create.pick_pack_type_id,
                order_id: pick_slip_create.order_id,
                store_id: pick_slip_create.store_id,
                pickpack_notes:"",
                button_diable:0,
                from_order:1,
                due_today:true,
                due_tom:true,
                due_day_tom:true,
                due_day_tom_3:true,
                due_day_tom_7:true
            };
        }else if(angular.isDefined(pick_slip_create.from_order) && pick_slip_create.pick_pack_type_id > 0){
          $scope.pickpack_slip = {
              pickpack_type_id: pick_slip_create.pick_pack_type_id,
              order_id: pick_slip_create.order_id,
              store_id: pick_slip_create.store_id,
              pickpack_notes:"",
              button_diable:0,
              from_order:1,
              due_today:true
          };
        }else{
          $scope.pickpack_slip = {
              pickpack_type_id:"",
              order_id: 0,
              store_id: 0,
              pickpack_notes:"",
              button_diable:0,
              due_today:true
          };
        }

        $scope.all_pl = function(today) {
          if(today == 1 || today == 2 || today == 3){
            $scope.today = today;
            datacontext.get_pickpack_pending_count_v1({today:today}).then(function(httpResult) {
                $scope.pickpack_types = httpResult.data.data.pick_types;
                $scope.today_cnt_total = httpResult.data.data.today_cnt;
                $scope.cnt_total = httpResult.data.data.count;
                $scope.pickpack_cc_cnt = httpResult.data.CC_CNT;
                $scope.pickpack_onsite_mugs_cnt = httpResult.data.ONSITE_MUGS_CNT;
                $scope.opd_nopl_cnt = httpResult.data.OPD_NOPL_CNT;
                $scope.free_cubby = httpResult.data.FREE_CUBBY;
                $scope.manual_cubby = httpResult.data.MANUAL_CUBBY;
                $scope.pickpack_slip.manual_cubby = httpResult.data.MANUAL_CUBBY;
            });
          }else{
            $scope.today = 0;
            datacontext.get_pickpack_pending_count_v1({today:'0'}).then(function(httpResult) {
                $scope.pickpack_types = httpResult.data.data.pick_types;
                $scope.today_cnt_total = httpResult.data.data.today_cnt;
                $scope.cnt_total = httpResult.data.data.count;
                $scope.pickpack_cc_cnt = httpResult.data.CC_CNT;
                $scope.pickpack_onsite_mugs_cnt = httpResult.data.ONSITE_MUGS_CNT;
                $scope.opd_nopl_cnt = httpResult.data.OPD_NOPL_CNT;
                $scope.free_cubby = httpResult.data.FREE_CUBBY;
                $scope.manual_cubby = httpResult.data.MANUAL_CUBBY;
                $scope.pickpack_slip.manual_cubby = httpResult.data.MANUAL_CUBBY;
            });
          }
        };
        datacontext.get_pickpack_pending_count().then(function(httpResult) {
            $scope.pickpack_types = httpResult.data.data.pick_types;
            $scope.today_cnt_total = httpResult.data.data.today_cnt;
            $scope.cnt_total = httpResult.data.data.count;
            $scope.pickpack_cc_cnt = httpResult.data.CC_CNT;
            $scope.pickpack_onsite_mugs_cnt = httpResult.data.ONSITE_MUGS_CNT;
            $scope.opd_nopl_cnt = httpResult.data.OPD_NOPL_CNT;
            $scope.free_cubby = httpResult.data.FREE_CUBBY;
            $scope.manual_cubby = httpResult.data.MANUAL_CUBBY;
            $scope.pickpack_slip.manual_cubby = httpResult.data.MANUAL_CUBBY;
            $scope.cutoff_order_id = httpResult.data.CUTOFF_ORDER_ID;
        });

        // Create pick slip
        $scope.create_pickslip_submit = function(isValid) {
            $scope.submitted = 1;
            console.log($scope.pickpack_slip);

            if (isValid)
                {
            	 $scope.pickpack_slip.button_diable =1;
                    // Create Vendor Product
                    // console.log($scope);
                    // console.log($scope.pickpack_slip.due_today);
                    // console.log($scope.pickpack_slip.due_tom);
                    if($scope.pickpack_slip.ass_manual_cubby === true && angular.isDefined($scope.manual_cubby) && $scope.pickpack_slip.manual_cubby.length === 0){
                      $scope.pickpack_slip.manual_cubby = $scope.manual_cubby;
                    }
                    console.log($scope.pickpack_slip);
                    if( (angular.isDefined($scope.pickpack_slip.due_today) && $scope.pickpack_slip.due_today === true) || (angular.isDefined($scope.pickpack_slip.due_tom) && angular.isDefined($scope.pickpack_slip.due_tom) === true) || (angular.isDefined($scope.pickpack_slip.due_day_tom) && angular.isDefined($scope.pickpack_slip.due_day_tom) === true)  || (angular.isDefined($scope.pickpack_slip.due_day_tom_3) && angular.isDefined($scope.pickpack_slip.due_day_tom_3) === true) || (angular.isDefined($scope.pickpack_slip.due_day_tom_7) && angular.isDefined($scope.pickpack_slip.due_day_tom_7) === true) ){
                      datacontext.populatePickpackSlipDueToday($scope.pickpack_slip).then(function (httpResult) {
                          $scope.pickpack_slip.pickpack_type_id = httpResult.data;
                          $scope.isCreated = true;

                          // close it
                          $modalInstance.close();
                          $window.scrollTo(0, 0);
                      });
                    }else{
                      datacontext.populatePickpackSlip($scope.pickpack_slip).then(function (httpResult) {
                          $scope.pickpack_slip.pickpack_type_id = httpResult.data;
                          $scope.isCreated = true;

                          // close it
                          $modalInstance.close();
                          $window.scrollTo(0, 0);
                      });
                    }

                }
        };

        // Auto Create pick slip
        $scope.auto_create_pickslip_submit = function(isValid) {
          // console.log($scope.pickpack_slip);
          // console.log("due_today");
          // console.log($scope.pickpack_slip.due_today);
          // console.log("due_tom");
          // console.log($scope.pickpack_slip.due_tom);
            $scope.submitted = 1;
            if (isValid)
                {
            	 $scope.pickpack_slip.button_diable =1;
                    // Create Vendor Product
                    datacontext.autoPopulatePickpackSlip($scope.pickpack_slip).then(function (httpResult) {
                        $scope.pickpack_slip.pickpack_type_id = httpResult.data;
                        $scope.isCreated = true;

                        // close it
                        $modalInstance.close();
                    });
                }
        };

     // stop Auto Create pick slip
        $scope.stop_auto_create_pickslip_submit = function(isValid) {
            $scope.submitted = 1;
            console.log(isValid);

            if (isValid)
                {
            	 $scope.pickpack_slip.button_diable =1;
            	 $scope.pickpack_slip.pickpack_type_id = isValid;
                    // Create Vendor Product
                    datacontext.stopAutoPopulatePickpackSlip($scope.pickpack_slip).then(function (httpResult) {
                        //$scope.pickpack_slip.pickpack_type_id = httpResult.data;
                        $scope.isCreated = true;

                        // close it
                        $modalInstance.close();
                    });
                }
        };


        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();

(function() {
    'use strict';
    var controllerId = 'shipLabelTestCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', shipLabelTestCtrl]);

    function shipLabelTestCtrl(common, datacontext, $scope) {

        var vm = this;
        $scope.result = '';

        activate();

        function activate() {
            var promises = [];
            common.activateController(promises, controllerId)
                .then(function() {
                    // log('Activated Pack List View');
                });
        }

        var shipLabelRequest = {
            "order_id": 12345,
            "order_package_id":54321,
            "ship_to_address_id": 1000,
            "ship_method_id": 1,
            "fulfillment_warehouse_id":2
        };

        $scope.requestLabel = function () {
            datacontext.generateDHLShipLabel(JSON.stringify(shipLabelRequest)).success(function (httpResult) {

                $scope.result = httpResult;
                console.log($scope.result);

            });
        }


    }
})();


(function() {
    'use strict';
    var controllerId = 'pickpackDashboardCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$modal', '$cookies', pickpackDashboardCtrl]);

    function pickpackDashboardCtrl(common, datacontext, $scope, $modal, $cookies) {

        var vm = this;
        vm.waybill_id = "";
        vm.default = 1;
        activate();
        $scope.show_all_tables = function () {
          vm.default = 0;
          activate();
        }
        function activate() {
          if(vm.default === 1){
            var promises = [
                getPendingPick(),
                getPendingPack(),
                get_order_package_items(),
                getPendingWFP(),
                getPendingXeroxPrintPack(),
                get_order_package_aging(),
                get_order_package_aging_v1(),
                get_order_shipments(),
                getPendingPrimeCount(),
                getPendingPrimeCatCount(),
                getWalmartEbay()
            ];
          }else{
            var promises = [
                manual_orders_no_tracking(),
                get_order_package_ship_method(),
                get_empty_locations_cnt(),
                get_last_import_cnt(),
                get_shipby_lastfive(),
                getTodayCnt()
            ];

          }

            //get_premium_orders(), get_pickpack_types(),
            common.activateController(promises, controllerId)
                .then(function() {
                    // log('Activated Pack List View');
                });
        }
        $scope.show_all = function () {
          get_premium_orders();
          get_pickpack_types();
        }

        $scope.all_today_change = function(all_today){
          console.log(vm);
            if(vm.all_today === "1"){
              return datacontext.get_pending_cat_count().then(function(httpResult) {
                  vm.get_pending_prime_cat_count = httpResult.data.data;
                  vm.get_pending_total  = httpResult.data.TOTAL;
                  vm.all_today = "1";
                  console.log(vm.all_today);

              });

            }else if(vm.all_today === "2"){
              return datacontext.get_pending_cat_count_all().then(function(httpResult) {
                  vm.get_pending_prime_cat_count = httpResult.data.data;
                  vm.get_pending_total  = httpResult.data.TOTAL;
                  vm.all_today = "2";
                  console.log(vm.all_today);

              });
            }else if(vm.all_today === "3"){
              return datacontext.get_pending_cat_count_tom().then(function(httpResult) {
                  vm.get_pending_prime_cat_count = httpResult.data.data;
                  vm.get_pending_total  = httpResult.data.TOTAL;
                  vm.all_today = "3";
                  console.log(vm.all_today);

              });
            }else if(vm.all_today === "4"){
              return datacontext.get_pending_cat_count_pl().then(function(httpResult) {
                  vm.get_pending_prime_cat_count = httpResult.data.data;
                  vm.get_pending_total  = httpResult.data.TOTAL;
                  vm.all_today = "4";
                  console.log(vm.all_today);
              });
            }else{
              return datacontext.get_pending_prime_cat_count().then(function(httpResult) {
                  vm.get_pending_prime_cat_count = httpResult.data.data;
                  vm.get_pending_total  = httpResult.data.TOTAL;
                  vm.all_today = all_today;
                  console.log(vm.all_today);
              });
            }

        }

        $scope.change_shipping_method = function(item){
            //console.log(item);
            $scope.pickpack_item = item;
            var modalInstance = $modal.open({
                templateUrl: '/app/pickpack/partials/pickpackShippingModal.html',
                controller:"pickpackShippingModalCtrl",
                windowClass:'small',
                resolve: {
                    pickpackItem: function () {
                        return $scope.pickpack_item;
                    }
                }
            }).result.then(function(){
                get_pickpack_types();
            });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        }

        function get_pickpack_types() {
            return datacontext.get_pickpack_types().then(function(httpResult) {
                vm.pickpack_types = httpResult.data.data;
            });
        }

        function get_premium_orders() {
            return datacontext.get_premium_orders().then(function(httpResult) {
                vm.premium_orders = httpResult.data.data;
                //console.log(vm.premium_orders);
            });
        }


        function get_waybill_num() {
            // get todays fedEx waybill num
            return datacontext.get_waybill_num({}).then(function(httpResult) {

                if(httpResult.data.data === 0){
                    // merge order item w/order items
                    var modalInstance = $modal.open({
                        templateUrl: '/app/pickpack/partials/fedex_waybill.html',
                        controller:"fedexWaybillCtrl",
                        backdrop  : 'static',
                        keyboard  : false,
                        windowClass:'small'
                    }).result.then(function(){
                        get_waybill_num();
                    });

                    vm.cancel = function () {
                        modalInstance.dismiss('cancel');
                    };
                }else{
                    vm.waybill_id = httpResult.data.data;
                }

            });
        }

        function get_order_package_aging() {

            return datacontext.get_order_package_aging().then(function(httpResult) {

                var hResults = httpResult.data.data;

                $scope.orderAging = [];
                $scope.reshipAging = [];
                var cntTotal = 0;
                for ( var i in hResults ) {

                    //console.log(hResults[i].order_package_type_id);

                    if ( hResults[i].order_package_type_id === 1 ) {
                    	cntTotal +=  hResults[i].cnt;
                    	$scope.orderAging.push({"age":hResults[i].age.toString(), "cnt": hResults[i].cnt, "cntTotal": cntTotal});
                    } else {
                      $scope.reshipAging.push({"age":hResults[i].age.toString(), "cnt": hResults[i].cnt});
                    }
                }
                //console.log($scope.reshipAging);
            });

        }

        function get_order_package_aging_v1() {

            return datacontext.get_order_package_aging_v1().then(function(httpResult) {

                var hResults = httpResult;

                $scope.orderAging_pl_v1 = httpResult.data.DATA_PL;
                $scope.orderAging_no_pl_v1 = httpResult.data.DATA_NO_PL;
                vm.get_order_aging_total_pl = httpResult.data.TOTAL_PL;
                vm.get_order_aging_total_no_pl = httpResult.data.TOTAL_NO_PL;
            });

        }
        function manual_orders_no_tracking() {

            return datacontext.manual_orders_no_tracking().then(function(httpResult) {

                var hResults = httpResult.data.data;
                $scope.manual_orders = httpResult.data.data;
            });

        }

        function get_order_package_ship_method() {

            return datacontext.get_order_package_ship_method().then(function(httpResult) {
            	$scope.orderByShipping = httpResult.data.data;
           	 	$scope.orderByShippingTotal = httpResult.data.TOTAL;

            });

        }

        function get_order_shipments() {

            return datacontext.get_order_shipments().then(function(httpResult) {
              //console.log(httpResult.data);
              var total_cnt = 0;
            	$scope.ShippedByHour = httpResult.data.data;
              //d.packed_orders   hour  packed_orders total_cnt

              for (var i in $scope.ShippedByHour) {
                total_cnt = total_cnt + $scope.ShippedByHour[i].packed_orders;
                $scope.ShippedByHour[i].total_cnt = total_cnt;

              }
              $scope.ShippedByHourTotal = httpResult.data.TOTAL1;
              $scope.ShippedByPace = httpResult.data.TOTAL2;
              $scope.ShippedByPrimePace = httpResult.data.TOTAL2PRIME;
              $scope.ShippedByHourAvg = httpResult.data.TOTAL;
              $scope.total_cnt = 0;


            });

        }

        function get_empty_locations_cnt() {

            return datacontext.get_empty_locations_cnt().then(function(httpResult) {

            	 $scope.austinCnt = httpResult.data.AUSTIN_CNT;
            	 $scope.fbaCnt = httpResult.data.FBA_CNT;


            });

        }
        function get_last_import_cnt() {

            return datacontext.get_last_import_cnt().then(function(httpResult) {
              console.log(httpResult.data);
            	 $scope.amz_order_imp_ran = httpResult.data.data.AMZ_ORDER_IMP_RAN;
            	 $scope.order_package_import_ran = httpResult.data.data.ORDER_PACKAGE_IMPORT_RAN;
               console.log($scope.amz_order_imp_ran);
               console.log($scope.order_package_import_ran);
            });

        }
        function get_shipby_lastfive() {

            return datacontext.get_shipby_lastfive().then(function(httpResult) {
              //console.log(httpResult);
            	$scope.shipped_orders = httpResult.data;

            });

        }


        function getPickpackPendingCount() {
            return datacontext.get_pickpack_pending_count().then(function(httpResult) {
                vm.pending_pickslip_count = httpResult.data.data.count;
            });
        }
        function getTodayCnt() {
            return datacontext.get_today_count().then(function(httpResult) {
                $scope.CreatedByHour = httpResult.data.data.TOTAL;
                vm.today_prime = httpResult.data.data.TOTALPRIME;
                vm.today_onsite = httpResult.data.data.TOTALONSITE;
            });
        }
        function getWalmartEbay() {
            return datacontext.get_walmart_ebay().then(function(httpResult) {
              //console.log(httpResult);
                $scope.w_e_orders = httpResult.data.data;
                $scope.w_e_orders_total = httpResult.data.TOTAL;

            });
        }

        function getPendingPrimeCount() {
            return datacontext.get_pending_prime_count().then(function(httpResult) {

                vm.pending_prime_count = httpResult.data.PRIMECNT;
                vm.pending_non_prime_count = httpResult.data.NONPRIMECNT;
                vm.onsiteCnt = httpResult.data.ONSITECNT;
            });

        }
        function getPendingPrimeCatCount() {
        return datacontext.get_pending_cat_count().then(function(httpResult) {
            //console.log("vm.get_pending_prime_cat_count");
            vm.get_pending_prime_cat_count = httpResult.data.data;
            vm.get_pending_total  = httpResult.data.TOTAL;
            console.log(httpResult);
            vm.all_today = "1";
            console.log(vm.all_today);

        });
      }

        function getPendingPick() {
            return datacontext.getPackageStatusCount({order_package_status_id:'2'}).then(function(httpResult) {
                vm.pending_pick_count = httpResult.data.data;
                vm.CUTOFF_ORDER_ID = httpResult.data.CUTOFF_ORDER_ID;
            });
        }

        function getPendingPack() {
            return datacontext.getPackageStatusCount({order_package_status_id:'3'}).then(function(httpResult) {
                vm.pending_pack_count = httpResult.data.data;
            });
        }

        function getPendingEndica() {
            var payload = {
                queryType:"count",
                order_package_status_id:4,
                ship_method_id:"5,10",
                has_tracking_code:0,
                Endica:1
            };
            return datacontext.get_order_packages(payload).then(function(httpResult) {
                vm.pending_endica = httpResult.data.total;
            });
        }

        function getPendingWFP() {
            var payload = {
                queryType:"count",
                order_package_status_id:4
            };
            return datacontext.get_pending_wfp(payload).then(function(httpResult) {
                vm.pending_wfp = httpResult.data.data;
                //console.log(vm.pending_wfp);
            });
        }

        function get_order_package_items() {

            var payload = {
                queryType:"array",
                financial_status_id: "4",
                fulfillment_status_id: "2",
                order_status_id: "1,2",
                shipped_on_start: ""
            };
            return datacontext.get_order_package_items_cnt(payload).then(function(httpResult) {

                vm.shipped = httpResult.data.data[0];
            });
        }

        function getPendingXeroxPrintPack() {
            var payload = {
                queryType:"count",
                pod:"2,3,9"
            };
            return datacontext.get_order_packages_pod(payload).then(function(httpResult) {
              //console.log(httpResult.data);
                vm.XeroxPrintPack = httpResult.data.TOTAL;
                vm.mugsCnt = httpResult.data.MUGSTOTAL;
                vm.canvasCnt = httpResult.data.CANVASTOTAL;

            });
        }
        $scope.suggestion_box = function () {
          $scope.user_id = $cookies.get('user_id');
          var modalInstance = $modal.open({
               templateUrl: '/app/homepage/suggestion_box.html',
               controller: 'suggestionBoxctrl',
               windowClass: 'small',
               resolve: {
                 user_id: function () {
                     return $scope.user_id;
                 }
               }
           }).result.then(function (result) {

           });

           vm.cancel = function () {
               modalInstance.dismiss('cancel');
           };
       };

    }
})();
(function () {
    'use strict';
    var controllerId = 'suggestionBoxctrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modalInstance', 'user_id', suggestionBoxctrl]);

    function suggestionBoxctrl(common, datacontext, $scope, $modalInstance, user_id) {
        var getLogFn = common.logger.getLogFn;
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');
        console.log("user_id:"+user_id);
        var vm = this;
        $scope.ok = function (data) {
          vm.query = {
            user_id: user_id,
            subject: data.subject,
            message: data.message
          };
          return datacontext.suggestion_box(vm.query).then(function (httpResult) {
              // set new data
              log_success("Message sent. Thank you!");
              vm.results = httpResult.data.data;

              $modalInstance.close();
              return httpResult.data.data;
          });


        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();
(function () {
    'use strict';
    var controllerId = 'shippingupdatenewCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$location', '$modalInstance', 'shippingupdate', shippingupdatenewCtrl]);

    function shippingupdatenewCtrl(common, datacontext, $scope, $location,$modalInstance,shippingupdate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        $scope.pickslip_id = shippingupdate;

        var vm = this;
        vm.query = {
        		note:'',
        		ship_method_id: 0,
        		pickslip_id: shippingupdate
            };

        vm.startSearch = 0;
        //vm.pickslip_id = shippingupdate;
        //activate();
        datacontext.get_pickpack_types().then(function(httpResult) {
        	$scope.pickpack_types = httpResult.data.data;
        });

        datacontext.get_ship_methods().then(function (httpResult) {
    		vm.ship_methods = httpResult.data.data;
    		$scope.ship_methods = vm.ship_methods;
    	});

        $scope.update_shipping = function (data,pickslip_id) {
        	console.log(data);
        	vm.query.note = data.note;
        	vm.query.ship_method_id = data.ship_method_id;
        	vm.query.pickslip_id = pickslip_id;
        	console.log(vm.query);
        	datacontext.update_ship_method(vm.query).then(function (httpResult) {
        		vm.ship_methods = httpResult.data.data;
	    		$scope.ship_methods = vm.ship_methods;
	    		$modalInstance.close('cancel');
	    	});
        }

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

    }
})();

( function() {
    'use strict';
    var controllerId = 'printimagenotfoundCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$location', '$modalInstance', 'itemdata', printimagenotfoundCtrl]);

    function printimagenotfoundCtrl(common, datacontext, $scope, $location, $modalInstance, itemdata) {


        console.log(itemdata);

        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        $scope.pickslip_id = itemdata.pickpack_slip_id;

        var vm = this;
        vm.query = {
            note:'',
            pickslip_id: itemdata.pickpack_slip_id,
            pid: itemdata.pid,
            mpid: itemdata.mpid,
        };

        $scope.print_image_missing_send_email = function (data,pickslip_id) {
            console.log(data);
            vm.query.note = data.note;

            vm.query.pickslip_id = pickslip_id;
            console.log(vm.query);
            datacontext.print_image_missing_send_email(vm.query).then(function (httpResult) {

                $modalInstance.close('cancel');
            });
        }

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }

})();

(function () {
    'use strict';
    var controllerId = 'noteupdateCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$location', '$modalInstance', 'noteupdate', noteupdateCtrl]);

    function noteupdateCtrl(common, datacontext, $scope, $location,$modalInstance,noteupdate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        $scope.pickslip_id = noteupdate;

        var vm = this;
        vm.query = {
        		note:'',
        		ship_method_id: 0,
        		pickslip_id: noteupdate
            };

        vm.startSearch = 0;
        //vm.pickslip_id = shippingupdate;
        //activate();


        $scope.update_note = function (data,pickslip_id) {
        	console.log(data);
        	vm.query.note = data.note;

        	vm.query.pickslip_id = pickslip_id;
        	console.log(vm.query);
        	datacontext.update_note(vm.query).then(function (httpResult) {

	    		$modalInstance.close('cancel');
	    	});
        }

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

    }
})();

(function () {
    'use strict';
    var controllerId = 'coverlabelCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$location', '$modalInstance', 'itemData', coverlabelCtrl]);

    function coverlabelCtrl(common, datacontext, $scope, $location,$modalInstance,itemData) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        $scope.itemData = itemData;

        var vm = this;
        $scope.show_can = 0;
        $scope.print_label_can = function(idx) {
            $scope.show_can = 1;
        };
        $scope.print_label = function(idx) {
            $scope.show_can = 0;
        };
        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

    }
})();

(function () {
    'use strict';
    var controllerId = 'pickListCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modal', '$cookies', pickListCtrl]);

    function pickListCtrl(common, datacontext, $scope, $modal, $cookies) {

        var vm = this;
        activate();

        function activate() {
            var promises = [
                get_pickpack_types_defaultship(),
                get_stores()
            ];

            common.activateController(promises, controllerId)
                .then(function() {
                    // log('Activated Pack List View');
                });
        }

        function get_pickpack_types_defaultship() {
            return datacontext.get_pickpack_types_defaultship().then(function(httpResult) {
                vm.pickpack_types = httpResult.data.data;
            });
        }

        function get_stores(){
            return datacontext.get_stores().then(function(httpResult) {
                vm.stores = httpResult.data.data;
            });
        }
    }

})();

(function () {
    'use strict';
    var controllerId = 'skipItemCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modal', '$cookies', 'NgTableParams', skipItemCtrl]);

    function skipItemCtrl(common, datacontext, $scope, $modal, $cookies, NgTableParams) {

        var vm = this;

        vm.query = {
            queryType:'array-count',
            order_by: "mp_ship_latest_by",
            order_dir: "asc",
            page: 1,
            limit: 50
        };

        activate();

        function activate() {
            var promises = [
                get_skip_items_at_pack()
                ,get_missings_items_at_pick()
            ];

            common.activateController(promises, controllerId).then(function() {
                // log('Activated Pack List View');
            });
        }

        function get_skip_items_at_pack() {

            vm.grid = 0;
            vm.tableParams = new NgTableParams({
                count: vm.query.limit
            }, {
                getData: function(params) {
                    vm.query.page = params.page;

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }

                    return datacontext.get_skip_items_at_pack(vm.query).then(function(httpResult) {
                        console.log(httpResult);

                        if(httpResult.data.DATA.no_records === '1'){
                            console.log('4093');
                            vm.get_skip_items.no_records = 1;
                        } else{
                            //vm.get_skip_items.no_records = 0;
                            vm.get_skip_items = httpResult.data.DATA;

                            vm.atts = _.chain(httpResult.data.DATA).groupBy("product_id")
                                        .pairs()
                                        .map(function (currentItem) {
                                            return _.object(_.zip(["product_id", "product_title"], currentItem));
                                        })
                                        .value();

                            vm.get_pack_skip_items = [];

                            for (var i = 0; i < vm.atts.length; i++) {
                                var product_id = vm.atts[i].product_id;
                                var arrlen = vm.atts[i].product_title.length;
                                for (var j = 0; j < vm.atts[i].product_title.length; j++) {
                                    var product_title = vm.atts[i].product_title[j].product_title;
                                }
                                vm.get_pack_skip_items.push({'product_id':product_id,'product_title':product_title,'len':arrlen});
                            }

                            console.log(vm.get_pack_skip_items);   
                        }
                    });
                }
            });
  
        }

        function get_missings_items_at_pick() {

            vm.query = {
                queryType:'array-count',
                order_by: "mp_ship_latest_by",
                order_dir: "asc",
                page: 1,
                limit: 50
            };

            return datacontext.get_missings_items_at_pick(vm.query).then(function (httpResult) {
                vm.get_missing_items = httpResult.data.DATA;
            });
        }

        /*function get_missings_items_at_pick() {

            vm.query = {
                queryType:'array-count',
                order_by: "mp_ship_latest_by",
                order_dir: "asc",
                page: 1,
                limit: 50
            };

            vm.grid = 0;
            vm.tableParams = new NgTableParams({
                count: vm.query.limit
            }, {
                getData: function(params) {
                    vm.query.page = params.page;

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }

                    return datacontext.get_missings_items_at_pick(vm.query).then(function(httpResult) {
                        console.log(httpResult);

                        if(httpResult.data.DATA.no_records === '1'){
                            console.log('4093');
                            vm.get_missing_items.no_records = 1;
                        } else{
                            //vm.get_missing_items.no_records = 0;
                            vm.get_missing_items = httpResult.data.DATA;

                            vm.atts = _.chain(httpResult.data.DATA).groupBy("product_id")
                                        .pairs()
                                        .map(function (currentItem) {
                                            return _.object(_.zip(["product_id", "product_title"], currentItem));
                                        })
                                        .value();

                            vm.get_pick_missing_items = [];

                            for (var i = 0; i < vm.atts.length; i++) {
                                var product_id = vm.atts[i].product_id;
                                var arrlen = vm.atts[i].product_title.length;
                                for (var j = 0; j < vm.atts[i].product_title.length; j++) {
                                    var product_title = vm.atts[i].product_title[j].product_title;
                                }
                                vm.get_pick_missing_items.push({'product_id':product_id,'product_title':product_title,'len':arrlen});
                            }

                            console.log(vm.get_pick_missing_items);   
                        }
                    });
                }
            });

        }*/

    }
})();
